
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5e30"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5e30"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
'use strict';

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $92f4fea5bc247620$export$3ba232387fd5d6dd; }, function (v) { return $92f4fea5bc247620$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$3ba232387fd5d6dd;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
'use strict';
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
function $92f4fea5bc247620$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$3ba232387fd5d6dd = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6sT7C", function(module, exports) {

$parcel$export(module.exports, "generateUuid", function () { return $4b501dab207d1b57$export$1c3aefb711c3a4cc; });
$parcel$export(module.exports, "generateRandomHexString", function () { return $4b501dab207d1b57$export$982a1a45496c7cc9; });
$parcel$export(module.exports, "generateSpanId", function () { return $4b501dab207d1b57$export$295213bc4d0c54ad; });
$parcel$export(module.exports, "generateTraceId", function () { return $4b501dab207d1b57$export$dc6d7ea554bcce10; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");
const $4b501dab207d1b57$var$uuidv4Template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
/**
 * Creates a random single hexadecimal value from a provided random value
 * table and corresponding index. If a random value table is not provided,
 * Math.random will be used to generate the value.
 *
 * @param {Uint8Array} valueTable Random value table typically generated using
 * the built-in crypto engine.
 * @param {int} tableIndex The index of the value table to use for generating
 * the hexadecimal value.
 * @returns {int} single hexadecimal value in decimal format
 */ function $4b501dab207d1b57$var$getRandomValue(valueTable, tableIndex) {
    if (valueTable) /**
     * The value table could have any number value in the given index. Use
     * bitwise AND to ensure the value we generate is a valid hex value.
     * x & 15 will ensure the value converted to hex using `toString(16)`
     * falls within the range of 0 and 15 inclusively.
     */ return valueTable[tableIndex] & 15;
    else return Math.random() * 16 | 0;
}
function $4b501dab207d1b57$export$1c3aefb711c3a4cc() {
    const crypto = (0, $9EKMI.globalScope)?.crypto || (0, $9EKMI.globalScope)?.msCrypto;
    let randomValueTable;
    let randomValueIndex = 0;
    if (crypto && crypto.getRandomValues) // For a UUID, we only need 30 characters since two characters are pre-defined
    // eslint-disable-next-line
    randomValueTable = crypto.getRandomValues(new Uint8Array(30));
    return $4b501dab207d1b57$var$uuidv4Template.split('').map((templateInput)=>{
        if (templateInput === 'x') return $4b501dab207d1b57$var$getRandomValue(randomValueTable, randomValueIndex++).toString(16);
        else if (templateInput === 'y') // this is the uuid variant per spec (8, 9, a, b)
        // % 4, then shift to get values 8-11
        return ($4b501dab207d1b57$var$getRandomValue() & 0x3 | 0x8).toString(16);
        else return templateInput;
    }).join('');
}
function $4b501dab207d1b57$export$982a1a45496c7cc9(length) {
    const crypto = (0, $9EKMI.globalScope)?.crypto || (0, $9EKMI.globalScope)?.msCrypto;
    let randomValueTable;
    let randomValueIndex = 0;
    if (crypto && crypto.getRandomValues) // eslint-disable-next-line
    randomValueTable = crypto.getRandomValues(new Uint8Array(length));
    const chars = [];
    for(var i = 0; i < length; i++)chars.push($4b501dab207d1b57$var$getRandomValue(randomValueTable, randomValueIndex++).toString(16));
    return chars.join('');
}
function $4b501dab207d1b57$export$295213bc4d0c54ad() {
    return $4b501dab207d1b57$export$982a1a45496c7cc9(16);
}
function $4b501dab207d1b57$export$dc6d7ea554bcce10() {
    return $4b501dab207d1b57$export$982a1a45496c7cc9(32);
}

});
parcelRegister("9EKMI", function(module, exports) {

$parcel$export(module.exports, "isBrowserScope", function () { return $707c23f7fa152c1a$export$56e2f6ad7d1fee79; });
$parcel$export(module.exports, "isWorkerScope", function () { return $707c23f7fa152c1a$export$39ae47e3e1e98d0c; });
$parcel$export(module.exports, "globalScope", function () { return $707c23f7fa152c1a$export$af1bbc55aad4f91e; });
$parcel$export(module.exports, "initiallyHidden", function () { return $707c23f7fa152c1a$export$866f094fde23c8c3; });
$parcel$export(module.exports, "initialLocation", function () { return $707c23f7fa152c1a$export$7514830a2958fa8a; });
$parcel$export(module.exports, "isiOS", function () { return $707c23f7fa152c1a$export$86c1a3f9ab33da5c; });
$parcel$export(module.exports, "iOSBelow16", function () { return $707c23f7fa152c1a$export$1ba445f0e41d6834; });
$parcel$export(module.exports, "ffVersion", function () { return $707c23f7fa152c1a$export$1f6138f94c32affb; });
$parcel$export(module.exports, "originTime", function () { return $707c23f7fa152c1a$export$ae4260dd33347e46; });
$parcel$export(module.exports, "getNavigationEntry", function () { return $707c23f7fa152c1a$export$6431553786c94949; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Contains constants about the environment the agent is running
 * within. These values are derived at the time the agent is first loaded.
 * @copyright 2023 New Relic Corporation. All rights reserved.
 * @license Apache-2.0
 */ 
var $1Z3KE = parcelRequire("1Z3KE");
const $707c23f7fa152c1a$export$56e2f6ad7d1fee79 = typeof window !== 'undefined' && !!window.document;
const $707c23f7fa152c1a$export$39ae47e3e1e98d0c = typeof WorkerGlobalScope !== 'undefined' && (typeof self !== 'undefined' && self instanceof WorkerGlobalScope && self.navigator instanceof WorkerNavigator || typeof globalThis !== 'undefined' && globalThis instanceof WorkerGlobalScope && globalThis.navigator instanceof WorkerNavigator);
const $707c23f7fa152c1a$export$af1bbc55aad4f91e = $707c23f7fa152c1a$export$56e2f6ad7d1fee79 ? window : typeof WorkerGlobalScope !== 'undefined' && (typeof self !== 'undefined' && self instanceof WorkerGlobalScope && self || typeof globalThis !== 'undefined' && globalThis instanceof WorkerGlobalScope && globalThis);
const $707c23f7fa152c1a$export$ead6f00ff694faa7 = $707c23f7fa152c1a$export$af1bbc55aad4f91e?.document?.readyState === 'complete';
const $707c23f7fa152c1a$export$866f094fde23c8c3 = Boolean($707c23f7fa152c1a$export$af1bbc55aad4f91e?.document?.visibilityState === 'hidden');
const $707c23f7fa152c1a$export$7514830a2958fa8a = '' + $707c23f7fa152c1a$export$af1bbc55aad4f91e?.location;
const $707c23f7fa152c1a$export$86c1a3f9ab33da5c = /iPad|iPhone|iPod/.test($707c23f7fa152c1a$export$af1bbc55aad4f91e.navigator?.userAgent);
const $707c23f7fa152c1a$export$1ba445f0e41d6834 = $707c23f7fa152c1a$export$86c1a3f9ab33da5c && typeof SharedWorker === 'undefined';
const $707c23f7fa152c1a$export$1f6138f94c32affb = (()=>{
    const match = $707c23f7fa152c1a$export$af1bbc55aad4f91e.navigator?.userAgent?.match(/Firefox[/\s](\d+\.\d+)/);
    if (Array.isArray(match) && match.length >= 2) return +match[1];
    return 0;
})();
const $707c23f7fa152c1a$export$ae4260dd33347e46 = Date.now() - (0, $1Z3KE.now)();
const $707c23f7fa152c1a$export$6431553786c94949 = ()=>{
    const navigationEntry = $707c23f7fa152c1a$export$af1bbc55aad4f91e?.performance?.getEntriesByType?.('navigation')?.[0];
    if (navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < $707c23f7fa152c1a$export$af1bbc55aad4f91e.performance.now()) return navigationEntry;
};

});
parcelRegister("1Z3KE", function(module, exports) {

$parcel$export(module.exports, "now", function () { return $171e65ea877f8542$export$461939dd4422153; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // This is our own layer around performance.now. It's not strictly necessary, but we keep it in case of future mod-ing of the value for refactor purpose.
function $171e65ea877f8542$export$461939dd4422153() {
    return Math.floor(performance.now());
}

});



parcelRegister("jkuUu", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $e127dcb3052ad46f$export$c106dd0671a0fc2d; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $klTus = parcelRequire("klTus");
function $e127dcb3052ad46f$export$c106dd0671a0fc2d(code, secondary) {
    if (typeof console.debug !== 'function') return;
    console.debug("New Relic Warning: https://github.com/newrelic/newrelic-browser-agent/blob/main/docs/warning-codes.md#".concat(code), secondary);
    (0, $klTus.dispatchGlobalEvent)({
        drained: null,
        type: 'data',
        name: 'warn',
        feature: 'warn',
        data: {
            code: code,
            secondary: secondary
        }
    });
}

});
parcelRegister("klTus", function(module, exports) {

$parcel$export(module.exports, "dispatchGlobalEvent", function () { return $ed10d001794673ae$export$fef770714ecf9cef; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");
const $ed10d001794673ae$var$GLOBAL_EVENT_NAMESPACE = 'newrelic';
function $ed10d001794673ae$export$fef770714ecf9cef(detail = {}) {
    try {
        (0, $9EKMI.globalScope).dispatchEvent(new CustomEvent($ed10d001794673ae$var$GLOBAL_EVENT_NAMESPACE, {
            detail: detail
        }));
    } catch (err) {
    // something happened... dispatchEvent or CustomEvent might not be supported
    // decide what to do about it here
    }
}

});


parcelRegister("4uE6N", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $34591380264f2e91$export$82e9f45cca5ba907; });
$parcel$export(module.exports, "spaPrefix", function () { return $34591380264f2e91$export$20477cedef6a6e70; });
$parcel$export(module.exports, "ADD_PAGE_ACTION", function () { return $34591380264f2e91$export$228b7cc1a6cf9275; });
$parcel$export(module.exports, "ADD_TO_TRACE", function () { return $34591380264f2e91$export$abd27fe9c52e263f; });
$parcel$export(module.exports, "ADD_RELEASE", function () { return $34591380264f2e91$export$2bdfac268df97e49; });
$parcel$export(module.exports, "FINISHED", function () { return $34591380264f2e91$export$4aae4ec5dcea8b65; });
$parcel$export(module.exports, "INTERACTION", function () { return $34591380264f2e91$export$cb531fa34a77fd0d; });
$parcel$export(module.exports, "LOG", function () { return $34591380264f2e91$export$5bfbc7f735892ffd; });
$parcel$export(module.exports, "NOTICE_ERROR", function () { return $34591380264f2e91$export$5f1a082cb0cb6b75; });
$parcel$export(module.exports, "PAUSE_REPLAY", function () { return $34591380264f2e91$export$b472a0cc6d20eaad; });
$parcel$export(module.exports, "RECORD_CUSTOM_EVENT", function () { return $34591380264f2e91$export$3aa3a9aaecdf0aeb; });
$parcel$export(module.exports, "RECORD_REPLAY", function () { return $34591380264f2e91$export$403c2c926e202a7b; });
$parcel$export(module.exports, "REGISTER", function () { return $34591380264f2e91$export$51e82cdd7353a0e1; });
$parcel$export(module.exports, "SET_APPLICATION_VERSION", function () { return $34591380264f2e91$export$676bac23273c34ff; });
$parcel$export(module.exports, "SET_CURRENT_ROUTE_NAME", function () { return $34591380264f2e91$export$ea81bad49e70ac48; });
$parcel$export(module.exports, "SET_CUSTOM_ATTRIBUTE", function () { return $34591380264f2e91$export$4f7e17a9ce5fd265; });
$parcel$export(module.exports, "SET_ERROR_HANDLER", function () { return $34591380264f2e91$export$da4c6f7d34422d9d; });
$parcel$export(module.exports, "SET_PAGE_VIEW_NAME", function () { return $34591380264f2e91$export$de869bc75474e4b2; });
$parcel$export(module.exports, "SET_USER_ID", function () { return $34591380264f2e91$export$68ebab714bd8b8f6; });
$parcel$export(module.exports, "START", function () { return $34591380264f2e91$export$21c466265830bc3a; });
$parcel$export(module.exports, "WRAP_LOGGER", function () { return $34591380264f2e91$export$641930966450a463; });
$parcel$export(module.exports, "MEASURE", function () { return $34591380264f2e91$export$20471946a1148a1b; });
$parcel$export(module.exports, "CONSENT", function () { return $34591380264f2e91$export$28dfad19df746b0d; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ const $34591380264f2e91$export$82e9f45cca5ba907 = 'api-';
const $34591380264f2e91$export$20477cedef6a6e70 = $34591380264f2e91$export$82e9f45cca5ba907 + 'ixn-';
const $34591380264f2e91$export$228b7cc1a6cf9275 = 'addPageAction';
const $34591380264f2e91$export$abd27fe9c52e263f = 'addToTrace';
const $34591380264f2e91$export$2bdfac268df97e49 = 'addRelease';
const $34591380264f2e91$export$4aae4ec5dcea8b65 = 'finished';
const $34591380264f2e91$export$cb531fa34a77fd0d = 'interaction';
const $34591380264f2e91$export$5bfbc7f735892ffd = 'log';
const $34591380264f2e91$export$5f1a082cb0cb6b75 = 'noticeError';
const $34591380264f2e91$export$b472a0cc6d20eaad = 'pauseReplay';
const $34591380264f2e91$export$3aa3a9aaecdf0aeb = 'recordCustomEvent';
const $34591380264f2e91$export$403c2c926e202a7b = 'recordReplay';
const $34591380264f2e91$export$51e82cdd7353a0e1 = 'register';
const $34591380264f2e91$export$676bac23273c34ff = 'setApplicationVersion';
const $34591380264f2e91$export$ea81bad49e70ac48 = 'setCurrentRouteName';
const $34591380264f2e91$export$4f7e17a9ce5fd265 = 'setCustomAttribute';
const $34591380264f2e91$export$da4c6f7d34422d9d = 'setErrorHandler';
const $34591380264f2e91$export$de869bc75474e4b2 = 'setPageViewName';
const $34591380264f2e91$export$68ebab714bd8b8f6 = 'setUserId';
const $34591380264f2e91$export$21c466265830bc3a = 'start';
const $34591380264f2e91$export$641930966450a463 = 'wrapLogger';
const $34591380264f2e91$export$20471946a1148a1b = 'measure';
const $34591380264f2e91$export$28dfad19df746b0d = 'consent';

});

parcelRegister("3R40a", function(module, exports) {

$parcel$export(module.exports, "EVENTS", function () { return $2ce96cfc997e573d$export$fa3d5b535a2458a1; });
$parcel$export(module.exports, "JSERRORS", function () { return $2ce96cfc997e573d$export$88a0cc809b8a547; });
$parcel$export(module.exports, "BLOBS", function () { return $2ce96cfc997e573d$export$ccc565122bb51b3e; });
$parcel$export(module.exports, "RUM", function () { return $2ce96cfc997e573d$export$c120be1e2e4e8ccc; });
$parcel$export(module.exports, "LOGS", function () { return $2ce96cfc997e573d$export$eaf0d0afcde1b12; });
$parcel$export(module.exports, "FEATURE_NAMES", function () { return $2ce96cfc997e573d$export$c0c87f9b303f52ae; });
$parcel$export(module.exports, "featurePriority", function () { return $2ce96cfc997e573d$export$98ea4d704b48d56b; });
$parcel$export(module.exports, "FEATURE_TO_ENDPOINT", function () { return $2ce96cfc997e573d$export$e19c6fc5e2dc3c29; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // To reduce build size a bit:
const $2ce96cfc997e573d$export$fa3d5b535a2458a1 = 'events';
const $2ce96cfc997e573d$export$88a0cc809b8a547 = 'jserrors';
const $2ce96cfc997e573d$export$ccc565122bb51b3e = 'browser/blobs';
const $2ce96cfc997e573d$export$c120be1e2e4e8ccc = 'rum';
const $2ce96cfc997e573d$export$eaf0d0afcde1b12 = 'browser/logs';
const $2ce96cfc997e573d$export$c0c87f9b303f52ae = {
    ajax: 'ajax',
    genericEvents: 'generic_events',
    jserrors: $2ce96cfc997e573d$export$88a0cc809b8a547,
    logging: 'logging',
    metrics: 'metrics',
    /**
   * @deprecated This feature has been replaced by Generic Events. Use/Import `GenericEvents` instead. This wrapper will be removed in a future release
   */ pageAction: 'page_action',
    pageViewEvent: 'page_view_event',
    pageViewTiming: 'page_view_timing',
    sessionReplay: 'session_replay',
    sessionTrace: 'session_trace',
    softNav: 'soft_navigations'
};
const $2ce96cfc997e573d$export$98ea4d704b48d56b = {
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.pageViewEvent]: 1,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.pageViewTiming]: 2,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.metrics]: 3,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.jserrors]: 4,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.softNav]: 5,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.ajax]: 6,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.sessionTrace]: 7,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.sessionReplay]: 8,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.logging]: 9,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.genericEvents]: 10
};
const $2ce96cfc997e573d$export$e19c6fc5e2dc3c29 = {
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.pageViewEvent]: $2ce96cfc997e573d$export$c120be1e2e4e8ccc,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.pageViewTiming]: $2ce96cfc997e573d$export$fa3d5b535a2458a1,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.ajax]: $2ce96cfc997e573d$export$fa3d5b535a2458a1,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.softNav]: $2ce96cfc997e573d$export$fa3d5b535a2458a1,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.metrics]: $2ce96cfc997e573d$export$88a0cc809b8a547,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.jserrors]: $2ce96cfc997e573d$export$88a0cc809b8a547,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.sessionTrace]: $2ce96cfc997e573d$export$ccc565122bb51b3e,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.sessionReplay]: $2ce96cfc997e573d$export$ccc565122bb51b3e,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.logging]: $2ce96cfc997e573d$export$eaf0d0afcde1b12,
    [$2ce96cfc997e573d$export$c0c87f9b303f52ae.genericEvents]: 'ins'
};

});

parcelRegister("8ncaL", function(module, exports) {

$parcel$export(module.exports, "configure", function () { return $6189e9ec0b1bc31e$export$8d21e34596265fa2; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $dwqbe = parcelRequire("dwqbe");

var $juL0p = parcelRequire("juL0p");

var $4RLGm = parcelRequire("4RLGm");

var $8Xnbq = parcelRequire("8Xnbq");

var $8uCIQ = parcelRequire("8uCIQ");

var $9EKMI = parcelRequire("9EKMI");

var $6AoZt = parcelRequire("6AoZt");

var $im7dd = parcelRequire("im7dd");

var $klTus = parcelRequire("klTus");

var $5HzeA = parcelRequire("5HzeA");
function $6189e9ec0b1bc31e$export$8d21e34596265fa2(agent, opts = {}, loaderType, forceDrain) {
    // eslint-disable-next-line camelcase
    let { init: init, info: info, loader_config: loader_config, runtime: runtime = {}, exposed: exposed = true } = opts;
    if (!info) {
        const nr = (0, $juL0p.gosCDN)();
        init = nr.init;
        info = nr.info;
        // eslint-disable-next-line camelcase
        loader_config = nr.loader_config;
    }
    agent.init = (0, $8Xnbq.mergeInit)(init || {});
    // eslint-disable-next-line camelcase
    agent.loader_config = (0, $5HzeA.mergeLoaderConfig)(loader_config || {});
    info.jsAttributes ??= {};
    if (0, $9EKMI.isWorkerScope) // add a default attr to all worker payloads
    info.jsAttributes.isWorker = true;
    agent.info = (0, $4RLGm.mergeInfo)(info);
    const updatedInit = agent.init;
    agent.runtime ??= (0, $8uCIQ.mergeRuntime)(runtime);
    // Apply proxy settings whenever configure is called (supports late {init} setting)
    if (updatedInit.proxy.assets) (0, $6AoZt.redefinePublicPath)(updatedInit.proxy.assets);
    if (!agent.runtime.configured) {
        Object.defineProperty(agent, 'beacons', {
            get () {
                return [
                    agent.info.beacon,
                    agent.info.errorBeacon,
                    agent.init.proxy.assets,
                    agent.init.proxy.beacon
                ].filter(Boolean);
            }
        });
        Object.defineProperty(agent.runtime, 'denyList', {
            get () {
                // Compute the internal traffic list fresh each time to ensure beacons array is current
                return [
                    ...agent.init.ajax.deny_list || [],
                    ...agent.init.ajax.block_internal ? agent.beacons : []
                ];
            }
        });
        agent.runtime.ptid = agent.agentIdentifier;
        (0, $dwqbe.setTopLevelCallers)(agent); // no need to set global APIs on newrelic obj more than once
        agent.runtime.loaderType = loaderType;
        agent.ee = (0, $im7dd.ee).get(agent.agentIdentifier);
        agent.exposed = exposed;
        (0, $klTus.dispatchGlobalEvent)({
            drained: !!agent.runtime.activatedFeatures,
            type: 'lifecycle',
            name: 'initialize',
            feature: undefined,
            data: agent.config
        });
        agent.runtime.configured = true;
    }
}

});
parcelRegister("dwqbe", function(module, exports) {

$parcel$export(module.exports, "setTopLevelCallers", function () { return $9d829256d8cd1736$export$b72f9dadc5bb63c9; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $juL0p = parcelRequire("juL0p");

var $8e4CA = parcelRequire("8e4CA");
function $9d829256d8cd1736$export$b72f9dadc5bb63c9(agentRef) {
    const nr = (0, $juL0p.gosCDN)();
    Object.getOwnPropertyNames((0, $8e4CA.ApiBase).prototype).forEach((fnName)=>{
        const origFn = (0, $8e4CA.ApiBase).prototype[fnName];
        if (typeof origFn !== 'function' || origFn === 'constructor') return;
        /** if the method already exists on the top and we are allowed to -- we can call it multiple times */ let origNrFn = nr[fnName];
        if (!agentRef[fnName] || agentRef.exposed === false || agentRef.runtime?.loaderType === 'micro-agent') return; // dont set the top level callers if we are not allowed to
        nr[fnName] = (...args)=>{
            const thisAgentFnResult = agentRef[fnName](...args);
            if (!origNrFn) return thisAgentFnResult;
            return origNrFn(...args); // if origFn is defined, we want to return the value from that call (ie the first agent that was set)
        };
    });
}

});
parcelRegister("juL0p", function(module, exports) {

$parcel$export(module.exports, "defaults", function () { return $e3154803a411aba8$export$ebe90cb607ad99e; });
$parcel$export(module.exports, "gosNREUM", function () { return $e3154803a411aba8$export$cb9c95fcb8bba936; });
$parcel$export(module.exports, "gosNREUMOriginals", function () { return $e3154803a411aba8$export$e35b4d175345df5c; });
$parcel$export(module.exports, "setNREUMInitializedAgent", function () { return $e3154803a411aba8$export$276f0697a3485aab; });
$parcel$export(module.exports, "gosCDN", function () { return $e3154803a411aba8$export$e270a60105a3ba68; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");

var $1Z3KE = parcelRequire("1Z3KE");

var $jkuUu = parcelRequire("jkuUu");

var $7QTAt = parcelRequire("7QTAt");
const $e3154803a411aba8$export$ebe90cb607ad99e = {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net'
};
function $e3154803a411aba8$export$cb9c95fcb8bba936() {
    if (!(0, $9EKMI.globalScope).NREUM) (0, $9EKMI.globalScope).NREUM = {};
    if (typeof (0, $9EKMI.globalScope).newrelic === 'undefined') (0, $9EKMI.globalScope).newrelic = (0, $9EKMI.globalScope).NREUM;
    return (0, $9EKMI.globalScope).NREUM;
}
function $e3154803a411aba8$export$97ac8a4694ec9c4e() {
    let nr = $e3154803a411aba8$export$cb9c95fcb8bba936();
    const externallySupplied = nr.info || {};
    nr.info = {
        beacon: $e3154803a411aba8$export$ebe90cb607ad99e.beacon,
        errorBeacon: $e3154803a411aba8$export$ebe90cb607ad99e.errorBeacon,
        ...externallySupplied
    };
    return nr;
}
function $e3154803a411aba8$export$4a23f90cd185fa0f() {
    let nr = $e3154803a411aba8$export$cb9c95fcb8bba936();
    const externallySupplied = nr.loader_config || {};
    nr.loader_config = {
        ...externallySupplied
    };
    return nr;
}
function $e3154803a411aba8$export$845dbb0c6d402e02() {
    let nr = $e3154803a411aba8$export$cb9c95fcb8bba936();
    const externallySupplied = nr.init || {};
    nr.init = {
        ...externallySupplied
    };
    return nr;
}
function $e3154803a411aba8$export$e35b4d175345df5c() {
    let nr = $e3154803a411aba8$export$cb9c95fcb8bba936();
    if (!nr.o) {
        nr.o = {
            ST: (0, $9EKMI.globalScope).setTimeout,
            SI: (0, $9EKMI.globalScope).setImmediate || (0, $9EKMI.globalScope).setInterval,
            CT: (0, $9EKMI.globalScope).clearTimeout,
            XHR: (0, $9EKMI.globalScope).XMLHttpRequest,
            REQ: (0, $9EKMI.globalScope).Request,
            EV: (0, $9EKMI.globalScope).Event,
            PR: (0, $9EKMI.globalScope).Promise,
            MO: (0, $9EKMI.globalScope).MutationObserver,
            // this'll be undefined if not in a web window
            FETCH: (0, $9EKMI.globalScope).fetch,
            WS: (0, $9EKMI.globalScope).WebSocket
        };
        (0, $7QTAt.isNative)(...Object.values(nr.o)); // Warns if the originals are not native, which is typically required for the agent to work properly
    }
    return nr;
}
function $e3154803a411aba8$export$276f0697a3485aab(id, newAgentInstance) {
    let nr = $e3154803a411aba8$export$cb9c95fcb8bba936();
    nr.initializedAgents ??= {};
    newAgentInstance.initializedAt = {
        ms: (0, $1Z3KE.now)(),
        date: new Date()
    };
    nr.initializedAgents[id] = newAgentInstance;
    // Warn if using more than one agent, but only once per agent load
    if (Object.keys(nr.initializedAgents).length === 2) (0, $jkuUu.warn)(69);
}
function $e3154803a411aba8$export$9a4e224aaad6a94a(id) {
    let nr = $e3154803a411aba8$export$cb9c95fcb8bba936();
    return nr.initializedAgents?.[id];
}
function $e3154803a411aba8$export$78bd502a6e8b6ea7(fnName, fn) {
    let nr = $e3154803a411aba8$export$cb9c95fcb8bba936();
    nr[fnName] = fn;
}
function $e3154803a411aba8$export$9e01407657d4a7c4() {
    const nr = $e3154803a411aba8$export$cb9c95fcb8bba936();
    nr.initialized = true;
}
function $e3154803a411aba8$export$e270a60105a3ba68() {
    $e3154803a411aba8$export$97ac8a4694ec9c4e();
    $e3154803a411aba8$export$845dbb0c6d402e02();
    $e3154803a411aba8$export$e35b4d175345df5c();
    $e3154803a411aba8$export$4a23f90cd185fa0f();
    return $e3154803a411aba8$export$cb9c95fcb8bba936();
}

});
parcelRegister("7QTAt", function(module, exports) {

$parcel$export(module.exports, "isNative", function () { return $5b78822fe68cc46c$export$43ab85c863381e0; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jkuUu = parcelRequire("jkuUu");
const $5b78822fe68cc46c$var$checked = new Map();
function $5b78822fe68cc46c$export$43ab85c863381e0(...fns) {
    return fns.every((fn)=>{
        if ($5b78822fe68cc46c$var$checked.has(fn)) return $5b78822fe68cc46c$var$checked.get(fn);
        const fnString = typeof fn === 'function' ? fn.toString() : '';
        const isNative = fnString.includes('[native code]');
        const isNr = fnString.includes('nrWrapper');
        if (!isNative && !isNr) (0, $jkuUu.warn)(64, fn?.name || fnString);
        $5b78822fe68cc46c$var$checked.set(fn, isNative);
        return isNative;
    });
}

});


parcelRegister("8e4CA", function(module, exports) {

$parcel$export(module.exports, "ApiBase", function () { return $5fd337389f3821f5$export$4e7c329e089d8cc5; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jkuUu = parcelRequire("jkuUu");

var $4uE6N = parcelRequire("4uE6N");
class $5fd337389f3821f5$export$4e7c329e089d8cc5 {
    #callMethod(methodName, ...args) {
        if (this[methodName] === $5fd337389f3821f5$export$4e7c329e089d8cc5.prototype[methodName]) (0, $jkuUu.warn)(35, methodName);
        else return this[methodName](...args);
    }
    // MicroAgent class custom defines its own start
    /**
   * Reports a browser PageAction event along with a name and optional attributes.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/addpageaction/}
   * @param {string} name Name or category of the action. Reported as the actionName attribute.
   * @param {object} [attributes] JSON object with one or more key/value pairs. For example: {key:"value"}. The key is reported as its own PageAction attribute with the specified values.
   */ addPageAction(name, attributes) {
        return this.#callMethod((0, $4uE6N.ADD_PAGE_ACTION), name, attributes);
    }
    /**
   * @experimental
   * IMPORTANT: This feature is being developed for use internally and is not in a public-facing production-ready state.
   * It is not recommended for use in production environments and will not receive support for issues.
   *
   * Registers an external caller to report through the base agent to a different target than the base agent.
   * @param {import('./api/register-api-types').RegisterAPIConstructor} target the target object to report data to
  @returns {import('./api/register-api-types').RegisterAPI} Returns an object that contains the available API methods and configurations to use with the external caller. See loaders/api/api.js for more information.
   */ register(target) {
        return this.#callMethod((0, $4uE6N.REGISTER), target);
    }
    /**
   * Records a custom event with a specified eventType and attributes.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/recordCustomEvent/}
   * @param {string} eventType The eventType to store the event as.
   * @param {Object} [attributes] JSON object with one or more key/value pairs. For example: {key:"value"}.
   */ recordCustomEvent(eventType, attributes) {
        return this.#callMethod((0, $4uE6N.RECORD_CUSTOM_EVENT), eventType, attributes);
    }
    /**
   * Groups page views to help URL structure or to capture the URL's routing information.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/setpageviewname/}
   * @param {string} name The page name you want to use. Use alphanumeric characters.
   * @param {string} [host] Default is http://custom.transaction. Typically set host to your site's domain URI.
   */ setPageViewName(name, host) {
        return this.#callMethod((0, $4uE6N.SET_PAGE_VIEW_NAME), name, host);
    }
    /**
   * Adds a user-defined attribute name and value to subsequent events on the page.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/setcustomattribute/}
   * @param {string} name Name of the attribute. Appears as column in the PageView event. It will also appear as a column in the PageAction event if you are using it.
   * @param {string|number|boolean|null} value Value of the attribute. Appears as the value in the named attribute column in the PageView event. It will appear as a column in the PageAction event if you are using it. Custom attribute values cannot be complex objects, only simple types such as Strings, Integers and Booleans. Passing a null value unsets any existing attribute of the same name.
   * @param {boolean} [persist] Default false. If set to true, the name-value pair will also be set into the browser's storage API. Then on the following instrumented pages that load within the same session, the pair will be re-applied as a custom attribute.
   */ setCustomAttribute(name, value, persist) {
        return this.#callMethod((0, $4uE6N.SET_CUSTOM_ATTRIBUTE), name, value, persist);
    }
    /**
   * Identifies a browser error without disrupting your app's operations.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/noticeerror/}
   * @param {Error|string} error Provide a meaningful error message that you can use when analyzing data on browser's JavaScript errors page.
   * @param {object} [customAttributes] An object containing name/value pairs representing custom attributes.
   */ noticeError(error, customAttributes) {
        return this.#callMethod((0, $4uE6N.NOTICE_ERROR), error, customAttributes);
    }
    /**
   * Adds a user-defined identifier string to subsequent events on the page.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/setuserid/}
   * @param {string|null} value A string identifier for the end-user, useful for tying all browser events to specific users. The value parameter does not have to be unique. If IDs should be unique, the caller is responsible for that validation. Passing a null value unsets any existing user ID.
   * @param {boolean} [resetSession=false] Optional param. When true, resets the current session ONLY when changing user id from an existing value to another value or null. If the current user id is null when calling the API, the session cannot be reset.
   */ setUserId(value, resetSession = false) {
        return this.#callMethod((0, $4uE6N.SET_USER_ID), value, resetSession);
    }
    /**
   * Adds a user-defined application version string to subsequent events on the page.
   * This decorates all payloads with an attribute of `application.version` which is queryable in NR1.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/setapplicationversion/}
   * @param {string|null} value A string identifier for the application version, useful for
   * tying all browser events to a specific release tag. The value parameter does not
   * have to be unique. Passing a null value unsets any existing value.
   */ setApplicationVersion(value) {
        return this.#callMethod((0, $4uE6N.SET_APPLICATION_VERSION), value);
    }
    /**
   * Allows selective ignoring and grouping of known errors that the browser agent captures.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/seterrorhandler/}
   * @param {(error: Error|string) => boolean | { group: string }} callback When an error occurs, the callback is called with the error object as a parameter. The callback will be called with each error, so it is not specific to one error.
   */ setErrorHandler(callback) {
        return this.#callMethod((0, $4uE6N.SET_ERROR_HANDLER), callback);
    }
    /**
   * Adds a unique name and ID to identify releases with multiple JavaScript bundles on the same page.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/addrelease/}
   * @param {string} name A short description of the component; for example, the name of a project, application, file, or library.
   * @param {string} id The ID or version of this release; for example, a version number, build number from your CI environment, GitHub SHA, GUID, or a hash of the contents.
   */ addRelease(name, id) {
        return this.#callMethod((0, $4uE6N.ADD_RELEASE), name, id);
    }
    /**
   * Capture a single log.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/log/}
   * @param {string} message String to be captured as log message
   * @param {{customAttributes?: object, level?: 'ERROR'|'TRACE'|'DEBUG'|'INFO'|'WARN'}} [options] customAttributes defaults to `{}` if not assigned, level defaults to `info` if not assigned.
  */ log(message, options) {
        return this.#callMethod((0, $4uE6N.LOG), message, options);
    }
    /**
   * Starts any and all features that are not running yet in "autoStart" mode
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/start/}
   */ start() {
        return this.#callMethod((0, $4uE6N.START));
    }
    /**
   * Records an additional time point as "finished" in a session trace and adds a page action.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/finished/}
   * @param {number} [timeStamp] integer (UNIX time) - Defaults to the current time of the call. If used, this marks the time that the page is "finished" according to your own criteria.
   */ finished(timeStamp) {
        return this.#callMethod((0, $4uE6N.FINISHED), timeStamp);
    }
    /**
   * Forces a replay to record. If a replay is already actively recording, this call will be ignored.
   * If a recording has not been started, a new one will be created. If a recording has been started, but is currently not recording, it will resume recording.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/recordReplay/}
   */ recordReplay() {
        return this.#callMethod((0, $4uE6N.RECORD_REPLAY));
    }
    /**
   * Forces an active replay to pause recording.  If a replay is already actively recording, this call will cause the recording to pause.
   * If a recording is not currently recording, this call will be ignored.  This API will pause both manual and automatic replays that are in progress.
   * The only way to resume recording after manually pausing a replay is to manually record again using the recordReplay() API.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/pauseReplay/}
   */ pauseReplay() {
        return this.#callMethod((0, $4uE6N.PAUSE_REPLAY));
    }
    /**
   * Adds a JavaScript object with a custom name, start time, etc. to an in-progress session trace.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/addtotrace/}
   * @param {{name: string, start: number, end?: number, origin?: string, type?: string}} customAttributes Supply a JavaScript object with these required and optional name/value pairs:
   *
   * - Required name/value pairs: name, start
   * - Optional name/value pairs: end, origin, type
   * - Note: Does not apply to MicroAgent
   *
   * If you are sending the same event object to New Relic as a PageAction, omit the TYPE attribute. (type is a string to describe what type of event you are marking inside of a session trace.) If included, it will override the event type and cause the PageAction event to be sent incorrectly. Instead, use the name attribute for event information.
   */ addToTrace(customAttributes) {
        return this.#callMethod((0, $4uE6N.ADD_TO_TRACE), customAttributes);
    }
    /**
   * Gives SPA routes more accurate names than default names. Monitors specific routes rather than by default grouping.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/setcurrentroutename/}
   * @param {string} name Current route name for the page.
   *  - Note: Does not apply to MicroAgent
   */ setCurrentRouteName(name) {
        return this.#callMethod((0, $4uE6N.SET_CURRENT_ROUTE_NAME), name);
    }
    /**
   * Returns a new API object that is bound to the current SPA interaction.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/interaction/}
   * @param {Object} [opts] Options to configure the new or existing interaction with
   * @param {boolean} [opts.waitForEnd=false] To forcibly keep the interaction open until the `.end` method is called on its handle, set to true. Defaults to false. After an interaction is earmarked with this, it cannot be undone.
   * @returns {InteractionInstance} An API object that is bound to a specific BrowserInteraction event. Each time this method is called for the same BrowserInteraction, a new object is created, but it still references the same interaction.
   *  - Note: Does not apply to MicroAgent
   *  - Deprecation Notice: interaction.createTracer is deprecated.  See https://docs.newrelic.com/eol/2024/04/eol-04-24-24-createtracer/ for more information.
  */ interaction(opts) {
        return this.#callMethod((0, $4uE6N.INTERACTION), opts);
    }
    /**
   * Wrap a logger function to capture a log each time the function is invoked with the message and arguments passed
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/wraplogger/}
   * @param {object} parent The parent object containing the logger method
   * @param {string} functionName The property name of the function in the parent object to be wrapped
   * @param {{customAttributes?: object, level?: 'ERROR'|'TRACE'|'DEBUG'|'INFO'|'WARN'}} [options] customAttributes defaults to `{}` if not assigned, level defaults to `info` if not assigned.
  */ wrapLogger(parent, functionName, options) {
        return this.#callMethod((0, $4uE6N.WRAP_LOGGER), parent, functionName, options);
    }
    /**
   * Measures a task that is recorded as a BrowserPerformance event.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/measure/}
   * @param {string} name The name of the task
   * @param {{start?: number|PerformanceMark, end?: number|PerformanceMark, customAttributes?: object}} [options] An object used to control the way the measure API operates
   * @returns {{start: number, end: number, duration: number, customAttributes: object}} Measurement details
   */ measure(name, options) {
        return this.#callMethod((0, $4uE6N.MEASURE), name, options);
    }
    /**
   * Accepts or rejects consent when the agent is configured to require consent before harvesting.
   * The consent state is stored in session storage inside the NRBA_SESSION object.
   * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/consent/}
   * @param {boolean?} accept Whether to accept or reject consent. Defaults to true (accept) if left undefined.
   */ consent(accept) {
        return this.#callMethod((0, $4uE6N.CONSENT), accept);
    }
}

});


parcelRegister("4RLGm", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $38b1195cb00f7072$export$1ea939691cdc45b8; });
$parcel$export(module.exports, "mergeInfo", function () { return $38b1195cb00f7072$export$dd2074f2efc1d6f9; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $juL0p = parcelRequire("juL0p");

var $jzcsA = parcelRequire("jzcsA");
/**
 * @typedef {Object} Info
 * @property {string} [beacon]
 * @property {string} [errorBeacon] - Base URL endpoint for all data harvested by the agent. Proxies should be defined in the init instead.
 * @property {string} licenseKey - New Relic license key provided by the website in user account.
 * @property {string} applicationID - New Relic application ID provided when creating a browser entity in the UI.
 * @property {number} [sa]
 * @property {number} [queueTime]
 * @property {number} [applicationTime]
 * @property {string} [ttGuid]
 * @property {string} [user]
 * @property {string} [account]
 * @property {string} [product]
 * @property {string} [extra]
 * @property {Object} [jsAttributes] - Custom attributes that are added to majority of agent's payloads. The `setCustomAttribute` API method affects this.
 * @property {string} [userAttributes]
 * @property {string} [atts]
 * @property {string} [transactionName]
 * @property {string} [tNamePlain]
 */ const $38b1195cb00f7072$var$InfoModel = {
    // preset defaults
    beacon: (0, $juL0p.defaults).beacon,
    errorBeacon: (0, $juL0p.defaults).errorBeacon,
    // others must be populated by user
    licenseKey: undefined,
    applicationID: undefined,
    sa: undefined,
    queueTime: undefined,
    applicationTime: undefined,
    ttGuid: undefined,
    user: undefined,
    account: undefined,
    product: undefined,
    extra: undefined,
    jsAttributes: {},
    userAttributes: undefined,
    atts: undefined,
    transactionName: undefined,
    tNamePlain: undefined
};
function $38b1195cb00f7072$export$1ea939691cdc45b8(info) {
    try {
        return !!info.licenseKey && !!info.errorBeacon && !!info.applicationID;
    } catch (err) {
        return false;
    }
}
const $38b1195cb00f7072$export$dd2074f2efc1d6f9 = (info)=>{
    return (0, $jzcsA.getModeledObject)(info, $38b1195cb00f7072$var$InfoModel);
};

});
parcelRegister("jzcsA", function(module, exports) {

$parcel$export(module.exports, "getModeledObject", function () { return $e3eaf38a40e538ab$export$ae2e6186cd4233b1; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jkuUu = parcelRequire("jkuUu");
function $e3eaf38a40e538ab$export$ae2e6186cd4233b1(obj, model) {
    try {
        if (!obj || typeof obj !== 'object') return (0, $jkuUu.warn)(3);
        if (!model || typeof model !== 'object') return (0, $jkuUu.warn)(4);
        // allow getters and setters to pass from model to target
        const output = Object.create(Object.getPrototypeOf(model), Object.getOwnPropertyDescriptors(model));
        const target = Object.keys(output).length === 0 ? obj : output;
        for(let key in target){
            if (obj[key] === undefined) continue;
            try {
                if (obj[key] === null) {
                    output[key] = null;
                    continue;
                }
                if (Array.isArray(obj[key]) && Array.isArray(model[key])) output[key] = Array.from(new Set([
                    ...obj[key],
                    ...model[key]
                ]));
                else if (obj[key] instanceof Map || obj[key] instanceof Set || obj[key] instanceof Date || obj[key] instanceof RegExp) output[key] = obj[key];
                else if (typeof obj[key] === 'object' && typeof model[key] === 'object') output[key] = $e3eaf38a40e538ab$export$ae2e6186cd4233b1(obj[key], model[key]);
                else output[key] = obj[key];
            } catch (e) {
                if (!output[key]) (0, $jkuUu.warn)(1, e);
            }
        }
        return output;
    } catch (err) {
        (0, $jkuUu.warn)(2, err);
    }
}

});


parcelRegister("8Xnbq", function(module, exports) {

$parcel$export(module.exports, "mergeInit", function () { return $6855d11df45c21ed$export$e4d1049466ea3e2e; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4UPGI = parcelRequire("4UPGI");

var $4JquY = parcelRequire("4JquY");

var $44Lnf = parcelRequire("44Lnf");

var $jkuUu = parcelRequire("jkuUu");

var $jzcsA = parcelRequire("jzcsA");
/**
 * @typedef {import('./init-types').Init} Init
 */ const $6855d11df45c21ed$var$nrMask = '[data-nr-mask]';
/**
 * @returns {Init} the default configuration object
 */ const $6855d11df45c21ed$var$InitModelFn = ()=>{
    const hiddenState = {
        feature_flags: [],
        experimental: {
            register: false,
            resources: false
        },
        mask_selector: '*',
        block_selector: '[data-nr-block]',
        mask_input_options: {
            color: false,
            date: false,
            'datetime-local': false,
            email: false,
            month: false,
            number: false,
            range: false,
            search: false,
            tel: false,
            text: false,
            time: false,
            url: false,
            week: false,
            // unify textarea and select element with text input
            textarea: false,
            select: false,
            password: true // This will be enforced to always be true in the setter
        }
    };
    return {
        ajax: {
            deny_list: undefined,
            block_internal: true,
            enabled: true,
            autoStart: true
        },
        api: {
            register: {
                get enabled () {
                    return hiddenState.feature_flags.includes((0, $4UPGI.FEATURE_FLAGS).REGISTER) || hiddenState.experimental.register;
                },
                set enabled (val){
                    hiddenState.experimental.register = val;
                },
                duplicate_data_to_container: false
            }
        },
        browser_consent_mode: {
            enabled: false
        },
        distributed_tracing: {
            enabled: undefined,
            exclude_newrelic_header: undefined,
            cors_use_newrelic_header: undefined,
            cors_use_tracecontext_headers: undefined,
            allowed_origins: undefined
        },
        get feature_flags () {
            return hiddenState.feature_flags;
        },
        set feature_flags (val){
            hiddenState.feature_flags = val;
        },
        generic_events: {
            enabled: true,
            autoStart: true
        },
        harvest: {
            interval: 30
        },
        jserrors: {
            enabled: true,
            autoStart: true
        },
        logging: {
            enabled: true,
            autoStart: true
        },
        metrics: {
            enabled: true,
            autoStart: true
        },
        obfuscate: undefined,
        page_action: {
            enabled: true
        },
        page_view_event: {
            enabled: true,
            autoStart: true
        },
        page_view_timing: {
            enabled: true,
            autoStart: true
        },
        performance: {
            capture_marks: false,
            capture_measures: false,
            capture_detail: true,
            resources: {
                get enabled () {
                    return hiddenState.feature_flags.includes((0, $4UPGI.FEATURE_FLAGS).RESOURCES) || hiddenState.experimental.resources;
                },
                set enabled (val){
                    hiddenState.experimental.resources = val;
                },
                asset_types: [],
                first_party_domains: [],
                ignore_newrelic: true
            }
        },
        privacy: {
            cookies_enabled: true
        },
        proxy: {
            assets: undefined,
            beacon: undefined
        },
        session: {
            expiresMs: (0, $44Lnf.DEFAULT_EXPIRES_MS),
            inactiveMs: (0, $44Lnf.DEFAULT_INACTIVE_MS)
        },
        session_replay: {
            autoStart: true,
            enabled: false,
            preload: false,
            sampling_rate: 10,
            error_sampling_rate: 100,
            collect_fonts: false,
            inline_images: false,
            fix_stylesheets: true,
            mask_all_inputs: true,
            // this has a getter/setter to facilitate validation of the selectors
            get mask_text_selector () {
                return hiddenState.mask_selector;
            },
            set mask_text_selector (val){
                if ((0, $4JquY.isValidSelector)(val)) hiddenState.mask_selector = "".concat(val, ",").concat($6855d11df45c21ed$var$nrMask);
                else if (val === '' || val === null) hiddenState.mask_selector = $6855d11df45c21ed$var$nrMask;
                else (0, $jkuUu.warn)(5, val);
            },
            // these properties only have getters because they are enforcable constants and should error if someone tries to override them
            get block_class () {
                return 'nr-block';
            },
            get ignore_class () {
                return 'nr-ignore';
            },
            get mask_text_class () {
                return 'nr-mask';
            },
            // props with a getter and setter are used to extend enforcable constants with customer input
            // we must preserve data-nr-block no matter what else the customer sets
            get block_selector () {
                return hiddenState.block_selector;
            },
            set block_selector (val){
                if ((0, $4JquY.isValidSelector)(val)) hiddenState.block_selector += ",".concat(val);
                else if (val !== '') (0, $jkuUu.warn)(6, val);
            },
            // password: must always be present and true no matter what customer sets
            get mask_input_options () {
                return hiddenState.mask_input_options;
            },
            set mask_input_options (val){
                if (val && typeof val === 'object') hiddenState.mask_input_options = {
                    ...val,
                    password: true
                };
                else (0, $jkuUu.warn)(7, val);
            }
        },
        session_trace: {
            enabled: true,
            autoStart: true
        },
        soft_navigations: {
            enabled: true,
            autoStart: true
        },
        ssl: undefined,
        user_actions: {
            enabled: true,
            elementAttributes: [
                'id',
                'className',
                'tagName',
                'type'
            ]
        }
    };
};
const $6855d11df45c21ed$export$e4d1049466ea3e2e = (init)=>{
    return (0, $jzcsA.getModeledObject)(init, $6855d11df45c21ed$var$InitModelFn());
};

});
parcelRegister("4UPGI", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $39447c8fae4de923$export$7e598866fa8de8d0; });
$parcel$export(module.exports, "OBSERVED_EVENTS", function () { return $39447c8fae4de923$export$a6b08df999683e57; });
$parcel$export(module.exports, "OBSERVED_WINDOW_EVENTS", function () { return $39447c8fae4de923$export$a1a8d401047167c1; });
$parcel$export(module.exports, "RAGE_CLICK_THRESHOLD_EVENTS", function () { return $39447c8fae4de923$export$de14435d7e5501cb; });
$parcel$export(module.exports, "RAGE_CLICK_THRESHOLD_MS", function () { return $39447c8fae4de923$export$54510d267087c9f9; });
$parcel$export(module.exports, "FRUSTRATION_TIMEOUT_MS", function () { return $39447c8fae4de923$export$51948bf4a0fe83af; });
$parcel$export(module.exports, "RESERVED_EVENT_TYPES", function () { return $39447c8fae4de923$export$4351ddf640efe754; });
$parcel$export(module.exports, "FEATURE_FLAGS", function () { return $39447c8fae4de923$export$1e3fa289c11cc7; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $39447c8fae4de923$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).genericEvents;
const $39447c8fae4de923$export$a6b08df999683e57 = [
    'auxclick',
    'click',
    'copy',
    'keydown',
    'paste',
    'scrollend'
];
const $39447c8fae4de923$export$a1a8d401047167c1 = [
    'focus',
    'blur'
];
const $39447c8fae4de923$export$de14435d7e5501cb = 4;
const $39447c8fae4de923$export$54510d267087c9f9 = 1000;
const $39447c8fae4de923$export$51948bf4a0fe83af = 2000;
const $39447c8fae4de923$export$4351ddf640efe754 = [
    'PageAction',
    'UserAction',
    'BrowserPerformance'
];
const $39447c8fae4de923$export$1e3fa289c11cc7 = {
    RESOURCES: 'experimental.resources',
    REGISTER: 'register'
};

});

parcelRegister("4JquY", function(module, exports) {

$parcel$export(module.exports, "isValidSelector", function () { return $371feb7512bae229$export$569ea5cbb1c2b2eb; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ const $371feb7512bae229$export$569ea5cbb1c2b2eb = (selector)=>{
    if (!selector || typeof selector !== 'string') return false;
    try {
        document.createDocumentFragment().querySelector(selector);
    } catch  {
        return false;
    }
    return true;
};

});

parcelRegister("44Lnf", function(module, exports) {

$parcel$export(module.exports, "PREFIX", function () { return $2f7c48a3e1aba4cf$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "DEFAULT_KEY", function () { return $2f7c48a3e1aba4cf$export$729d352c37f0a7df; });
$parcel$export(module.exports, "DEFAULT_EXPIRES_MS", function () { return $2f7c48a3e1aba4cf$export$715c7a209892fa6a; });
$parcel$export(module.exports, "DEFAULT_INACTIVE_MS", function () { return $2f7c48a3e1aba4cf$export$490a662b0d960ee6; });
$parcel$export(module.exports, "SESSION_EVENTS", function () { return $2f7c48a3e1aba4cf$export$a612cd94c904d02f; });
$parcel$export(module.exports, "SESSION_EVENT_TYPES", function () { return $2f7c48a3e1aba4cf$export$deef4d5c0976a9aa; });
$parcel$export(module.exports, "MODE", function () { return $2f7c48a3e1aba4cf$export$e48589d9e4824227; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ const $2f7c48a3e1aba4cf$export$8a682ae47622dbb9 = 'NRBA';
const $2f7c48a3e1aba4cf$export$729d352c37f0a7df = 'SESSION';
const $2f7c48a3e1aba4cf$export$715c7a209892fa6a = 14400000;
const $2f7c48a3e1aba4cf$export$490a662b0d960ee6 = 1800000;
const $2f7c48a3e1aba4cf$export$a612cd94c904d02f = {
    STARTED: 'session-started',
    PAUSE: 'session-pause',
    RESET: 'session-reset',
    RESUME: 'session-resume',
    UPDATE: 'session-update'
};
const $2f7c48a3e1aba4cf$export$deef4d5c0976a9aa = {
    SAME_TAB: 'same-tab',
    CROSS_TAB: 'cross-tab'
};
const $2f7c48a3e1aba4cf$export$e48589d9e4824227 = {
    OFF: 0,
    FULL: 1,
    ERROR: 2
};

});


parcelRegister("8uCIQ", function(module, exports) {

$parcel$export(module.exports, "mergeRuntime", function () { return $62ef298676f9a84e$export$aae7f81aac349f9; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jzcsA = parcelRequire("jzcsA");

var $9EKMI = parcelRequire("9EKMI");

var $4wUr4 = parcelRequire("4wUr4");
/**
 * Module level count of harvests. This property will auto-increment each time it is accessed.
 * @type {number}
 */ let $62ef298676f9a84e$var$_harvestCount = 0;
const $62ef298676f9a84e$var$ReadOnly = {
    buildEnv: (0, $4wUr4.BUILD_ENV),
    distMethod: (0, $4wUr4.DIST_METHOD),
    version: (0, $4wUr4.VERSION),
    originTime: $9EKMI.originTime
};
const $62ef298676f9a84e$var$hiddenState = {
    consented: false
};
const $62ef298676f9a84e$var$RuntimeModel = {
    /** @type {{[key: string]: number} | undefined} */ activatedFeatures: undefined,
    /** Agent-specific metadata found in the RUM call response. ex. entityGuid */ appMetadata: {},
    /** @type {boolean} */ configured: false,
    get consented () {
        return this.session?.state?.consent || $62ef298676f9a84e$var$hiddenState.consented;
    },
    set consented (value){
        $62ef298676f9a84e$var$hiddenState.consented = value;
    },
    customTransaction: undefined,
    denyList: [],
    disabled: false,
    /** @type {Map<string, {staged: boolean, priority: number}>} */ drainRegistry: new Map(),
    harvester: undefined,
    isolatedBacklog: false,
    isRecording: false,
    // true when actively recording, false when paused or stopped
    loaderType: undefined,
    maxBytes: 30000,
    obfuscator: undefined,
    onerror: undefined,
    ptid: undefined,
    releaseIds: {},
    session: undefined,
    timeKeeper: undefined,
    registeredEntities: [],
    /** a proxy is set in agent-session to track jsAttributes changes for harvesting mechanics */ jsAttributesMetadata: {
        bytes: 0
    },
    get harvestCount () {
        return ++$62ef298676f9a84e$var$_harvestCount;
    }
};
const $62ef298676f9a84e$export$aae7f81aac349f9 = (runtime)=>{
    const modeledObject = (0, $jzcsA.getModeledObject)(runtime, $62ef298676f9a84e$var$RuntimeModel);
    const readonlyDescriptors = Object.keys($62ef298676f9a84e$var$ReadOnly).reduce((descriptors, key)=>{
        descriptors[key] = {
            value: $62ef298676f9a84e$var$ReadOnly[key],
            writable: false,
            configurable: true,
            enumerable: true
        };
        return descriptors;
    }, {});
    return Object.defineProperties(modeledObject, readonlyDescriptors);
};

});
parcelRegister("4wUr4", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $34c5ed80338eb844$export$a4ad2735b021c132; });
$parcel$export(module.exports, "BUILD_ENV", function () { return $34c5ed80338eb844$export$389083522bf36370; });
$parcel$export(module.exports, "DIST_METHOD", function () { return $34c5ed80338eb844$export$2b81c41a7f64a10d; });
$parcel$export(module.exports, "RRWEB_PACKAGE_NAME", function () { return $34c5ed80338eb844$export$f93ab5f104979cde; });
$parcel$export(module.exports, "RRWEB_VERSION", function () { return $34c5ed80338eb844$export$1accf68fcec134b; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file This file exposes NPM build environment variables. These variables will
 * be overridden with babel.
 */ /**
 * Exposes the version of the agent
 */ const $34c5ed80338eb844$export$a4ad2735b021c132 = "1.314.0";
const $34c5ed80338eb844$export$389083522bf36370 = 'NPM';
const $34c5ed80338eb844$export$2b81c41a7f64a10d = 'NPM';
const $34c5ed80338eb844$export$f93ab5f104979cde = '@newrelic/rrweb';
const $34c5ed80338eb844$export$1accf68fcec134b = "1.1.0";

});


parcelRegister("6AoZt", function(module, exports) {

$parcel$export(module.exports, "redefinePublicPath", function () { return $4cb97d71cf30ebc9$export$5d128d82e7337f0f; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ const $4cb97d71cf30ebc9$export$5d128d82e7337f0f = ()=>{
// We don't support setting public path in webpack via NPM build.
};

});

parcelRegister("im7dd", function(module, exports) {

$parcel$export(module.exports, "contextId", function () { return $d5cfe042f13c98c8$export$afdf044262a55ebe; });
$parcel$export(module.exports, "ee", function () { return $d5cfe042f13c98c8$export$75bcf1258875c6bf; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $juL0p = parcelRequire("juL0p");

var $iGnFd = parcelRequire("iGnFd");

var $3MOOm = parcelRequire("3MOOm");

var $3Nvam = parcelRequire("3Nvam");
// create a unique id to store event context data for the current agent bundle
const $d5cfe042f13c98c8$export$afdf044262a55ebe = "nr@context:".concat((0, $3Nvam.bundleId));
// create global emitter instance that can be shared among bundles
const $d5cfe042f13c98c8$export$75bcf1258875c6bf = $d5cfe042f13c98c8$var$ee(undefined, 'globalEE');
// Only override the exposed event emitter if one has not already been exposed
const $d5cfe042f13c98c8$var$nr = (0, $juL0p.gosNREUM)();
if (!$d5cfe042f13c98c8$var$nr.ee) $d5cfe042f13c98c8$var$nr.ee = $d5cfe042f13c98c8$export$75bcf1258875c6bf;
function $d5cfe042f13c98c8$var$ee(old, debugId) {
    var handlers = {};
    var bufferGroupMap = {};
    var emitters = {};
    // In cases where multiple agents can run on a page, the event backlogs of feature event emitters must be isolated
    // to prevent event emitter context and buffers from "bubbling up" to other agents operating in the scope.
    // An example of this is our MicroAgent loader package, which sets this property to true to prevent overlap.
    var isolatedBacklog = false;
    try {
        // We only want to check the runtime configuration for `isolatedBacklog` if the event emitter belongs to a feature.
        // For feature event emitters, the debugId will be an agentIdentifier with a length of 16. In contrast, some of our
        // tests do not namespace the event emitter with an agentID and just use the parent (which has no ID).
        isolatedBacklog = debugId.length !== 16 ? false : $d5cfe042f13c98c8$var$nr.initializedAgents?.[debugId]?.runtime.isolatedBacklog;
    } catch (err) {
    // Do nothing for now.
    }
    var emitter = {
        on: addEventListener,
        addEventListener: addEventListener,
        removeEventListener: removeEventListener,
        emit: emit,
        get: getOrCreate,
        listeners: listeners,
        context: context,
        buffer: bufferEventsByGroup,
        abort: abort,
        isBuffering: isBuffering,
        debugId: debugId,
        backlog: isolatedBacklog ? {} : old && typeof old.backlog === 'object' ? old.backlog : {},
        isolatedBacklog: isolatedBacklog
    };
    function abort() {
        emitter._aborted = true;
        Object.keys(emitter.backlog).forEach((key)=>{
            delete emitter.backlog[key];
        });
    }
    Object.defineProperty(emitter, 'aborted', {
        get: ()=>{
            let aborted = emitter._aborted || false;
            if (aborted) return aborted;
            else if (old) aborted = old.aborted;
            return aborted;
        }
    });
    return emitter;
    function context(contextOrStore) {
        if (contextOrStore && contextOrStore instanceof (0, $3MOOm.EventContext)) return contextOrStore;
        else if (contextOrStore) return (0, $iGnFd.getOrSet)(contextOrStore, $d5cfe042f13c98c8$export$afdf044262a55ebe, ()=>new (0, $3MOOm.EventContext)($d5cfe042f13c98c8$export$afdf044262a55ebe));
        else return new (0, $3MOOm.EventContext)($d5cfe042f13c98c8$export$afdf044262a55ebe);
    }
    function emit(type, args, contextOrStore, force, bubble) {
        if (bubble !== false) bubble = true;
        if ($d5cfe042f13c98c8$export$75bcf1258875c6bf.aborted && !force) return;
        if (old && bubble) old.emit(type, args, contextOrStore);
        var ctx = context(contextOrStore);
        var handlersArray = listeners(type);
        // Apply each handler function in the order they were added
        // to the context with the arguments
        handlersArray.forEach((handler)=>{
            handler.apply(ctx, args);
        });
        // Buffer after emitting for consistent ordering
        var bufferGroup = getBuffer()[bufferGroupMap[type]];
        if (bufferGroup) bufferGroup.push([
            emitter,
            type,
            args,
            ctx
        ]);
        // Return the context so that the module that emitted can see what was done.
        return ctx;
    }
    function addEventListener(type, fn) {
        // Retrieve type from handlers, if it doesn't exist assign the default and retrieve it.
        handlers[type] = listeners(type).concat(fn);
    }
    function removeEventListener(type, fn) {
        var listeners = handlers[type];
        if (!listeners) return;
        for(var i = 0; i < listeners.length; i++)if (listeners[i] === fn) listeners.splice(i, 1);
    }
    function listeners(type) {
        return handlers[type] || [];
    }
    function getOrCreate(name) {
        return emitters[name] = emitters[name] || $d5cfe042f13c98c8$var$ee(emitter, name);
    }
    function bufferEventsByGroup(types, group) {
        const eventBuffer = getBuffer();
        group = group || 'feature';
        // do not buffer events if agent has been aborted
        if (emitter.aborted) return;
        Object.entries(types || {}).forEach(([_, type])=>{
            bufferGroupMap[type] = group;
            if (!(group in eventBuffer)) eventBuffer[group] = [];
        });
    }
    function isBuffering(type) {
        var bufferGroup = getBuffer()[bufferGroupMap[type]];
        return !!bufferGroup;
    }
    // buffer is associated with a base emitter, since there are two
    // (global and scoped to the current bundle), it is now part of the emitter
    function getBuffer() {
        return emitter.backlog;
    }
}

});
parcelRegister("iGnFd", function(module, exports) {

$parcel$export(module.exports, "getOrSet", function () { return $d99e8163fbc8e147$export$4e083ea558c6b585; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $d99e8163fbc8e147$var$has = Object.prototype.hasOwnProperty;
function $d99e8163fbc8e147$export$4e083ea558c6b585(obj, prop, getVal) {
    // If the value exists return it.
    if ($d99e8163fbc8e147$var$has.call(obj, prop)) return obj[prop];
    var val = getVal();
    // Attempt to set the property so it's not enumerable
    if (Object.defineProperty && Object.keys) try {
        Object.defineProperty(obj, prop, {
            value: val,
            // old IE inherits non-write-ability
            writable: true,
            enumerable: false
        });
        return val;
    } catch (e) {
    // Can't report internal errors,
    // because GOS is a dependency of the reporting mechanisms
    }
    // fall back to setting normally
    obj[prop] = val;
    return val;
}

});

parcelRegister("3MOOm", function(module, exports) {

$parcel$export(module.exports, "EventContext", function () { return $2c1d44d5229b7116$export$4994f107c6e9cbba; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ class $2c1d44d5229b7116$export$4994f107c6e9cbba {
    constructor(contextId){
        this.contextId = contextId;
    }
}

});

parcelRegister("3Nvam", function(module, exports) {

$parcel$export(module.exports, "bundleId", function () { return $2c3e1fa37c80669e$export$14732f507e2ca794; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Contains a unique identifier for the running agent bundle
 * when loaded.
 * @copyright 2023 New Relic Corporation. All rights reserved.
 * @license Apache-2.0
 */ 
var $6sT7C = parcelRequire("6sT7C");
const $2c3e1fa37c80669e$export$14732f507e2ca794 = (0, $6sT7C.generateUuid)();

});


parcelRegister("5HzeA", function(module, exports) {

$parcel$export(module.exports, "mergeLoaderConfig", function () { return $426c4cb760591a32$export$e762ff190a6ab3f5; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jzcsA = parcelRequire("jzcsA");
const $426c4cb760591a32$var$LoaderConfigModel = {
    accountID: undefined,
    trustKey: undefined,
    agentID: undefined,
    licenseKey: undefined,
    applicationID: undefined,
    xpid: undefined
};
const $426c4cb760591a32$export$e762ff190a6ab3f5 = (loaderConfig)=>{
    return (0, $jzcsA.getModeledObject)(loaderConfig, $426c4cb760591a32$var$LoaderConfigModel);
};

});


parcelRegister("gy0pT", function(module, exports) {

$parcel$export(module.exports, "handleEE", function () { return $c0c0250f69665a98$export$2d41587f2e6ab7bf; });
$parcel$export(module.exports, "handle", function () { return $c0c0250f69665a98$export$8f34ce051745d39e; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $im7dd = parcelRequire("im7dd");
var $c0c0250f69665a98$export$2d41587f2e6ab7bf = (0, $im7dd.ee).get('handle');
function $c0c0250f69665a98$export$8f34ce051745d39e(type, args, ctx, group, ee) {
    if (ee) {
        ee.buffer([
            type
        ], group);
        ee.emit(type, args, ctx);
    } else {
        $c0c0250f69665a98$export$2d41587f2e6ab7bf.buffer([
            type
        ], group);
        $c0c0250f69665a98$export$2d41587f2e6ab7bf.emit(type, args, ctx);
    }
}

});

parcelRegister("dVxdm", function(module, exports) {

$parcel$export(module.exports, "setupAPI", function () { return $a23a5cf6e5bafaa0$export$2138c6fb47db208; });
$parcel$export(module.exports, "appendJsAttribute", function () { return $a23a5cf6e5bafaa0$export$668462df174b283b; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $klTus = parcelRequire("klTus");

var $gy0pT = parcelRequire("gy0pT");

var $1Z3KE = parcelRequire("1Z3KE");

var $jkuUu = parcelRequire("jkuUu");

var $bu0p3 = parcelRequire("bu0p3");

var $azp24 = parcelRequire("azp24");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");
function $a23a5cf6e5bafaa0$export$2138c6fb47db208(name, fn, agent, obj) {
    /* use object if provided, otherwise use agent as base for api method assignment */ const api = obj || agent;
    // We only set the global API event if the API is not already overridden from the default
    if (!api || !!api[name] && api[name] !== (0, $azp24.AgentBase).prototype[name]) return;
    api[name] = function() {
        (0, $gy0pT.handle)((0, $bu0p3.SUPPORTABILITY_METRIC_CHANNEL), [
            'API/' + name + '/called'
        ], undefined, (0, $3R40a.FEATURE_NAMES).metrics, agent.ee);
        (0, $klTus.dispatchGlobalEvent)({
            drained: !!agent.runtime?.activatedFeatures,
            type: 'data',
            name: 'api',
            feature: (0, $4uE6N.prefix) + name,
            data: {}
        });
        try {
            return fn.apply(this, arguments);
        } catch (err) {
            (0, $jkuUu.warn)(23, err);
        }
    };
}
function $a23a5cf6e5bafaa0$export$668462df174b283b(agent, key, value, apiName, addToBrowserStorage) {
    const currentInfo = agent.info;
    if (value === null) delete currentInfo.jsAttributes[key];
    else currentInfo.jsAttributes[key] = value;
    if (addToBrowserStorage || value === null) (0, $gy0pT.handle)((0, $4uE6N.prefix) + apiName, [
        (0, $1Z3KE.now)(),
        key,
        value
    ], undefined, 'session', agent.ee);
}

});
parcelRegister("bu0p3", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $85c2cf1b9c72d945$export$7e598866fa8de8d0; });
$parcel$export(module.exports, "SUPPORTABILITY_METRIC", function () { return $85c2cf1b9c72d945$export$7ffef7f7591d712d; });
$parcel$export(module.exports, "CUSTOM_METRIC", function () { return $85c2cf1b9c72d945$export$6dfbad21075861b8; });
$parcel$export(module.exports, "SUPPORTABILITY_METRIC_CHANNEL", function () { return $85c2cf1b9c72d945$export$24bf99574d5f1eed; });
$parcel$export(module.exports, "CUSTOM_METRIC_CHANNEL", function () { return $85c2cf1b9c72d945$export$168568077cd7cf19; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $85c2cf1b9c72d945$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).metrics;
const $85c2cf1b9c72d945$export$7ffef7f7591d712d = 'sm';
const $85c2cf1b9c72d945$export$6dfbad21075861b8 = 'cm';
const $85c2cf1b9c72d945$export$24bf99574d5f1eed = 'storeSupportabilityMetrics';
const $85c2cf1b9c72d945$export$168568077cd7cf19 = 'storeEventMetrics';

});

parcelRegister("azp24", function(module, exports) {

$parcel$export(module.exports, "AgentBase", function () { return $7b209728b66bb72b$export$e1cc1b83e0e3d6e2; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /* eslint-disable n/handle-callback-err */ 
var $6sT7C = parcelRequire("6sT7C");

var $8e4CA = parcelRequire("8e4CA");
class $7b209728b66bb72b$export$e1cc1b83e0e3d6e2 extends (0, $8e4CA.ApiBase) {
    agentIdentifier = (0, $6sT7C.generateRandomHexString)(16);
}

});


parcelRegister("Sqjfb", function(module, exports) {

$parcel$export(module.exports, "registerDrain", function () { return $0a3973c184b8d5ec$export$ca0839984da1fad0; });
$parcel$export(module.exports, "deregisterDrain", function () { return $0a3973c184b8d5ec$export$cb7850ae66cca4c0; });
$parcel$export(module.exports, "drain", function () { return $0a3973c184b8d5ec$export$39a457f171101d3b; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $klTus = parcelRequire("klTus");

var $4he1m = parcelRequire("4he1m");

var $3R40a = parcelRequire("3R40a");

var $3MOOm = parcelRequire("3MOOm");
function $0a3973c184b8d5ec$export$ca0839984da1fad0(agentRef, group) {
    if (!agentRef) return;
    // Here `item` captures the registered properties of a feature-group: whether it is ready for its buffered events
    // to be drained (`staged`) and the `priority` order in which it should be drained relative to other feature groups.
    const item = {
        staged: false,
        priority: (0, $3R40a.featurePriority)[group] || 0
    };
    if (!agentRef.runtime.drainRegistry.get(group)) agentRef.runtime.drainRegistry.set(group, item);
}
function $0a3973c184b8d5ec$export$cb7850ae66cca4c0(agentRef, group) {
    if (!agentRef) return;
    const drainRegistry = agentRef.runtime.drainRegistry;
    if (!drainRegistry) return;
    if (drainRegistry.get(group)) drainRegistry.delete(group);
    $0a3973c184b8d5ec$var$drainGroup(agentRef, group, false);
    if (drainRegistry.size) $0a3973c184b8d5ec$var$checkCanDrainAll(agentRef);
}
function $0a3973c184b8d5ec$export$39a457f171101d3b(agentRef, featureName = 'feature', force = false) {
    if (!agentRef) return;
    // If the feature for the specified agent is not in the registry, that means the instrument file was bypassed.
    // This could happen in tests, or loaders that directly import the aggregator. In these cases it is safe to
    // drain the feature group immediately rather than waiting to drain all at once.
    if (!agentRef.runtime.drainRegistry.get(featureName) || force) return $0a3973c184b8d5ec$var$drainGroup(agentRef, featureName);
    // When `drain` is called, this feature is ready to drain (staged).
    agentRef.runtime.drainRegistry.get(featureName).staged = true;
    $0a3973c184b8d5ec$var$checkCanDrainAll(agentRef);
}
/** Checks all items in the registry to see if they have been "staged".  If ALL items are staged, it will drain all registry items (drainGroup).  It not, nothing will happen */ function $0a3973c184b8d5ec$var$checkCanDrainAll(agentRef) {
    if (!agentRef) return;
    // Only when the event-groups for all features are ready to drain (staged) do we execute the drain. This has the effect
    // that the last feature to call drain triggers drain for all features.
    const items = Array.from(agentRef.runtime.drainRegistry);
    if (items.every(([key, values])=>values.staged)) {
        items.sort((a, b)=>a[1].priority - b[1].priority);
        items.forEach(([group])=>{
            agentRef.runtime.drainRegistry.delete(group);
            $0a3973c184b8d5ec$var$drainGroup(agentRef, group);
        });
    }
}
/**
   * Drains all the buffered (backlog) events for a particular feature's event-group by emitting each event to each of
   * the subscribed handlers for the group.
   * @param {*} group - The name of a particular feature's event "bucket".
   */ function $0a3973c184b8d5ec$var$drainGroup(agentRef, group, activateGroup = true) {
    if (!agentRef) return;
    const baseEE = agentRef.ee;
    const handlers = (0, $4he1m.registerHandler).handlers; // other storage in registerHandler
    if (!baseEE || baseEE.aborted || !baseEE.backlog || !handlers) return;
    (0, $klTus.dispatchGlobalEvent)({
        type: 'lifecycle',
        name: 'drain',
        feature: group
    });
    // Only activated features being drained should run queued listeners on buffered events. Deactivated features only need to release memory.
    if (activateGroup) {
        const bufferedEventsInGroup = baseEE.backlog[group];
        const groupHandlers = handlers[group]; // each group in the registerHandler storage
        if (groupHandlers) {
            // We don't cache the length of the buffer while looping because events might still be added while processing.
            for(let i = 0; bufferedEventsInGroup && i < bufferedEventsInGroup.length; ++i)// eslint-disable-line no-unmodified-loop-condition
            $0a3973c184b8d5ec$var$emitEvent(bufferedEventsInGroup[i], groupHandlers);
            Object.entries(groupHandlers).forEach(([eventType, handlerRegistrationList])=>{
                Object.values(handlerRegistrationList || {}).forEach((registration)=>{
                    // registration *should* be an array of: [targetEE, eventHandler]
                    // certain browser polyfills of .values and .entries pass the prototype methods into the callback,
                    // which breaks this assumption and throws errors. So we make sure here that we only call .on() if its an actual NR EE
                    if (registration[0]?.on && registration[0].context() instanceof (0, $3MOOm.EventContext) && !registration[0].listeners(eventType).includes(registration[1])) registration[0].on(eventType, registration[1]);
                });
            });
        }
    }
    if (!baseEE.isolatedBacklog) delete handlers[group];
    baseEE.backlog[group] = null;
    baseEE.emit('drain-' + group, []); // Informs the feature that it has drained its backlog of events, this kicks off an immediate harvest to capture any load-driven events that were buffered.
}
/**
 * Processes the specified event using all relevant handler functions associated with a particular feature, based on
 * whether the handler is meant to apply to events of this type. (Event type is a descriptive string set at the
 * time an event is originally created by instrumentation, as with calls to the `handle` method.)
 * @param {*} evt - A single event to be emitted to (processed by) eligible handler functions.
 * @param {*} groupHandlers - A set of handler functions associated with a particular feature's event-group.
 */ function $0a3973c184b8d5ec$var$emitEvent(evt, groupHandlers) {
    var type = evt[1];
    Object.values(groupHandlers[type] || {}).forEach((registration)=>{
        var sourceEE = evt[0];
        var ee = registration[0];
        if (ee === sourceEE) {
            var handler = registration[1];
            var ctx = evt[3];
            var args = evt[2];
            handler.apply(ctx, args);
        }
    });
}

});
parcelRegister("4he1m", function(module, exports) {

$parcel$export(module.exports, "registerHandler", function () { return $31d3a0341751519c$export$bc8af6df6fbeb921; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");
$31d3a0341751519c$export$bc8af6df6fbeb921.on = $31d3a0341751519c$var$registerWithSpecificEmitter;
var $31d3a0341751519c$var$handlers = $31d3a0341751519c$export$bc8af6df6fbeb921.handlers = {};
function $31d3a0341751519c$export$bc8af6df6fbeb921(type, handler, group, ee) {
    $31d3a0341751519c$var$registerWithSpecificEmitter(ee || (0, $gy0pT.handleEE), $31d3a0341751519c$var$handlers, type, handler, group);
}
function $31d3a0341751519c$var$registerWithSpecificEmitter(ee, handlers, type, handler, group) {
    if (!group) group = 'feature';
    if (!ee) ee = (0, $gy0pT.handleEE);
    var groupHandlers = handlers[group] = handlers[group] || {};
    var list = groupHandlers[type] = groupHandlers[type] || [];
    list.push([
        ee,
        handler
    ]);
}

});


parcelRegister("1017n", function(module, exports) {

$parcel$export(module.exports, "FeatureBase", function () { return $0ba6a88cc06502cb$export$81c9452efe02d91c; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $Sqjfb = parcelRequire("Sqjfb");
class $0ba6a88cc06502cb$export$81c9452efe02d91c {
    constructor(agentRef, featureName){
        /** @type {Object} */ this.agentRef = agentRef;
        /** @type {import('../../common/event-emitter/contextual-ee').ee} */ this.ee = agentRef?.ee;
        /** @type {string} */ this.featureName = featureName;
        /**
     * Blocked can be used to prevent aggregation and harvest after initialization time of the feature.
     * This can currently happen if RUM response setToken flag is 0, which is tied to ingest account entitlement info.
     * @type {boolean}
     */ this.blocked = false;
    }
    deregisterDrain() {
        (0, $Sqjfb.deregisterDrain)(this.agentRef, this.featureName);
    }
}

});

parcelRegister("b5Hn5", function(module, exports) {

$parcel$export(module.exports, "onWindowLoad", function () { return $8131cdfdbcc4e492$export$ed85e297a450c0d2; });
$parcel$export(module.exports, "onDOMContentLoaded", function () { return $8131cdfdbcc4e492$export$62028ff70825ead9; });
$parcel$export(module.exports, "onPopstateChange", function () { return $8131cdfdbcc4e492$export$ce956b4c2d17201; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $8FJov = parcelRequire("8FJov");

var $letnH = parcelRequire("letnH");
function $8131cdfdbcc4e492$export$12e88edc9b131855() {
    return typeof document === 'undefined' || document.readyState === 'complete';
}
function $8131cdfdbcc4e492$export$ed85e297a450c0d2(cb, useCapture) {
    if ($8131cdfdbcc4e492$export$12e88edc9b131855()) return cb();
    const singleCb = (0, $letnH.single)(cb);
    const poll = setInterval(()=>{
        if ($8131cdfdbcc4e492$export$12e88edc9b131855()) {
            clearInterval(poll);
            singleCb();
        }
    }, 500);
    (0, $8FJov.windowAddEventListener)('load', singleCb, useCapture);
}
function $8131cdfdbcc4e492$export$62028ff70825ead9(cb) {
    if ($8131cdfdbcc4e492$export$12e88edc9b131855()) return cb();
    (0, $8FJov.documentAddEventListener)('DOMContentLoaded', cb);
}
function $8131cdfdbcc4e492$export$ce956b4c2d17201(cb) {
    if ($8131cdfdbcc4e492$export$12e88edc9b131855()) return cb();
    (0, $8FJov.windowAddEventListener)('popstate', cb);
}

});
parcelRegister("8FJov", function(module, exports) {

$parcel$export(module.exports, "eventListenerOpts", function () { return $65055d6592e1c6ea$export$6ddd7bdfa403e719; });
$parcel$export(module.exports, "windowAddEventListener", function () { return $65055d6592e1c6ea$export$bf10bb44a4e3af6a; });
$parcel$export(module.exports, "documentAddEventListener", function () { return $65055d6592e1c6ea$export$db5d8ccc4742b625; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ function $65055d6592e1c6ea$export$6ddd7bdfa403e719(useCapture, abortSignal) {
    return {
        capture: useCapture,
        passive: false,
        signal: abortSignal
    };
}
function $65055d6592e1c6ea$export$bf10bb44a4e3af6a(event, listener, capture = false, abortSignal) {
    window.addEventListener(event, listener, $65055d6592e1c6ea$export$6ddd7bdfa403e719(capture, abortSignal));
}
function $65055d6592e1c6ea$export$db5d8ccc4742b625(event, listener, capture = false, abortSignal) {
    document.addEventListener(event, listener, $65055d6592e1c6ea$export$6ddd7bdfa403e719(capture, abortSignal));
}

});

parcelRegister("letnH", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $f751b2456b4af596$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "single", function () { return $f751b2456b4af596$export$863d7ca51b416cee; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Reduce the invocation of the supplied function so that it is only invoked
 * once within a given timeout.
 *
 * If `wait` is `0`, the function will be invoked during the next tick.
 * If `options.leading` is false or not provided, the function will be invoked
 * N milliseconds after the last invocation of the returned function where
 * N is the `timeout` value.
 * If `options.leading` is true, the function will be invoked immediately upon
 * the first invocation of the returned function and not again for N milliseconds
 * where N is the `timeout` value.
 * @param {function} func Function whose invocation should be limited so it is only invoked
 * once within a given timeout period.
 * @param {number} timeout Time in milliseconds that the function should only be invoked
 * once within.
 * @param {object} options Debounce options
 * @param {boolean} options.leading Forces the function to be invoked on the first
 * invocation of the returned function instead of N milliseconds after the last
 * invocation.
 * @returns {function} A wrapping function that will ensure the provided function
 * is invoked only once within the given timeout.
 */ function $f751b2456b4af596$export$61fc7d43ac8f84b0(func, timeout = 500, options = {}) {
    const leading = options?.leading || false;
    let timer;
    return (...args)=>{
        if (leading && timer === undefined) {
            func.apply(this, args);
            timer = setTimeout(()=>{
                timer = clearTimeout(timer);
            }, timeout);
        }
        if (!leading) {
            clearTimeout(timer);
            timer = setTimeout(()=>{
                func.apply(this, args);
            }, timeout);
        }
    };
}
function $f751b2456b4af596$export$863d7ca51b416cee(func) {
    let called = false;
    return (...args)=>{
        if (!called) {
            called = true;
            func.apply(this, args);
        }
    };
}

});


parcelRegister("24qgc", function(module, exports) {

$parcel$export(module.exports, "hasReplayPrerequisite", function () { return $1820533d23c41942$export$3eb4096f95328822; });
$parcel$export(module.exports, "isPreloadAllowed", function () { return $1820533d23c41942$export$cc48718a2140b6cc; });
$parcel$export(module.exports, "customMasker", function () { return $1820533d23c41942$export$b574d35306b76c05; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $juL0p = parcelRequire("juL0p");

var $1orxZ = parcelRequire("1orxZ");
function $1820533d23c41942$export$3eb4096f95328822(agentInit) {
    return !!(0, $juL0p.gosNREUMOriginals)().o.MO && // Session Replay cannot work without Mutation Observer
    (0, $1orxZ.canEnableSessionTracking)(agentInit) && // requires session tracking to be running (hence "session" replay...)
    agentInit?.session_trace.enabled === true; // Session Replay as of now is tightly coupled with Session Trace in the UI
}
function $1820533d23c41942$export$cc48718a2140b6cc(agentInit) {
    return agentInit?.session_replay.preload === true && $1820533d23c41942$export$3eb4096f95328822(agentInit);
}
function $1820533d23c41942$export$b574d35306b76c05(text, element) {
    try {
        if (typeof element?.type === 'string') {
            if (element.type.toLowerCase() === 'password') return '*'.repeat(text?.length || 0);
            if (element?.dataset?.nrUnmask !== undefined || element?.classList?.contains('nr-unmask')) return text;
        }
    } catch (err) {
    // likely an element was passed to this handler that was invalid and was missing attributes or methods
    }
    return typeof text === 'string' ? text.replace(/[\S]/g, '*') : '*'.repeat(text?.length || 0);
}

});
parcelRegister("1orxZ", function(module, exports) {

$parcel$export(module.exports, "canEnableSessionTracking", function () { return $103d66a9edc6b2dc$export$67fc5003183015e1; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");
const $103d66a9edc6b2dc$export$67fc5003183015e1 = (agentInit)=>{
    return (0, $9EKMI.isBrowserScope) && agentInit?.privacy.cookies_enabled === true;
};

});


parcelRegister("iNTSX", function(module, exports) {

$parcel$export(module.exports, "IDEAL_PAYLOAD_SIZE", function () { return $db082749e409c3e1$export$525bfbdfb92541f7; });
$parcel$export(module.exports, "MAX_PAYLOAD_SIZE", function () { return $db082749e409c3e1$export$3a95de05ee89251; });
$parcel$export(module.exports, "SESSION_ERROR", function () { return $db082749e409c3e1$export$62a57542475576d6; });
$parcel$export(module.exports, "SUPPORTS_REGISTERED_ENTITIES", function () { return $db082749e409c3e1$export$83d80609134c4d7a; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $db082749e409c3e1$export$525bfbdfb92541f7 = 16000;
const $db082749e409c3e1$export$3a95de05ee89251 = 1000000;
const $db082749e409c3e1$export$729d352c37f0a7df = 'NR_CONTAINER_AGENT';
const $db082749e409c3e1$export$62a57542475576d6 = 'SESSION_ERROR';
const $db082749e409c3e1$export$83d80609134c4d7a = {
    [(0, $3R40a.FEATURE_NAMES).logging]: true,
    [(0, $3R40a.FEATURE_NAMES).genericEvents]: true,
    [(0, $3R40a.FEATURE_NAMES).jserrors]: true,
    [(0, $3R40a.FEATURE_NAMES).ajax]: true
};

});

parcelRegister("7CkoZ", function(module, exports) {
module.exports = $parcel$import("jjBJ0").then(()=>parcelRequire('eF6cD'));

});

parcelRegister("f5YR6", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $afd68743f4610ea0$export$7e598866fa8de8d0; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $afd68743f4610ea0$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).pageViewEvent;

});

parcelRegister("iwT1r", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("aCmou"),
    $parcel$import("1uHoI"),
    $parcel$import("kl0II")
]).then(()=>parcelRequire('lueeF'));

});

parcelRegister("kx4OV", function(module, exports) {

$parcel$export(module.exports, "subscribeToVisibilityChange", function () { return $ef2aa0f03b58d213$export$29e2367efc1f9a96; });
$parcel$export(module.exports, "subscribeToPageUnload", function () { return $ef2aa0f03b58d213$export$73368e3cf9be42f2; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $8FJov = parcelRequire("8FJov");
function $ef2aa0f03b58d213$export$29e2367efc1f9a96(cb, toHiddenOnly = false, capture, abortSignal) {
    (0, $8FJov.documentAddEventListener)('visibilitychange', handleVisibilityChange, capture, abortSignal);
    function handleVisibilityChange() {
        if (toHiddenOnly) {
            // trigger cb on change to hidden state only
            if (document.visibilityState === 'hidden') cb();
            return;
        }
        cb(document.visibilityState);
    }
}
function $ef2aa0f03b58d213$export$73368e3cf9be42f2(cb, capture, abortSignal) {
    (0, $8FJov.windowAddEventListener)('pagehide', cb, capture, abortSignal);
}

});

parcelRegister("gOaMh", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $c3c9ad14ea17967c$export$7e598866fa8de8d0; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $c3c9ad14ea17967c$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).pageViewTiming;

});

parcelRegister("hseEw", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("aCmou"),
    $parcel$import("1uHoI"),
    $parcel$import("5MKAi")
]).then(()=>parcelRequire('6XknC'));

});

parcelRegister("38uIx", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1uHoI"),
    $parcel$import("kY25b")
]).then(()=>parcelRequire('4ePKb'));

});

parcelRegister("3o0w7", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $277403a74b50a9af$export$7e598866fa8de8d0; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $277403a74b50a9af$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).jserrors;

});

parcelRegister("8KO5M", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $65f979dd468dc43f$export$fac44ee5b035f737; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $im7dd = parcelRequire("im7dd");
/**
 * Returns a function for use as a replacer parameter in JSON.stringify() to handle circular references.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value MDN - Cyclical object value}
 * @returns {Function} A function that filters out values it has seen before.
 */ const $65f979dd468dc43f$var$getCircularReplacer = ()=>{
    const seen = new WeakSet();
    return (key, value)=>{
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) return;
            seen.add(value);
        }
        return value;
    };
};
function $65f979dd468dc43f$export$fac44ee5b035f737(val) {
    try {
        return JSON.stringify(val, $65f979dd468dc43f$var$getCircularReplacer()) ?? '';
    } catch (e) {
        try {
            (0, $im7dd.ee).emit('internal-error', [
                e
            ]);
        } catch (err) {
        // do nothing
        }
        // return a string so that downstream users of the method do not throw errors
        return '';
    }
}

});

parcelRegister("cPnWJ", function(module, exports) {

$parcel$export(module.exports, "V2_TYPES", function () { return $956cd2aeaa6714a2$export$2323787878753776; });
$parcel$export(module.exports, "getRegisteredTargetsFromId", function () { return $956cd2aeaa6714a2$export$b93ac6320ad020a4; });
$parcel$export(module.exports, "getRegisteredTargetsFromFilename", function () { return $956cd2aeaa6714a2$export$3f1512647d6547b1; });
$parcel$export(module.exports, "getVersion2Attributes", function () { return $956cd2aeaa6714a2$export$cea0f42fe5ed2e75; });
$parcel$export(module.exports, "getVersion2DuplicationAttributes", function () { return $956cd2aeaa6714a2$export$396e4b7b0a7cddf1; });
$parcel$export(module.exports, "shouldDuplicate", function () { return $956cd2aeaa6714a2$export$38c0b00950e54dd6; });
$parcel$export(module.exports, "findTargetsFromStackTrace", function () { return $956cd2aeaa6714a2$export$106c26495c1cc744; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $dOQdv = parcelRequire("dOQdv");
const $956cd2aeaa6714a2$export$2323787878753776 = {
    /** Micro Frontend */ MFE: 'MFE',
    /** Browser Application */ BA: 'BA'
};
function $956cd2aeaa6714a2$export$b93ac6320ad020a4(id, agentRef) {
    if (!id || !agentRef?.init.api.register.enabled) return [];
    const registeredEntities = agentRef.runtime.registeredEntities;
    return registeredEntities?.filter((entity)=>String(entity.metadata.target.id) === String(id)).map((entity)=>entity.metadata.target) || [];
}
function $956cd2aeaa6714a2$export$3f1512647d6547b1(filename, agentRef) {
    if (!filename || !agentRef?.init.api.register.enabled) return [];
    const registeredEntities = agentRef.runtime.registeredEntities;
    return registeredEntities?.filter((entity)=>entity.metadata.timings?.asset?.endsWith(filename)).map((entity)=>entity.metadata.target) || [];
}
function $956cd2aeaa6714a2$export$cea0f42fe5ed2e75(target, aggregateInstance) {
    if (!$956cd2aeaa6714a2$var$supportsV2(aggregateInstance)) return {};
    const containerAgentEntityGuid = aggregateInstance.agentRef.runtime.appMetadata.agents[0].entityGuid;
    /** if there's no target, but we are in v2 mode, this means the data belongs to the container agent */ if (!target) return {
        'entity.guid': containerAgentEntityGuid,
        appId: aggregateInstance.agentRef.info.applicationID
    };
    /** otherwise, the data belongs to the target (MFE) and should be attributed as such */ return target.attributes;
}
function $956cd2aeaa6714a2$export$396e4b7b0a7cddf1(target, aggregateInstance) {
    if (!$956cd2aeaa6714a2$export$38c0b00950e54dd6(target, aggregateInstance)) return {};
    return {
        'child.id': target.id,
        'child.type': target.type,
        ...$956cd2aeaa6714a2$export$cea0f42fe5ed2e75(undefined, aggregateInstance)
    };
}
function $956cd2aeaa6714a2$export$38c0b00950e54dd6(target, aggregateInstance) {
    return !!target && !!$956cd2aeaa6714a2$var$supportsV2(aggregateInstance) && aggregateInstance.agentRef.init.api.register.duplicate_data_to_container;
}
function $956cd2aeaa6714a2$export$106c26495c1cc744(agentRef) {
    if (!agentRef?.init.api.register.enabled) return [
        undefined
    ];
    const targets = [];
    try {
        var urls = (0, $dOQdv.extractUrlsFromStack)((0, $dOQdv.getDeepStackTrace)());
        let iterator = urls.length - 1;
        while(urls[iterator])targets.push(...$956cd2aeaa6714a2$export$3f1512647d6547b1(urls[iterator--], agentRef));
    } catch (err) {
    // Silent catch to prevent errors from propagating
    }
    if (!targets.length) targets.push(undefined); // if we can't find any targets from the stack trace, return an array with undefined to signify the container agent is the target
    return targets;
}
/**
 * Determines if the aggregate instance supports version 2 of the harvest endpoint. Nearly all the V2 logic "depends" on
 * the harvest endpoint version, so this is the main gatekeeper method for whether or not V2 logic should be executed across the
 * various functions in this module.
 * @param {*} aggregateInstance The aggregate instance to check.
 * @returns {boolean} Returns true if the aggregate instance supports version 2, false otherwise.
 */ function $956cd2aeaa6714a2$var$supportsV2(aggregateInstance) {
    return aggregateInstance?.harvestEndpointVersion === 2;
}

});
parcelRegister("dOQdv", function(module, exports) {

$parcel$export(module.exports, "extractUrlsFromStack", function () { return $a0f8730dbb30d8a4$export$80850c39a1317c52; });
$parcel$export(module.exports, "getDeepStackTrace", function () { return $a0f8730dbb30d8a4$export$8c2515e94c6e2c50; });
$parcel$export(module.exports, "findScriptTimings", function () { return $a0f8730dbb30d8a4$export$13112c2e629682bb; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");

var $1Z3KE = parcelRequire("1Z3KE");

var $jWywI = parcelRequire("jWywI");

var $drC1B = parcelRequire("drC1B");

var $62Y8D = parcelRequire("62Y8D");
let $a0f8730dbb30d8a4$export$d532e9749719c1ea;
try {
    $a0f8730dbb30d8a4$export$d532e9749719c1ea = $a0f8730dbb30d8a4$export$80850c39a1317c52($a0f8730dbb30d8a4$export$8c2515e94c6e2c50())[0];
} catch (err) {
    $a0f8730dbb30d8a4$export$d532e9749719c1ea = $a0f8730dbb30d8a4$export$80850c39a1317c52(err)[0];
}
/** @type {(entry: PerformanceEntry) => boolean} - A shared function to determine if a performance entry is a valid script or link resource for evaluation */ const $a0f8730dbb30d8a4$var$validEntryCriteria = (entry)=>entry.initiatorType === 'script' || [
        'link',
        'fetch'
    ].includes(entry.initiatorType) && entry.name.endsWith('.js');
const $a0f8730dbb30d8a4$export$5812885d0c1c5481 = new Map();
/** @type {Array<{ test: (entry: PerformanceEntry) => boolean, addedAt: number }>} an array of PerformanceObserver subscribers to check for late emissions */ let $a0f8730dbb30d8a4$var$poSubscribers = [];
/**
 * Retrieves a script correlation by URL using exact matching
 * @param {string} targetUrl - The URL to find
 * @returns {ScriptCorrelation | undefined} - The correlation object if found
 */ function $a0f8730dbb30d8a4$var$findCorrelation(targetUrl) {
    return $a0f8730dbb30d8a4$export$5812885d0c1c5481.get(targetUrl);
}
/**
 * Gets or creates a script correlation entry
 * @param {string} url - The cleaned URL
 * @returns {ScriptCorrelation} - The correlation object
 */ function $a0f8730dbb30d8a4$var$getOrCreateCorrelation(url) {
    const existing = $a0f8730dbb30d8a4$var$findCorrelation(url);
    if (existing) return existing;
    const correlation = new (0, $62Y8D.ScriptCorrelation)(url);
    $a0f8730dbb30d8a4$export$5812885d0c1c5481.set(url, correlation);
    // Keep size under control
    if ($a0f8730dbb30d8a4$export$5812885d0c1c5481.size > 1000) {
        const firstKey = $a0f8730dbb30d8a4$export$5812885d0c1c5481.keys().next().value;
        $a0f8730dbb30d8a4$export$5812885d0c1c5481.delete(firstKey);
    }
    return correlation;
}
/** Set up a MutationObserver to detect script elements being added to the DOM */ if ((0, $9EKMI.globalScope).MutationObserver && (0, $9EKMI.globalScope).document) {
    const scriptMutationObserver = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            mutation.addedNodes.forEach((node)=>{
                if (node.nodeName === 'SCRIPT' && node.src) {
                    const cleanedSrc = (0, $jWywI.cleanURL)(node.src);
                    const correlation = $a0f8730dbb30d8a4$var$getOrCreateCorrelation(cleanedSrc);
                    correlation.dom.start = (0, $1Z3KE.now)();
                    correlation.dom.value = node;
                    const setEnd = ()=>{
                        correlation.dom.end = (0, $1Z3KE.now)();
                    };
                    [
                        'load',
                        'error'
                    ].forEach((event)=>node.addEventListener(event, setEnd, {
                            once: true
                        }));
                }
            });
        });
    });
    scriptMutationObserver.observe((0, $9EKMI.globalScope).document, {
        childList: true,
        subtree: true
    });
}
if ((0, $9EKMI.globalScope).PerformanceObserver?.supportedEntryTypes.includes('resource')) {
    /** We must track the script assets this way, because the performance buffer can fill up and when it does that
   * it stops accepting new entries (instead of dropping old entries), which means if the register API is called
   * after the buffer fills up we won't be able to get the script timing information from the resource timing API
  */ const scriptObserver = new PerformanceObserver((list)=>{
        list.getEntries().filter($a0f8730dbb30d8a4$var$validEntryCriteria).forEach((entry)=>{
            // Update correlation with performance data (creates entry if needed)
            const entryUrl = (0, $jWywI.cleanURL)(entry.name);
            const correlation = $a0f8730dbb30d8a4$var$getOrCreateCorrelation(entryUrl);
            correlation.performance.start = Math.floor(entry.startTime);
            correlation.performance.end = Math.floor(entry.responseEnd);
            correlation.performance.value = entry;
            // Clear resolved or expired subscribers
            const canClear = [];
            $a0f8730dbb30d8a4$var$poSubscribers.forEach(({ test: test, addedAt: addedAt }, idx)=>{
                if (test(entry) || (0, $1Z3KE.now)() - addedAt > 10000) canClear.push(idx);
            });
            $a0f8730dbb30d8a4$var$poSubscribers = $a0f8730dbb30d8a4$var$poSubscribers.filter((_, idx)=>!canClear.includes(idx));
        });
    });
    scriptObserver.observe({
        type: 'resource',
        buffered: true
    });
}
function $a0f8730dbb30d8a4$export$80850c39a1317c52(stack) {
    if (!stack || typeof stack !== 'string') return [];
    const urls = new Set();
    const lines = stack.split('\n');
    for (const line of lines){
        // Try gecko format first, then chrome
        const parts = line.match((0, $drC1B.gecko)) || line.match((0, $drC1B.chrome)) || line.match((0, $drC1B.chromeEval));
        if (parts && parts[2]) urls.add((0, $jWywI.cleanURL)(parts[2]));
        else {
            // Fallback: match URLs using a generic .js pattern (non-greedy to handle ports and query params)
            const fallbackMatch = line.match(/\(([^)]+\.js):\d+:\d+\)/) || line.match(/^\s+at\s+([^\s(]+\.js):\d+:\d+/);
            if (fallbackMatch && fallbackMatch[1]) urls.add((0, $jWywI.cleanURL)(fallbackMatch[1]));
        }
    }
    return [
        ...urls
    ];
}
function $a0f8730dbb30d8a4$export$8c2515e94c6e2c50() {
    let stack;
    try {
        const originalStackLimit = Error.stackTraceLimit;
        Error.stackTraceLimit = 50;
        stack = new Error().stack;
        Error.stackTraceLimit = originalStackLimit;
    } catch (e) {
        stack = new Error().stack;
    }
    return stack;
}
/**
 * Indicates whether the provided URL matches any script preload link tags in the document.
 * @param {string} targetUrl The URL to match against preload tags
 * @returns {boolean} True if a matching preload link is found, false otherwise
 */ function $a0f8730dbb30d8a4$var$wasPreloaded(targetUrl) {
    if (!targetUrl || !(0, $9EKMI.globalScope).document) return false;
    try {
        const linkTags = (0, $9EKMI.globalScope).document.querySelectorAll('link[rel="preload"][as="script"]');
        for (const link of linkTags){
            // link.href is resolved to an absolute URL by the browser (even if supplied as relative), so we can match exactly against the cleaned target URL
            if ((0, $jWywI.cleanURL)(link.href) === targetUrl) return true;
        }
    } catch (error) {
    // Don't let DOM parsing errors break anything
    }
    return false;
}
/**
 * Checks if a performance entry matches the target MFE script URL using exact matching
 * @param {PerformanceResourceTiming} entry - The resource timing entry
 * @param {string} targetUrl - The MFE script URL to match
 * @returns {boolean} True if the entry matches
 */ function $a0f8730dbb30d8a4$var$entryMatchesUrl(entry, targetUrl) {
    const entryUrl = (0, $jWywI.cleanURL)(entry.name);
    return entryUrl === targetUrl;
}
/**
 * Applies performance entry timing data to a timings object
 * @param {RegisterAPITimings} timings - The timings object to update
 * @param {PerformanceResourceTiming} entry - The performance entry
 */ function $a0f8730dbb30d8a4$var$applyPerformanceEntry(timings, entry) {
    timings.fetchStart = Math.floor(entry.startTime);
    timings.fetchEnd = Math.floor(entry.responseEnd);
    timings.asset = entry.name;
    timings.type = entry.initiatorType;
}
function $a0f8730dbb30d8a4$export$13112c2e629682bb() {
    const timings = {
        registeredAt: (0, $1Z3KE.now)(),
        reportedAt: undefined,
        fetchStart: 0,
        fetchEnd: 0,
        scriptStart: 0,
        scriptEnd: 0,
        asset: undefined,
        type: 'unknown'
    };
    const stack = $a0f8730dbb30d8a4$export$8c2515e94c6e2c50();
    if (!stack) return timings;
    const navUrl = (0, $9EKMI.globalScope).performance?.getEntriesByType('navigation')?.[0]?.name || '';
    try {
        const urls = $a0f8730dbb30d8a4$export$80850c39a1317c52(stack);
        // Filter out agent file from URLs (unless it's the only one)
        const mfeScriptUrl = (urls.length > 1 ? urls.filter((line)=>$a0f8730dbb30d8a4$export$d532e9749719c1ea !== line) : urls)[0];
        if (!mfeScriptUrl) return timings;
        // Check for inline script
        if (navUrl.includes(mfeScriptUrl)) {
            timings.asset = (0, $jWywI.cleanURL)(navUrl);
            timings.type = 'inline';
            return timings;
        }
        // Get correlation data
        timings.correlation = $a0f8730dbb30d8a4$var$findCorrelation(mfeScriptUrl);
        // Use correlation's performance entry if available, otherwise check live performance API
        const performanceEntry = timings.correlation?.performance.value || performance.getEntriesByType('resource').find((e)=>$a0f8730dbb30d8a4$var$entryMatchesUrl(e, mfeScriptUrl));
        if (performanceEntry) $a0f8730dbb30d8a4$var$applyPerformanceEntry(timings, performanceEntry);
        else if ($a0f8730dbb30d8a4$var$wasPreloaded(mfeScriptUrl)) {
            // Handle preloaded scripts that may report late
            timings.asset = mfeScriptUrl;
            timings.type = 'preload';
            // Subscribe to late performance observer callbacks
            $a0f8730dbb30d8a4$var$poSubscribers.push({
                addedAt: (0, $1Z3KE.now)(),
                test: (entry)=>{
                    if ($a0f8730dbb30d8a4$var$entryMatchesUrl(entry, mfeScriptUrl)) {
                        $a0f8730dbb30d8a4$var$applyPerformanceEntry(timings, entry);
                        return true;
                    }
                    return false;
                }
            });
        }
        /*
     * Use getters here because the correlation data may arrive after this function returns the timing object, and we want to provide the most up-to-date timing information possible when the getters are accessed at harvest time.
     * The getters will fall back to fetchEnd if correlation data isn't available yet, which is our best approximation for script execution start when actual script timings can not be determined.
    */ Object.defineProperty(timings, 'scriptStart', {
            get: ()=>timings.correlation?.script.start || timings.fetchEnd
        });
        Object.defineProperty(timings, 'scriptEnd', {
            get: ()=>timings.correlation?.script.end || timings.registeredAt
        });
    } catch (error) {
    // Don't let stack parsing errors break anything
    }
    return timings;
}

});
parcelRegister("jWywI", function(module, exports) {

$parcel$export(module.exports, "cleanURL", function () { return $e84e376152b75432$export$c13cda99ef5646fc; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $e84e376152b75432$var$patternWithHash = /([^?#]*)[^#]*(#[^?]*|$).*/;
var $e84e376152b75432$var$patternWithoutHash = /([^?#]*)().*/;
function $e84e376152b75432$export$c13cda99ef5646fc(url, keepHash) {
    if (!url) return url;
    return url.replace(keepHash ? $e84e376152b75432$var$patternWithHash : $e84e376152b75432$var$patternWithoutHash, '$1$2');
}

});

parcelRegister("drC1B", function(module, exports) {

$parcel$export(module.exports, "classNameRegex", function () { return $9c9b4aee2327f6cc$export$ff1367d11ec55999; });
$parcel$export(module.exports, "chromeEval", function () { return $9c9b4aee2327f6cc$export$da50b9d88964f402; });
$parcel$export(module.exports, "ieEval", function () { return $9c9b4aee2327f6cc$export$9cf429520b44358a; });
$parcel$export(module.exports, "chrome", function () { return $9c9b4aee2327f6cc$export$7b60a2159daa9614; });
$parcel$export(module.exports, "gecko", function () { return $9c9b4aee2327f6cc$export$249f5a6e3b293e58; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ const $9c9b4aee2327f6cc$export$ff1367d11ec55999 = /function (.+?)\s*\(/;
const $9c9b4aee2327f6cc$export$da50b9d88964f402 = /^\s*at .+ \(eval at \S+ \((?:(?:file|http|https):[^)]+)?\)(?:, [^:]*:\d+:\d+)?\)$/i;
const $9c9b4aee2327f6cc$export$9cf429520b44358a = /^\s*at Function code \(Function code:\d+:\d+\)\s*/i;
const $9c9b4aee2327f6cc$export$7b60a2159daa9614 = /^\s*at (?:((?:\[object object\])?(?:[^(]*\([^)]*\))*[^()]*(?: \[as \S+\])?) )?\(?((?:file|http|https|chrome-extension):.*?)?:(\d+)(?::(\d+))?\)?\s*$/i;
const $9c9b4aee2327f6cc$export$249f5a6e3b293e58 = /^\s*(?:([^@]*)(?:\(.*?\))?@)?((?:file|http|https|chrome|safari-extension).*?):(\d+)(?::(\d+))?\s*$/i;

});

parcelRegister("62Y8D", function(module, exports) {

$parcel$export(module.exports, "ScriptCorrelation", function () { return $4671943080bacff4$export$ef9cae332e81cb95; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Represents script correlation data combining DOM and Performance API information
 */ class $4671943080bacff4$export$ef9cae332e81cb95 {
    /** @type {CorrelationTiming} [dom] - DOM-related information */ dom = new $4671943080bacff4$var$CorrelationTiming();
    /** @type {CorrelationTiming} [performance] - Performance-related information */ performance = new $4671943080bacff4$var$CorrelationTiming();
    /**
   * Creates a new ScriptCorrelation instance
   * @param {string} url - The cleaned URL of the script
   */ constructor(url){
        /** @type {string} The cleaned URL of the script */ this.url = url;
    }
    /**
   * Gets the script timing, using DOM timings if available, otherwise falling back to performance timings or registeredAt as appropriate. This is used to provide the most accurate script timing possible for registered entities.
   * @returns {{start: number, end: number}
   */ get script() {
        const start = Math.max(this.dom.start, this.performance.end);
        const end = Math.max(this.dom.end, this.performance.end, start);
        return {
            start: start,
            end: end
        };
    }
}
class $4671943080bacff4$var$CorrelationTiming {
    /** @type {number} [start] - The startTime from the performance entry */ start = 0;
    /** @type {number} [end] - The responseEnd from the performance entry */ end = 0;
    /** @type {*} [value] - The entry value */ value = undefined;
}

});



parcelRegister("9RUUB", function(module, exports) {

$parcel$export(module.exports, "LOG_LEVELS", function () { return $72f535d3b8830918$export$8a0bf1eafa288f88; });
$parcel$export(module.exports, "LOGGING_MODE", function () { return $72f535d3b8830918$export$12972ee34ff5a6de; });
$parcel$export(module.exports, "LOGGING_EVENT_EMITTER_CHANNEL", function () { return $72f535d3b8830918$export$cd2ef9233cc88578; });
$parcel$export(module.exports, "FEATURE_NAME", function () { return $72f535d3b8830918$export$7e598866fa8de8d0; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $72f535d3b8830918$export$8a0bf1eafa288f88 = {
    ERROR: 'ERROR',
    WARN: 'WARN',
    INFO: 'INFO',
    DEBUG: 'DEBUG',
    TRACE: 'TRACE'
};
const $72f535d3b8830918$export$12972ee34ff5a6de = {
    OFF: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3,
    DEBUG: 4,
    TRACE: 5
};
const $72f535d3b8830918$export$cd2ef9233cc88578 = 'log';
const $72f535d3b8830918$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).logging;

});

parcelRegister("8FTye", function(module, exports) {

$parcel$export(module.exports, "bufferLog", function () { return $650d3e5c17ee299f$export$2f558c5a57582c83; });
$parcel$export(module.exports, "isValidLogLevel", function () { return $650d3e5c17ee299f$export$eccb56b396694af1; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $1Z3KE = parcelRequire("1Z3KE");

var $3R40a = parcelRequire("3R40a");

var $bu0p3 = parcelRequire("bu0p3");

var $9RUUB = parcelRequire("9RUUB");
function $650d3e5c17ee299f$export$2f558c5a57582c83(ee, message, customAttributes = {}, level = (0, $9RUUB.LOG_LEVELS).INFO, autoCaptured = true, targets, timestamp = (0, $1Z3KE.now)()) {
    (0, $gy0pT.handle)((0, $bu0p3.SUPPORTABILITY_METRIC_CHANNEL), [
        "API/logging/".concat(level.toLowerCase(), "/called")
    ], undefined, (0, $3R40a.FEATURE_NAMES).metrics, ee);
    (0, $gy0pT.handle)((0, $9RUUB.LOGGING_EVENT_EMITTER_CHANNEL), [
        timestamp,
        message,
        customAttributes,
        level,
        autoCaptured,
        targets
    ], undefined, (0, $3R40a.FEATURE_NAMES).logging, ee);
}
function $650d3e5c17ee299f$export$eccb56b396694af1(level) {
    if (typeof level !== 'string') return false;
    return Object.values((0, $9RUUB.LOG_LEVELS)).some((logLevel)=>logLevel === level.toUpperCase().trim());
}

});

parcelRegister("5C29L", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1uHoI"),
    $parcel$import("7Z7gv")
]).then(()=>parcelRequire('bIXwV'));

});

parcelRegister("32kbo", function(module, exports) {

$parcel$export(module.exports, "wrapEvents", function () { return $236136e633000dfd$export$27a5dfcd59102a7c; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Wraps `addEventListener` and `removeEventListener` for instrumentation.
 * This module is used directly by: session_trace.
 * It is also called by -> wrapXhr <-, so see "wrap-xhr.js" for features that use this indirectly.
 */ 
var $im7dd = parcelRequire("im7dd");

var $gRz07 = parcelRequire("gRz07");

var $iGnFd = parcelRequire("iGnFd");

var $9EKMI = parcelRequire("9EKMI");
const $236136e633000dfd$var$wrapped = {};
const $236136e633000dfd$var$XHR = (0, $9EKMI.globalScope).XMLHttpRequest;
const $236136e633000dfd$var$ADD_EVENT_LISTENER = 'addEventListener';
const $236136e633000dfd$var$REMOVE_EVENT_LISTENER = 'removeEventListener';
const $236136e633000dfd$var$flag = "nr@wrapped:".concat((0, $im7dd.contextId));
function $236136e633000dfd$export$27a5dfcd59102a7c(sharedEE) {
    var ee = $236136e633000dfd$export$b88e0ef4192fcaff(sharedEE);
    // Notice if our wrapping never ran yet, the falsy NaN will not early return; but if it has,
    // then we increment the count to track # of feats using this at runtime.
    if ($236136e633000dfd$var$wrapped[ee.debugId]++) return ee;
    $236136e633000dfd$var$wrapped[ee.debugId] = 1; // otherwise, first feature to wrap events
    var wrapFn = (0, $gRz07.createWrapperWithEmitter)(ee, true);
    // Guard against instrumenting environments w/o necessary features
    if ('getPrototypeOf' in Object) {
        if (0, $9EKMI.isBrowserScope) $236136e633000dfd$var$findEventListenerProtoAndCb(document, wrapNode);
        if ($236136e633000dfd$var$XHR) $236136e633000dfd$var$findEventListenerProtoAndCb($236136e633000dfd$var$XHR.prototype, wrapNode);
        $236136e633000dfd$var$findEventListenerProtoAndCb((0, $9EKMI.globalScope), wrapNode);
    }
    ee.on($236136e633000dfd$var$ADD_EVENT_LISTENER + '-start', function(args, target) {
        var originalListener = args[1];
        if (originalListener === null || typeof originalListener !== 'function' && typeof originalListener !== 'object' || args[0] === 'newrelic' // ignore our own window events
        ) return;
        var wrapped = (0, $iGnFd.getOrSet)(originalListener, $236136e633000dfd$var$flag, function() {
            var listener = {
                object: wrapHandleEvent,
                function: originalListener
            }[typeof originalListener];
            return listener ? wrapFn(listener, 'fn-', null, listener.name || 'anonymous') : originalListener;
            function wrapHandleEvent() {
                if (typeof originalListener.handleEvent !== 'function') return;
                return originalListener.handleEvent.apply(originalListener, arguments);
            }
        });
        this.wrapped = args[1] = wrapped;
    });
    ee.on($236136e633000dfd$var$REMOVE_EVENT_LISTENER + '-start', function(args) {
        args[1] = this.wrapped || args[1];
    });
    function wrapNode(node) {
        wrapFn.inPlace(node, [
            $236136e633000dfd$var$ADD_EVENT_LISTENER,
            $236136e633000dfd$var$REMOVE_EVENT_LISTENER
        ], '-', uniqueListener);
    }
    function uniqueListener(args, obj) {
        // Context for the listener is stored on itself.
        return args[1];
    }
    return ee;
}
/**
 * Find the base prototype of 'object' that has its own "addEventListener" property, and run some function on it.
 * @param {Object} object - the initial object to traverse prototype chain on
 * @param {Function} cb - the function to run on the ancestral object once found, accepts an object as a arg
 * @param {Array} rest - [optional] any additional arguments to pass to the cb
 */ function $236136e633000dfd$var$findEventListenerProtoAndCb(object, cb, ...rest) {
    let step = object;
    while(typeof step === 'object' && !Object.prototype.hasOwnProperty.call(step, $236136e633000dfd$var$ADD_EVENT_LISTENER))step = Object.getPrototypeOf(step);
    if (step) cb(step, ...rest);
}
function $236136e633000dfd$export$b88e0ef4192fcaff(sharedEE) {
    return (sharedEE || (0, $im7dd.ee)).get('events');
}

});
parcelRegister("gRz07", function(module, exports) {

$parcel$export(module.exports, "flag", function () { return $c46cbf06d3cfdedb$export$42405f212471e8a2; });
$parcel$export(module.exports, "createWrapperWithEmitter", function () { return $c46cbf06d3cfdedb$export$154496d12bf0944f; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Provides helper functions for wrapping functions in various scenarios.
 */ 
var $im7dd = parcelRequire("im7dd");

var $3Nvam = parcelRequire("3Nvam");

var $cPnWJ = parcelRequire("cPnWJ");
const $c46cbf06d3cfdedb$export$42405f212471e8a2 = "nr@original:".concat((0, $3Nvam.bundleId));
const $c46cbf06d3cfdedb$var$LONG_TASK_THRESHOLD = 50;
/**
 * A convenience alias of `hasOwnProperty`.
 * @type {function}
 */ var $c46cbf06d3cfdedb$var$has = Object.prototype.hasOwnProperty;
/**
 * For tracking whether an event is already being emitted inside the wrapper.
 * @type {boolean}
 */ var $c46cbf06d3cfdedb$var$inWrapper = false;
var // eslint-disable-next-line
$c46cbf06d3cfdedb$export$2e2bcd8739ae039 = $c46cbf06d3cfdedb$export$154496d12bf0944f;
function $c46cbf06d3cfdedb$export$154496d12bf0944f(emitter, always, agentRef) {
    emitter || (emitter = (0, $im7dd.ee));
    wrapFn.inPlace = inPlace;
    /**
   * A flag used to determine if a native function has already been wrapped.
   * As a property on a wrapped function, contains the original function.
   * @type {string}
   */ wrapFn.flag = $c46cbf06d3cfdedb$export$42405f212471e8a2;
    return wrapFn;
    /**
   * Wraps a function with event emitting functionality.
   * @param {function} fn - The function to wrap.
   * @param {string} prefix - A prefix for the names of emitted events.
   * @param {function|object} getContext - The function or object that will serve as the 'this' context for handlers of events emitted by this wrapper.
   * @param {string} methodName - The name of the method being wrapped.
   * @param {boolean} bubble - If true, emitted events should also bubble up to the old emitter upon which the `emitter` in the current scope was based (if it defines one).
   * @param {boolean} [evaluateStack] - If true, the wrapper will attempt to evaluate the stack of the executed wrapped function to find targets of the execution (ex. the MFE source of a console.log).
   * @returns {function} The wrapped function.
   */ function wrapFn(fn, prefix, getContext, methodName, bubble, evaluateStack) {
        // Unless fn is both wrappable and unwrapped, return it unchanged.
        if ($c46cbf06d3cfdedb$var$notWrappable(fn)) return fn;
        if (!prefix) prefix = '';
        nrWrapper[$c46cbf06d3cfdedb$export$42405f212471e8a2] = fn;
        $c46cbf06d3cfdedb$export$784d13d8ee351f07(fn, nrWrapper, emitter);
        return nrWrapper;
        /**
     * A wrapper function that emits events before and after calling the wrapped function.
     * Any arguments will be passed along to the original function.
     * @returns {any} The return value of the wrapped function.
     */ function nrWrapper() {
            var args;
            var originalThis;
            var ctx;
            var result;
            let thrownError;
            let targets;
            try {
                originalThis = this;
                args = [
                    ...arguments
                ];
                // certain wrappers can inform the function wrapper to evaluate the stack of the executed wrapped function to find targets of the execution
                // (e.g. wrap-logger can inform this method to find try to find the MFE source of a console.log)
                targets = evaluateStack ? (0, $cPnWJ.findTargetsFromStackTrace)(agentRef) : [
                    undefined
                ]; // undefined target always maps to the container agent
                if (typeof getContext === 'function') ctx = getContext(args, originalThis);
                else ctx = getContext || {};
            } catch (e) {
                $c46cbf06d3cfdedb$var$report([
                    e,
                    '',
                    [
                        args,
                        originalThis,
                        methodName
                    ],
                    ctx
                ], emitter);
            }
            // Warning: start events may mutate args!
            safeEmit(prefix + 'start', [
                args,
                originalThis,
                methodName,
                targets
            ], ctx, bubble);
            const fnStartTime = performance.now();
            let fnEndTime;
            try {
                result = fn.apply(originalThis, args);
                fnEndTime = performance.now();
                return result;
            } catch (err) {
                fnEndTime = performance.now();
                safeEmit(prefix + 'err', [
                    args,
                    originalThis,
                    err,
                    targets
                ], ctx, bubble);
                // rethrow error so we don't effect execution by observing.
                thrownError = err;
                throw thrownError;
            } finally{
                const duration = fnEndTime - fnStartTime;
                const task = {
                    start: fnStartTime,
                    end: fnEndTime,
                    duration: duration,
                    isLongTask: duration >= $c46cbf06d3cfdedb$var$LONG_TASK_THRESHOLD,
                    methodName: methodName,
                    thrownError: thrownError
                };
                // standalone long task message
                if (task.isLongTask) safeEmit('long-task', [
                    task,
                    originalThis,
                    targets
                ], ctx, bubble);
                // -end message also includes the task execution info
                safeEmit(prefix + 'end', [
                    args,
                    originalThis,
                    result,
                    targets
                ], ctx, bubble);
            }
        }
    }
    /**
   * Creates wrapper functions around each of an array of methods on a specified object.
   * @param {Object} obj The object to which the specified methods belong.
   * @param {string[]} methods An array of method names to be wrapped.
   * @param {string} [prefix=''] A prefix to add to the names of emitted events. If `-` is the first character, also
   * adds the method name before the prefix.
   * @param {function|object} [getContext] The function or object that will serve as the 'this' context for handlers
   * of events emitted by this wrapper.
   * @param {boolean} [bubble=false] If `true`, emitted events should also bubble up to the old emitter upon which
   * the `emitter` in the current scope was based (if it defines one).
   */ function inPlace(obj, methods, prefix, getContext, bubble, evaluateStack) {
        if (!prefix) prefix = '';
        // If prefix starts with '-' set this boolean to add the method name to the prefix before passing each one to wrap.
        const prependMethodPrefix = prefix.charAt(0) === '-';
        for(let i = 0; i < methods.length; i++){
            const method = methods[i];
            const fn = obj[method];
            // Unless fn is both wrappable and unwrapped, bail so we don't add extra properties with undefined values.
            if ($c46cbf06d3cfdedb$var$notWrappable(fn)) continue;
            obj[method] = wrapFn(fn, prependMethodPrefix ? method + prefix : prefix, getContext, method, bubble, evaluateStack);
        }
    }
    /**
   * Emits an event using the `emit` method of the `emitter` object in the executing scope, but only if an event is not
   * already being emitted (except when the executing scope defines `always` as `true`).
   * @param {string} evt - The name of the event to be emitted.
   * @param {array} arr - An array of arguments to pass with the event.
   * @param {Object} store - The function or object that will serve as the 'this'
   *     context when applying handler functions for this event.
   * @param {boolean} bubble - If `true`, emitted events should also
   *     bubble up to the old emitter upon which the `emitter` in the
   *     executing scope was based (if it defines one).
   */ function safeEmit(evt, arr, store, bubble) {
        if ($c46cbf06d3cfdedb$var$inWrapper && !always) return;
        var prev = $c46cbf06d3cfdedb$var$inWrapper;
        $c46cbf06d3cfdedb$var$inWrapper = true;
        try {
            emitter.emit(evt, arr, store, always, bubble);
        } catch (e) {
            $c46cbf06d3cfdedb$var$report([
                e,
                evt,
                arr,
                store
            ], emitter);
        }
        $c46cbf06d3cfdedb$var$inWrapper = prev;
    }
}
/**
 * Emits an "internal-error" event. Used to report errors encountered when emitting events using `safeEmit`.
 * @param {array} args - Arguments to be passed to the "internal-error" event.
 * @param {Object} [emitter] - The (optional) desired event emitter. Defaults to the global event emitter.
 */ function $c46cbf06d3cfdedb$var$report(args, emitter) {
    emitter || (emitter = (0, $im7dd.ee));
    try {
        emitter.emit('internal-error', args);
    } catch (err) {
    // do nothing
    }
}
function $c46cbf06d3cfdedb$export$784d13d8ee351f07(from, to, emitter) {
    if (Object.defineProperty && Object.keys) // Create accessors that proxy to actual function
    try {
        var keys = Object.keys(from);
        // eslint-disable-next-line
        keys.forEach(function(key) {
            Object.defineProperty(to, key, {
                get: function() {
                    return from[key];
                },
                // eslint-disable-next-line
                set: function(val) {
                    from[key] = val;
                    return val;
                }
            });
        });
        return to;
    } catch (e) {
        $c46cbf06d3cfdedb$var$report([
            e
        ], emitter);
    }
    // fall back to copying properties
    for(var i in from)if ($c46cbf06d3cfdedb$var$has.call(from, i)) to[i] = from[i];
    return to;
}
/**
 * Determines whether a function is eligible to be wrapped in part based on whether it has already been wrapped.
 * @param {function} fn - The function in question.
 * @returns {boolean} Whether the passed function is ineligible to be wrapped.
 */ function $c46cbf06d3cfdedb$var$notWrappable(fn) {
    return !(fn && typeof fn === 'function' && fn.apply && !fn[$c46cbf06d3cfdedb$export$42405f212471e8a2]);
}

});


parcelRegister("5qa2T", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $3f272c55aaa7b932$export$7a5253c0f62e0150; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");
function $3f272c55aaa7b932$export$7a5253c0f62e0150(url) {
    // Return if URL is a data URL, parseUrl assumes urls are http/https
    if ((url || '').indexOf('data:') === 0) return {
        protocol: 'data'
    };
    try {
        const parsedUrl = new URL(url, location.href);
        const returnVal = {
            port: parsedUrl.port,
            hostname: parsedUrl.hostname,
            pathname: parsedUrl.pathname,
            search: parsedUrl.search,
            protocol: parsedUrl.protocol.slice(0, parsedUrl.protocol.indexOf(':')),
            sameOrigin: parsedUrl.protocol === (0, $9EKMI.globalScope)?.location?.protocol && parsedUrl.host === (0, $9EKMI.globalScope)?.location?.host
        };
        if (!returnVal.port || returnVal.port === '') {
            if (parsedUrl.protocol === 'http:') returnVal.port = '80';
            if (parsedUrl.protocol === 'https:') returnVal.port = '443';
        }
        if (!returnVal.pathname || returnVal.pathname === '') returnVal.pathname = '/';
        else if (!returnVal.pathname.startsWith('/')) returnVal.pathname = "/".concat(returnVal.pathname);
        return returnVal;
    } catch (err) {
        return {};
    }
}

});

parcelRegister("e2uyi", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $a388f39adcb36998$export$7e598866fa8de8d0; });
$parcel$export(module.exports, "AJAX_ID", function () { return $a388f39adcb36998$export$a69d58745c04adca; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $a388f39adcb36998$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).ajax;
const $a388f39adcb36998$export$a69d58745c04adca = 'ajaxRequest.id';

});

parcelRegister("9ZQLQ", function(module, exports) {

$parcel$export(module.exports, "shouldCollectEvent", function () { return $7472beb54fba4b8e$export$82663275b5f3dc0e; });
$parcel$export(module.exports, "hasUndefinedHostname", function () { return $7472beb54fba4b8e$export$6597dd2c505adbe7; });
$parcel$export(module.exports, "setDenyList", function () { return $7472beb54fba4b8e$export$2b1175d1e776daf9; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * An array of filter objects {hostname, pathname} for identifying XHR events to be excluded from collection.
 * @see {@link https://docs.newrelic.com/docs/browser/new-relic-browser/configuration/filter-ajax-request-events/ Filter AjaxRequest events}
 * @type {Array.<{hostname: string, pathname: string}>}
 */ var $7472beb54fba4b8e$var$denyList = [];
function $7472beb54fba4b8e$export$82663275b5f3dc0e(params) {
    if (!params || $7472beb54fba4b8e$export$6597dd2c505adbe7(params)) return false;
    if ($7472beb54fba4b8e$var$denyList.length === 0) return true;
    // short circuit if deny list contains just a wildcard
    if ($7472beb54fba4b8e$var$denyList[0].hostname === '*') return false;
    for(var i = 0; i < $7472beb54fba4b8e$var$denyList.length; i++){
        var parsed = $7472beb54fba4b8e$var$denyList[i];
        if (parsed.hostname.test(params.hostname) && parsed.pathname.test(params.pathname)) return false;
    }
    return true;
}
function $7472beb54fba4b8e$export$6597dd2c505adbe7(params) {
    return params.hostname === undefined; // requests with an undefined hostname (e.g., data URLs) should not be collected.
}
function $7472beb54fba4b8e$export$2b1175d1e776daf9(denyListConfig) {
    $7472beb54fba4b8e$var$denyList = [];
    if (!denyListConfig || !denyListConfig.length) return;
    for(var i = 0; i < denyListConfig.length; i++){
        let url = denyListConfig[i];
        if (!url) continue; // ignore bad values like undefined or empty strings
        // short circuit if deny list entry is just a wildcard
        if (url === '*') {
            $7472beb54fba4b8e$var$denyList = [
                {
                    hostname: '*'
                }
            ];
            return;
        }
        if (url.indexOf('http://') === 0) url = url.substring(7);
        else if (url.indexOf('https://') === 0) url = url.substring(8);
        const firstSlash = url.indexOf('/');
        let host, pathname;
        if (firstSlash > 0) {
            host = url.substring(0, firstSlash);
            pathname = url.substring(firstSlash);
        } else {
            host = url;
            pathname = '*';
        }
        let [hostname] = host.split(':');
        $7472beb54fba4b8e$var$denyList.push({
            hostname: $7472beb54fba4b8e$var$convertToRegularExpression(hostname),
            pathname: $7472beb54fba4b8e$var$convertToRegularExpression(pathname, true)
        });
    }
}
/**
 * Converts a deny list filter string into a regular expression object with wildcard support
 * @param {string} filter - deny list filter to convert
 * @param {boolean} [isPathname=false] - indicates if the filter is a pathname
 * @returns {RegExp} - regular expression object built from the input string
 */ function $7472beb54fba4b8e$var$convertToRegularExpression(filter, isPathname = false) {
    const newFilter = filter.replace(/[.+?^${}()|[\]\\]/g, (m)=>'\\' + m) // use a replacer function to not break apm injection
    .replace(/\*/g, '.*?'); // use lazy matching instead of greedy
    return new RegExp((isPathname ? '^' : '') + newFilter + '\x24'); // x24 == $, but using a literal $ causes webpack to to break when building unminified
}

});

parcelRegister("k6inY", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1uHoI"),
    $parcel$import("any70")
]).then(()=>parcelRequire('iaK9r'));

});

parcelRegister("adIx8", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $770da9b4e441bc23$export$7e598866fa8de8d0; });
$parcel$export(module.exports, "BST_RESOURCE", function () { return $770da9b4e441bc23$export$db89487524ba94f3; });
$parcel$export(module.exports, "RESOURCE", function () { return $770da9b4e441bc23$export$84ba8fa7099b85b; });
$parcel$export(module.exports, "START", function () { return $770da9b4e441bc23$export$21c466265830bc3a; });
$parcel$export(module.exports, "END", function () { return $770da9b4e441bc23$export$32239d68d9c6cb49; });
$parcel$export(module.exports, "FN_START", function () { return $770da9b4e441bc23$export$e2cee5a527844a50; });
$parcel$export(module.exports, "FN_END", function () { return $770da9b4e441bc23$export$434fb1ee9bc02f03; });
$parcel$export(module.exports, "PUSH_STATE", function () { return $770da9b4e441bc23$export$27879af501b2d964; });
$parcel$export(module.exports, "MAX_NODES_PER_HARVEST", function () { return $770da9b4e441bc23$export$638d2c65e6bded32; });
$parcel$export(module.exports, "ERROR_MODE_SECONDS_WINDOW", function () { return $770da9b4e441bc23$export$b9b4151d6f1df154; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $770da9b4e441bc23$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).sessionTrace;
const $770da9b4e441bc23$export$db89487524ba94f3 = 'bstResource';
const $770da9b4e441bc23$export$84ba8fa7099b85b = 'resource';
const $770da9b4e441bc23$export$21c466265830bc3a = '-start';
const $770da9b4e441bc23$export$32239d68d9c6cb49 = '-end';
const $770da9b4e441bc23$export$e2cee5a527844a50 = 'fn' + $770da9b4e441bc23$export$21c466265830bc3a;
const $770da9b4e441bc23$export$434fb1ee9bc02f03 = 'fn' + $770da9b4e441bc23$export$32239d68d9c6cb49;
const $770da9b4e441bc23$export$27879af501b2d964 = 'pushState';
const $770da9b4e441bc23$export$638d2c65e6bded32 = 1000;
const $770da9b4e441bc23$export$b9b4151d6f1df154 = 30000; // sliding window of nodes to track when simply monitoring (but not harvesting) in error mode

});

parcelRegister("grVnN", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1uHoI"),
    $parcel$import("iL0y8")
]).then(()=>parcelRequire('9ckjO'));

});

parcelRegister("6bsRh", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $480a27d1927d6d2f$export$7e598866fa8de8d0; });
$parcel$export(module.exports, "ERROR_DURING_REPLAY", function () { return $480a27d1927d6d2f$export$12971df8bc161378; });
$parcel$export(module.exports, "AVG_COMPRESSION", function () { return $480a27d1927d6d2f$export$8c217bbcf900228c; });
$parcel$export(module.exports, "RRWEB_EVENT_TYPES", function () { return $480a27d1927d6d2f$export$efb5de2debaf223; });
$parcel$export(module.exports, "CHECKOUT_MS", function () { return $480a27d1927d6d2f$export$763b0576de6114e0; });
$parcel$export(module.exports, "ABORT_REASONS", function () { return $480a27d1927d6d2f$export$76a4a93d70902add; });
$parcel$export(module.exports, "QUERY_PARAM_PADDING", function () { return $480a27d1927d6d2f$export$1c29e1fd3b9f241d; });
$parcel$export(module.exports, "TRIGGERS", function () { return $480a27d1927d6d2f$export$709baa12d4a9776d; });
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $44Lnf = parcelRequire("44Lnf");

var $3R40a = parcelRequire("3R40a");
const $480a27d1927d6d2f$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).sessionReplay;
const $480a27d1927d6d2f$export$12971df8bc161378 = 'errorDuringReplay';
const $480a27d1927d6d2f$export$8c217bbcf900228c = 0.12;
const $480a27d1927d6d2f$export$efb5de2debaf223 = {
    DomContentLoaded: 0,
    Load: 1,
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Custom: 5
};
const $480a27d1927d6d2f$export$763b0576de6114e0 = {
    [(0, $44Lnf.MODE).ERROR]: 15000,
    [(0, $44Lnf.MODE).FULL]: 300000,
    [(0, $44Lnf.MODE).OFF]: 0
};
const $480a27d1927d6d2f$export$76a4a93d70902add = {
    RESET: {
        message: 'Session was reset',
        sm: 'Reset'
    },
    IMPORT: {
        message: 'Recorder failed to import',
        sm: 'Import'
    },
    TOO_MANY: {
        message: '429: Too Many Requests',
        sm: 'Too-Many'
    },
    TOO_BIG: {
        message: 'Payload was too large',
        sm: 'Too-Big'
    },
    CROSS_TAB: {
        message: 'Session Entity was set to OFF on another tab',
        sm: 'Cross-Tab'
    },
    ENTITLEMENTS: {
        message: 'Session Replay is not allowed and will not be started',
        sm: 'Entitlement'
    }
};
const $480a27d1927d6d2f$export$1c29e1fd3b9f241d = 5000;
const $480a27d1927d6d2f$export$709baa12d4a9776d = {
    API: 'api',
    RESUME: 'resume',
    SWITCH_TO_FULL: 'switchToFull',
    INITIALIZE: 'initialize',
    PRELOAD: 'preload'
};

});

parcelRegister("dWGbK", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1uHoI"),
    $parcel$import("4f6sw")
]).then(()=>parcelRequire('8rBbr'));

});

parcelRegister("bSuiD", function(module, exports) {
module.exports = $parcel$import("7qhnc").then(()=>parcelRequire('laqLT'));

});

parcelRegister("4vZgp", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1uHoI"),
    $parcel$import("9lnpW")
]).then(()=>parcelRequire('jBB2H'));

});

parcelRegister("52LFv", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("1uHoI"),
    $parcel$import("5d2xF")
]).then(()=>parcelRequire('lw6U3'));

});

parcelRegister("1ZAXp", function(module, exports) {

$parcel$export(module.exports, "INTERACTION_TRIGGERS", function () { return $173827db85b5407b$export$f91d90f003422cac; });
$parcel$export(module.exports, "POPSTATE_TRIGGER", function () { return $173827db85b5407b$export$b1a0e10694b70e8a; });
$parcel$export(module.exports, "API_TRIGGER_NAME", function () { return $173827db85b5407b$export$8c3da82bfc9589b5; });
$parcel$export(module.exports, "IPL_TRIGGER_NAME", function () { return $173827db85b5407b$export$56a79e042f693792; });
$parcel$export(module.exports, "FEATURE_NAME", function () { return $173827db85b5407b$export$7e598866fa8de8d0; });
$parcel$export(module.exports, "NO_LONG_TASK_WINDOW", function () { return $173827db85b5407b$export$b681e5991f0e4131; });
$parcel$export(module.exports, "POPSTATE_MERGE_WINDOW", function () { return $173827db85b5407b$export$aabdbf5bf6981c90; });
$parcel$export(module.exports, "INTERACTION_TYPE", function () { return $173827db85b5407b$export$dc1d3aa5f3837765; });
$parcel$export(module.exports, "NODE_TYPE", function () { return $173827db85b5407b$export$accaa52ddae3fe58; });
$parcel$export(module.exports, "INTERACTION_STATUS", function () { return $173827db85b5407b$export$975cd767cbe1677a; });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $173827db85b5407b$export$f91d90f003422cac = [
    'click',
    // e.g. user clicks link or the page back/forward buttons
    'keydown',
    // e.g. user presses left and right arrow key to switch between displayed photo gallery
    'submit' // e.g. user clicks submit butotn or presses enter while editing a form field
];
const $173827db85b5407b$export$b1a0e10694b70e8a = 'popstate'; // e.g. user clicks browser back/forward button or history API is used programmatically
const $173827db85b5407b$export$8c3da82bfc9589b5 = 'api';
const $173827db85b5407b$export$56a79e042f693792 = 'initialPageLoad';
const $173827db85b5407b$export$7e598866fa8de8d0 = (0, $3R40a.FEATURE_NAMES).softNav;
const $173827db85b5407b$export$b681e5991f0e4131 = 5000; // purpose is to wait 5 seconds wherein no long task is detected
const $173827db85b5407b$export$aabdbf5bf6981c90 = 500; // "coalesce" (discard) a popstate that happen within this period following an INTERACTION_TRIGGER opening ixn, e.g. click->popstate
const $173827db85b5407b$export$dc1d3aa5f3837765 = {
    INITIAL_PAGE_LOAD: '',
    ROUTE_CHANGE: 1,
    UNSPECIFIED: 2
};
const $173827db85b5407b$export$accaa52ddae3fe58 = {
    INTERACTION: 1,
    AJAX: 2,
    CUSTOM_END: 3,
    CUSTOM_TRACER: 4
};
const $173827db85b5407b$export$975cd767cbe1677a = {
    IP: 'in progress',
    PF: 'pending finish',
    // interaction meets the hard criteria but is awaiting flexible conditions to fully finish
    FIN: 'finished',
    CAN: 'cancelled'
};

});

parcelRegister("5k7MW", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("aCmou"),
    $parcel$import("1uHoI"),
    $parcel$import("1XM0l")
]).then(()=>parcelRequire('bEFXe'));

});

parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
'use strict';

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Og(!0), $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Og(!1), $b36288e2db101ba3$var$Wg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = null, $b36288e2db101ba3$var$Zg = null;
function $b36288e2db101ba3$var$$g() {
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Xg = null;
}
function $b36288e2db101ba3$var$ah(a) {
    var b = $b36288e2db101ba3$var$Wg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$ch(a, b) {
    $b36288e2db101ba3$var$Xg = a;
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$dh = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$eh(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Yg) {
            if (null === $b36288e2db101ba3$var$Xg) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Yg = a;
            $b36288e2db101ba3$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Yg.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$fh = null;
function $b36288e2db101ba3$var$gh(a) {
    null === $b36288e2db101ba3$var$fh ? $b36288e2db101ba3$var$fh = [
        a
    ] : $b36288e2db101ba3$var$fh.push(a);
}
function $b36288e2db101ba3$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$ih(a, d);
}
function $b36288e2db101ba3$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$jh = !1;
function $b36288e2db101ba3$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$ih(a, c);
}
function $b36288e2db101ba3$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$th = {}, $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th);
function $b36288e2db101ba3$var$xh(a) {
    if (a === $b36288e2db101ba3$var$th) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$yh(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$wh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, $b36288e2db101ba3$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, b);
}
function $b36288e2db101ba3$var$zh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$wh);
}
function $b36288e2db101ba3$var$Ah(a) {
    $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
    var b = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, c));
}
function $b36288e2db101ba3$var$Bh(a) {
    $b36288e2db101ba3$var$vh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh));
}
var $b36288e2db101ba3$var$L = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Dh = [];
function $b36288e2db101ba3$var$Eh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Dh.length; a++)$b36288e2db101ba3$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Dh.length = 0;
}
var $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Hh = 0, $b36288e2db101ba3$var$M = null, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$Ih = !1, $b36288e2db101ba3$var$Jh = !1, $b36288e2db101ba3$var$Kh = 0, $b36288e2db101ba3$var$Lh = 0;
function $b36288e2db101ba3$var$P() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Nh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Hh = f;
    $b36288e2db101ba3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Fh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Oh : $b36288e2db101ba3$var$Ph;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Jh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Qh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Jh);
    }
    $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
    b = null !== $b36288e2db101ba3$var$N && null !== $b36288e2db101ba3$var$N.next;
    $b36288e2db101ba3$var$Hh = 0;
    $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
    $b36288e2db101ba3$var$Ih = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$Sh() {
    var a = 0 !== $b36288e2db101ba3$var$Kh;
    $b36288e2db101ba3$var$Kh = 0;
    return a;
}
function $b36288e2db101ba3$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Uh() {
    if (null === $b36288e2db101ba3$var$N) {
        var a = $b36288e2db101ba3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$N.next;
    var b = null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState : $b36288e2db101ba3$var$O.next;
    if (null !== b) $b36288e2db101ba3$var$O = b, $b36288e2db101ba3$var$N = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$N = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$N.memoizedState,
            baseState: $b36288e2db101ba3$var$N.baseState,
            baseQueue: $b36288e2db101ba3$var$N.baseQueue,
            queue: $b36288e2db101ba3$var$N.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    }
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Wh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$M.lanes |= m;
                $b36288e2db101ba3$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$M.lanes |= f, $b36288e2db101ba3$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Xh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Yh() {}
function $b36288e2db101ba3$var$Zh(a, b) {
    var c = $b36288e2db101ba3$var$M, d = $b36288e2db101ba3$var$Uh(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$dh = !0);
    d = d.queue;
    $b36288e2db101ba3$var$$h($b36288e2db101ba3$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$O && $b36288e2db101ba3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
}
function $b36288e2db101ba3$var$ai(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
    });
}
function $b36288e2db101ba3$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$ih(a, 1);
    null !== b && $b36288e2db101ba3$var$gi(b, a, 1, -1);
}
function $b36288e2db101ba3$var$hi(a) {
    var b = $b36288e2db101ba3$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ii.bind(null, $b36288e2db101ba3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$ji() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$ki(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Th();
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$N) {
        var g = $b36288e2db101ba3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Mh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$bi(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$mi(a, b) {
    return $b36288e2db101ba3$var$ki(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$$h(a, b) {
    return $b36288e2db101ba3$var$li(2048, 8, a, b);
}
function $b36288e2db101ba3$var$ni(a, b) {
    return $b36288e2db101ba3$var$li(4, 2, a, b);
}
function $b36288e2db101ba3$var$oi(a, b) {
    return $b36288e2db101ba3$var$li(4, 4, a, b);
}
function $b36288e2db101ba3$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$li(4, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ri() {}
function $b36288e2db101ba3$var$si(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ti(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ui(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$dh = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$M.lanes |= c, $b36288e2db101ba3$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$vi(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Gh.transition;
    $b36288e2db101ba3$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Gh.transition = d;
    }
}
function $b36288e2db101ba3$var$wi() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$xi(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, c);
    else if (c = $b36288e2db101ba3$var$hh(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$R();
        $b36288e2db101ba3$var$gi(c, a, d, e);
        $b36288e2db101ba3$var$Bi(c, b, d);
    }
}
function $b36288e2db101ba3$var$ii(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$hh(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$R(), $b36288e2db101ba3$var$gi(c, a, d, e), $b36288e2db101ba3$var$Bi(c, b, d));
    }
}
function $b36288e2db101ba3$var$zi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$M || null !== b && b === $b36288e2db101ba3$var$M;
}
function $b36288e2db101ba3$var$Ai(a, b) {
    $b36288e2db101ba3$var$Jh = $b36288e2db101ba3$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$Rh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$P,
    useContext: $b36288e2db101ba3$var$P,
    useEffect: $b36288e2db101ba3$var$P,
    useImperativeHandle: $b36288e2db101ba3$var$P,
    useInsertionEffect: $b36288e2db101ba3$var$P,
    useLayoutEffect: $b36288e2db101ba3$var$P,
    useMemo: $b36288e2db101ba3$var$P,
    useReducer: $b36288e2db101ba3$var$P,
    useRef: $b36288e2db101ba3$var$P,
    useState: $b36288e2db101ba3$var$P,
    useDebugValue: $b36288e2db101ba3$var$P,
    useDeferredValue: $b36288e2db101ba3$var$P,
    useTransition: $b36288e2db101ba3$var$P,
    useMutableSource: $b36288e2db101ba3$var$P,
    useSyncExternalStore: $b36288e2db101ba3$var$P,
    useId: $b36288e2db101ba3$var$P,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Oh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ki(4194308, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$xi.bind(null, $b36288e2db101ba3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$hi,
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$hi(!1), b = a[0];
        a = $b36288e2db101ba3$var$vi.bind(null, a[1]);
        $b36288e2db101ba3$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$M, e = $b36288e2db101ba3$var$Th();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$mi($b36288e2db101ba3$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$Th(), b = $b36288e2db101ba3$var$Q.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Ph = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Wh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Qh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Xh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return null === $b36288e2db101ba3$var$N ? b.memoizedState = a : $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36288e2db101ba3$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$R(), d = $b36288e2db101ba3$var$yi(a), e = $b36288e2db101ba3$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$nh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, d, c), $b36288e2db101ba3$var$oh(b, a, d));
    }
};
function $b36288e2db101ba3$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$eh(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36288e2db101ba3$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$eh(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Ei.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Ni(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Oi || ($b36288e2db101ba3$var$Oi = !0, $b36288e2db101ba3$var$Pi = d);
        $b36288e2db101ba3$var$Li(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Qi(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Li(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ri ? $b36288e2db101ba3$var$Ri = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$mh(-1, 1), b.tag = 2, $b36288e2db101ba3$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Wi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$dh = !1;
function $b36288e2db101ba3$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Vg(b, null, c, d) : $b36288e2db101ba3$var$Ug(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$ch(b, e);
    d = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$bj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$dh = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$Zi(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$cj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj);
            $b36288e2db101ba3$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= d;
    $b36288e2db101ba3$var$Xi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$ch(b, e);
    c = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$ch(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$ij(a, b), $b36288e2db101ba3$var$Gi(b, c, d), $b36288e2db101ba3$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$eh(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Hi(b, g, d, l);
        $b36288e2db101ba3$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof m && ($b36288e2db101ba3$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$eh(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$Hi(b, g, d, k);
        $b36288e2db101ba3$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof y && ($b36288e2db101ba3$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$jj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$jj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$Zi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Ug(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Ug(b, null, h, f)) : $b36288e2db101ba3$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$yh(a, b.containerInfo);
}
function $b36288e2db101ba3$var$lj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Xi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$pj(g, d, 0, null), a = $b36288e2db101ba3$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$nj(c), b.memoizedState = $b36288e2db101ba3$var$mj, a) : $b36288e2db101ba3$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$Pg(h, f) : (f = $b36288e2db101ba3$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$qj(a, b) {
    b = $b36288e2db101ba3$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$sj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Ug(b, a.child, null, c);
    a = $b36288e2db101ba3$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$nj(g);
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Ki(f, d, void 0);
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$dh || h) {
        d = $b36288e2db101ba3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$ih(a, e), $b36288e2db101ba3$var$gi(d, a, e, -1));
        }
        $b36288e2db101ba3$var$tj();
        d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$bh(a.return, b, c);
}
function $b36288e2db101ba3$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Xi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$vj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$kj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Ah(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$oj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
                a = $b36288e2db101ba3$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$dj(a, b, c);
    }
    return $b36288e2db101ba3$var$Zi(a, b, c);
}
var $b36288e2db101ba3$var$zj, $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj;
$b36288e2db101ba3$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Aj = function() {};
$b36288e2db101ba3$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Dj(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$zh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Aj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Bh(b);
            var e = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
                $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$L.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$Aj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Dj(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Gj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$L.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$fj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Ij(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Bh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L), null;
        case 4:
            return $b36288e2db101ba3$var$zh(), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Jj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Nj = !1;
function $b36288e2db101ba3$var$Oj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Nj;
    $b36288e2db101ba3$var$Nj = !1;
    return n;
}
function $b36288e2db101ba3$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Xj = !1;
function $b36288e2db101ba3$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$Zj(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$Zj(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Lj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Xj = !0;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Mj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Yj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Yj(a, b, c);
    }
}
function $b36288e2db101ba3$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Kj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Xj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$Zj(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$dk(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Pj(3, a, a.return), $b36288e2db101ba3$var$Qj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            break;
        case 13:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$fk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$ek(a);
    }
}
function $b36288e2db101ba3$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$hk(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$ik(a, b, c);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Jj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Jj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$jk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$jk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$ik(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Jj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$kk(a, b, c);
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Rj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$gk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$jk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Qj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$lk = Math.ceil, $b36288e2db101ba3$var$mk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$fj = 0, $b36288e2db101ba3$var$ej = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$pk = null, $b36288e2db101ba3$var$rh = 0, $b36288e2db101ba3$var$qk = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = null, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$fk = 0, $b36288e2db101ba3$var$Gj = Infinity, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Oi = !1, $b36288e2db101ba3$var$Pi = null, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = null, $b36288e2db101ba3$var$xk = 0, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, $b36288e2db101ba3$var$Ak = -1, $b36288e2db101ba3$var$Bk = 0;
function $b36288e2db101ba3$var$R() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$Ak : $b36288e2db101ba3$var$Ak = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Bk && ($b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Bk;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$gi(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$yk) throw $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$Q) a === $b36288e2db101ba3$var$Q && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$qk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Ck(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Dk(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Ek.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Ek.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Fk(c, $b36288e2db101ba3$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Gk(a, b) {
    $b36288e2db101ba3$var$Ak = -1;
    $b36288e2db101ba3$var$Bk = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Ik(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Jk();
        if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Kk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Lk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Mk(a, h);
        }
        $b36288e2db101ba3$var$$g();
        $b36288e2db101ba3$var$mk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Nk(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Ok(e) && (b = $b36288e2db101ba3$var$Ik(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Nk(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$fk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Gk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    var c = $b36288e2db101ba3$var$sk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Kk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Ik(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$tk = c, null !== b && $b36288e2db101ba3$var$Fj(b));
    return a;
}
function $b36288e2db101ba3$var$Fj(a) {
    null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = a : $b36288e2db101ba3$var$tk.push.apply($b36288e2db101ba3$var$tk, a);
}
function $b36288e2db101ba3$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Ck(a, b) {
    b &= ~$b36288e2db101ba3$var$rk;
    b &= ~$b36288e2db101ba3$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Ek(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, b), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Qk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Rk(a) {
    null !== $b36288e2db101ba3$var$wk && 0 === $b36288e2db101ba3$var$wk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$ok.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$ok.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Hj() {
    $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$ej.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$ej);
}
function $b36288e2db101ba3$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$zh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Eh();
                break;
            case 5:
                $b36288e2db101ba3$var$Bh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$zh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 10:
                $b36288e2db101ba3$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Hj();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Q = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$Pg(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$fj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$pk = null;
    $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$qk = $b36288e2db101ba3$var$rh = 0;
    $b36288e2db101ba3$var$tk = $b36288e2db101ba3$var$sk = null;
    if (null !== $b36288e2db101ba3$var$fh) {
        for(b = 0; b < $b36288e2db101ba3$var$fh.length; b++)if (c = $b36288e2db101ba3$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$fh = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Mk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$$g();
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
            if ($b36288e2db101ba3$var$Ih) {
                for(var d = $b36288e2db101ba3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Ih = !1;
            }
            $b36288e2db101ba3$var$Hh = 0;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            $b36288e2db101ba3$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$pk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Si(f, l, b);
                            $b36288e2db101ba3$var$tj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Vi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ji(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$sk ? $b36288e2db101ba3$var$sk = [
                    f
                ] : $b36288e2db101ba3$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Ni(f, k, b);
                            $b36288e2db101ba3$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Qi(f, h, b);
                                $b36288e2db101ba3$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Sk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Jk() {
    var a = $b36288e2db101ba3$var$mk.current;
    $b36288e2db101ba3$var$mk.current = $b36288e2db101ba3$var$Rh;
    return null === a ? $b36288e2db101ba3$var$Rh : a;
}
function $b36288e2db101ba3$var$tj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$Q || 0 === ($b36288e2db101ba3$var$rh & 268435455) && 0 === ($b36288e2db101ba3$var$qk & 268435455) || $b36288e2db101ba3$var$Ck($b36288e2db101ba3$var$Q, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Ik(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Jk();
    if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Kk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Tk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Mk(a, e);
    }
    $b36288e2db101ba3$var$$g();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$mk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$Q = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Tk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Lk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Uk(a) {
    var b = $b36288e2db101ba3$var$Vk(a.alternate, a, $b36288e2db101ba3$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Sk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$nk.current = null;
}
function $b36288e2db101ba3$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Ej(c, b, $b36288e2db101ba3$var$fj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Pk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$ok.transition;
    try {
        $b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Wk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$ok.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Wk(a, b, c, d) {
    do $b36288e2db101ba3$var$Hk();
    while (null !== $b36288e2db101ba3$var$wk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$Q && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$vk || ($b36288e2db101ba3$var$vk = !0, $b36288e2db101ba3$var$Fk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$ok.transition;
        $b36288e2db101ba3$var$ok.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$nk.current = null;
        $b36288e2db101ba3$var$Oj(a, c);
        $b36288e2db101ba3$var$dk(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$hk(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$ok.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$vk && ($b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = a, $b36288e2db101ba3$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Ri = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Oi) throw $b36288e2db101ba3$var$Oi = !1, a = $b36288e2db101ba3$var$Pi, $b36288e2db101ba3$var$Pi = null, a;
    0 !== ($b36288e2db101ba3$var$xk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$zk ? $b36288e2db101ba3$var$yk++ : ($b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = a) : $b36288e2db101ba3$var$yk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Hk() {
    if (null !== $b36288e2db101ba3$var$wk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$xk), b = $b36288e2db101ba3$var$ok.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$ok.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$wk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$wk;
                $b36288e2db101ba3$var$wk = null;
                $b36288e2db101ba3$var$xk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Sj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Xk(a, b, c) {
    b = $b36288e2db101ba3$var$Ji(c, b);
    b = $b36288e2db101ba3$var$Ni(a, b, 1);
    a = $b36288e2db101ba3$var$nh(a, b, 1);
    b = $b36288e2db101ba3$var$R();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Dk(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(d))) {
                a = $b36288e2db101ba3$var$Ji(c, a);
                a = $b36288e2db101ba3$var$Qi(b, a, 1);
                b = $b36288e2db101ba3$var$nh(b, a, 1);
                a = $b36288e2db101ba3$var$R();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$Q === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$fk ? $b36288e2db101ba3$var$Kk(a, 0) : $b36288e2db101ba3$var$rk |= c);
    $b36288e2db101ba3$var$Dk(a, b);
}
function $b36288e2db101ba3$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$R();
    a = $b36288e2db101ba3$var$ih(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Dk(a, c));
}
function $b36288e2db101ba3$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Yk(a, c);
}
function $b36288e2db101ba3$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Yk(a, c);
}
var $b36288e2db101ba3$var$Vk;
$b36288e2db101ba3$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$yj(a, b, c);
            $b36288e2db101ba3$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$ch(b, c);
            e = $b36288e2db101ba3$var$Nh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$kh(b), e.updater = $b36288e2db101ba3$var$Ei, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$Ii(b, d, a, c), b = $b36288e2db101ba3$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$Zk(d);
                a = $b36288e2db101ba3$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$$i(null, b, d, $b36288e2db101ba3$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$kj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$lh(a, b);
                $b36288e2db101ba3$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$Zi(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Ah(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$gj(a, b), $b36288e2db101ba3$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$oj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Ug(b, null, d, c) : $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$Yi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$ch(b, c), e = $b36288e2db101ba3$var$eh(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Ci(d, b.pendingProps), e = $b36288e2db101ba3$var$Ci(d.type, e), $b36288e2db101ba3$var$$i(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$ij(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$ch(b, c), $b36288e2db101ba3$var$Gi(b, d, e), $b36288e2db101ba3$var$Ii(b, d, e, c), $b36288e2db101ba3$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$xj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$dj(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Fk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$$k(a, b, c, d);
}
function $b36288e2db101ba3$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$Zk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Tg(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Tg(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$pj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$kh(f);
    return a;
}
function $b36288e2db101ba3$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$dl(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$dl(null);
    c = a.current;
    d = $b36288e2db101ba3$var$R();
    e = $b36288e2db101ba3$var$yi(c);
    f = $b36288e2db101ba3$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$nh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Dk(a, d);
    return a;
}
function $b36288e2db101ba3$var$fl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$R(), g = $b36288e2db101ba3$var$yi(e);
    c = $b36288e2db101ba3$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$nh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$gi(a, e, g, f), $b36288e2db101ba3$var$oh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    $b36288e2db101ba3$var$hl(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$hl(a, b);
}
function $b36288e2db101ba3$var$jl() {
    return null;
}
var $b36288e2db101ba3$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ll(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.render = $b36288e2db101ba3$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$fl(a, b, null, null);
};
$b36288e2db101ba3$var$ml.prototype.unmount = $b36288e2db101ba3$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Rk(function() {
            $b36288e2db101ba3$var$fl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$pl() {}
function $b36288e2db101ba3$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$el(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$pl);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$bl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$pl);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$fl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$fl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$ql(c, b, a, e, d);
    return $b36288e2db101ba3$var$gl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Dk(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Rk(function() {
                var b = $b36288e2db101ba3$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$R();
                    $b36288e2db101ba3$var$gi(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$il(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$il(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$yi(a), c = $b36288e2db101ba3$var$ih(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(c, a, b, d);
        }
        $b36288e2db101ba3$var$il(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Rk;
var $b36288e2db101ba3$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Qk
    ]
}, $b36288e2db101ba3$var$tl = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$ul = {
    bundleType: $b36288e2db101ba3$var$tl.bundleType,
    version: $b36288e2db101ba3$var$tl.version,
    rendererPackageName: $b36288e2db101ba3$var$tl.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$tl.findFiberByHostInstance || $b36288e2db101ba3$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$vl.isDisabled && $b36288e2db101ba3$var$vl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$vl.inject($b36288e2db101ba3$var$ul), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$vl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$sl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$nl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$cl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ll(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Rk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$ol(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$rl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
'use strict';
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("dj0NU", function(module, exports) {
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI" + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        OnePlus: [
                            "304",
                            "403",
                            "203"
                        ],
                        "*": OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Energizer"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Cat"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Smartfren"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Touch"
                ],
                VERSION
            ],
            [
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("b3Xnn", function(module, exports) {
module.exports = $parcel$import("8z7OA").then(()=>parcelRequire('jh23p'));

});

var $014c9f8258d9a5d4$exports = {};
$parcel$extendImportMap({
    "jjBJ0": "agent-session.856264cb.js",
    "kl0II": "aggregate.c2cb46ff.js",
    "1uHoI": "aggregate.66807482.js",
    "aCmou": "aggregate.73056967.js",
    "5MKAi": "aggregate.643804bc.js",
    "kY25b": "aggregate.5294b8af.js",
    "7Z7gv": "aggregate.ab5b8421.js",
    "any70": "aggregate.3ffaa9e5.js",
    "iL0y8": "aggregate.eea71ea5.js",
    "4f6sw": "aggregate.ca602d6e.js",
    "gYIeX": "browser.2f908e3c.js",
    "7qhnc": "recorder.b9b2e32d.js",
    "9lnpW": "aggregate.1d5930e3.js",
    "5d2xF": "aggregate.83fb9f17.js",
    "1XM0l": "aggregate.eb458632.js",
    "7FX8R": "SOAK2026_Map.f199e5f7.jpg",
    "8PNQt": "service-worker.js",
    "8z7OA": "browser.412b627e.js"
});

// Init NR browser agent
var $d4dab640dcbe486c$exports = {};
'use strict';

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // important side effects
parcelRequire("6AoZt");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // We don't support setting automating the nonce attribute in the npm package
var $7f1da288c92d828b$export$2e2bcd8739ae039 = {};



var $azp24 = parcelRequire("azp24");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
const $fa0853a1d774eb4d$var$featureNames = Object.values((0, $3R40a.FEATURE_NAMES));
function $fa0853a1d774eb4d$export$b223b1e857b805e7(agentInit) {
    const enabledFeatures = {};
    $fa0853a1d774eb4d$var$featureNames.forEach((featureName)=>{
        enabledFeatures[featureName] = !!agentInit[featureName]?.enabled;
    });
    return enabledFeatures;
}



var $8ncaL = parcelRequire("8ncaL");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3R40a = parcelRequire("3R40a");
function $ee23bbfa53b85079$export$3d76026a5ff16223(feature) {
    switch(feature){
        case (0, $3R40a.FEATURE_NAMES).ajax:
            return [
                (0, $3R40a.FEATURE_NAMES).jserrors
            ];
        case (0, $3R40a.FEATURE_NAMES).sessionTrace:
            return [
                (0, $3R40a.FEATURE_NAMES).ajax,
                (0, $3R40a.FEATURE_NAMES).pageViewEvent
            ];
        case (0, $3R40a.FEATURE_NAMES).sessionReplay:
            return [
                (0, $3R40a.FEATURE_NAMES).sessionTrace
            ];
        case (0, $3R40a.FEATURE_NAMES).pageViewTiming:
            return [
                (0, $3R40a.FEATURE_NAMES).pageViewEvent
            ];
        // this could change if we disconnect window load timings
        default:
            return [];
    }
}



var $3R40a = parcelRequire("3R40a");
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $1Z3KE = parcelRequire("1Z3KE");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $4155cd3189be20c2$export$eb2552c617008252(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.SET_PAGE_VIEW_NAME), function(name, host) {
        if (typeof name !== 'string') return;
        if (name.charAt(0) !== '/') name = '/' + name;
        agent.runtime.customTransaction = (host || 'http://custom.transaction') + name;
        (0, $gy0pT.handle)((0, $4uE6N.prefix) + (0, $4uE6N.SET_PAGE_VIEW_NAME), [
            (0, $1Z3KE.now)()
        ], undefined, undefined, agent.ee);
    }, agent);
}


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Defines `InstrumentBase` to be used as the super of the Instrument classes implemented by each feature.
 * Inherits and executes the `checkConfiguration` method from [FeatureBase]{@link ./feature-base}, which also
 * exposes the `blocked` property.
 */ 
var $Sqjfb = parcelRequire("Sqjfb");

var $1017n = parcelRequire("1017n");

var $b5Hn5 = parcelRequire("b5Hn5");

var $9EKMI = parcelRequire("9EKMI");

var $jkuUu = parcelRequire("jkuUu");

var $3R40a = parcelRequire("3R40a");

var $24qgc = parcelRequire("24qgc");

var $1orxZ = parcelRequire("1orxZ");

var $letnH = parcelRequire("letnH");

var $iNTSX = parcelRequire("iNTSX");

var $gy0pT = parcelRequire("gy0pT");

class $2591173c660a4e27$export$53233a09ca4736e9 extends (0, $1017n.FeatureBase) {
    /**
   * Instantiate InstrumentBase.
   * @param {Object} agentRef - The agent reference object.
   * @param {string} featureName - The name of the feature module (used to construct file path).
   */ constructor(agentRef, featureName){
        super(agentRef, featureName);
        /** @type {Function | undefined} This should be set by any derived Instrument class if it has things to do when feature fails or is killed. */ this.abortHandler = undefined;
        /**
     * @type {import('./aggregate-base').AggregateBase} Holds the reference to the feature's aggregate module counterpart, if and after it has been initialized. This may not be assigned until after page loads!
     * The only purpose of this for now is to expose it to the NREUM interface, as the feature's instrument instance is already exposed.
    */ this.featAggregate = undefined;
        /**
     * @type {Promise} Assigned immediately after @see importAggregator runs. Serves as a signal for when the inner async fn finishes execution. Useful for features to await
     * one another if there are inter-features dependencies.
    */ this.loadedSuccessfully = undefined;
        this.onAggregateImported = new Promise((resolve)=>{
            this.loadedSuccessfully = resolve;
        });
        /**
     * used in conjunction with newrelic.start() to defer harvesting in features
     * @type {Promise} Resolves when the feature is ready to import its aggregator, either immediately or after the start API has been called if the feature is autoStart: false.
    */ this.deferred = Promise.resolve();
        if (agentRef.init[this.featureName].autoStart === false) this.deferred = new Promise((resolve, reject)=>{
            this.ee.on('manual-start-all', (0, $letnH.single)(()=>{
                // register the feature to drain only once the API has been called, it will drain when importAggregator finishes for all the features
                // called by the api in that cycle
                (0, $Sqjfb.registerDrain)(agentRef, this.featureName);
                resolve();
            }));
        });
        else /** if the feature requires opt-in (!auto-start), it will get registered once the api has been called */ (0, $Sqjfb.registerDrain)(agentRef, featureName);
    }
    /**
   * Lazy-load the latter part of the feature: its aggregator. This method is called by the first part of the feature
   * (the instrumentation) when instrumentation is complete.
   * @param {Object} agentRef - reference to the base agent ancestor that this feature belongs to
   * @param {Function} fetchAggregator - a function that returns a promise that resolves to the aggregate module
   * @param {Object} [argsObjFromInstrument] - any values or references to pass down to aggregate
   * @returns
   */ importAggregator(agentRef, fetchAggregator, argsObjFromInstrument = {}) {
        if (this.featAggregate) return;
        const importLater = async ()=>{
            // wait for the deferred promise to resolve before proceeding
            // this will resolve immediately if the feature is auto-started,
            // or otherwise when the manual-start-all event is emitted by the start API
            await this.deferred;
            let session;
            try {
                if ((0, $1orxZ.canEnableSessionTracking)(agentRef.init)) {
                    // would require some setup before certain features start
                    const { setupAgentSession: setupAgentSession } = await (parcelRequire("7CkoZ"));
                    session = setupAgentSession(agentRef);
                }
            } catch (e) {
                (0, $jkuUu.warn)(20, e);
                this.ee.emit('internal-error', [
                    e
                ]);
                (0, $gy0pT.handle)((0, $iNTSX.SESSION_ERROR), [
                    e
                ], undefined, this.featureName, this.ee);
            }
            /**
       * Note this try-catch differs from the one in Agent.run() in that it's placed later in a page's lifecycle and
       * it's only responsible for aborting its one specific feature, rather than all.
       */ try {
                if (!this.#shouldImportAgg(this.featureName, session, agentRef.init)) {
                    (0, $Sqjfb.drain)(this.agentRef, this.featureName);
                    this.loadedSuccessfully(false); // aggregate module isn't loaded at all
                    return;
                }
                const { Aggregate: Aggregate } = await fetchAggregator();
                this.featAggregate = new Aggregate(agentRef, argsObjFromInstrument);
                agentRef.runtime.harvester.initializedAggregates.push(this.featAggregate); // "subscribe" the feature to future harvest intervals (PVE will start the timer)
                this.loadedSuccessfully(true);
            } catch (e) {
                (0, $jkuUu.warn)(34, e);
                this.abortHandler?.(); // undo any important alterations made to the page
                // not supported yet but nice to do: "abort" this agent's EE for this feature specifically
                (0, $Sqjfb.drain)(this.agentRef, this.featureName, true);
                this.loadedSuccessfully(false);
                if (this.ee) this.ee.abort();
            }
        };
        // For regular web pages, we want to wait and lazy-load the aggregator only after all page resources are loaded.
        // Non-browser scopes (i.e. workers) have no `window.load` event, so the aggregator can be lazy-loaded immediately.
        if (!(0, $9EKMI.isBrowserScope)) importLater();
        else (0, $b5Hn5.onWindowLoad)(()=>importLater(), true);
    }
    /**
  * Make a determination if an aggregate class should even be imported
  * @param {string} featureName
  * @param {import('../../common/session/session-entity').SessionEntity} session
  * @returns
  */ #shouldImportAgg(featureName, session, agentInit) {
        if (this.blocked) return false;
        switch(featureName){
            case (0, $3R40a.FEATURE_NAMES).sessionReplay:
                // the session manager must be initialized successfully for Replay & Trace features
                return (0, $24qgc.hasReplayPrerequisite)(agentInit) && !!session;
            case (0, $3R40a.FEATURE_NAMES).sessionTrace:
                return !!session;
            default:
                return true;
        }
    }
}



var $f5YR6 = parcelRequire("f5YR6");

var $44Lnf = parcelRequire("44Lnf");

var $klTus = parcelRequire("klTus");

var $b5Hn5 = parcelRequire("b5Hn5");

class $013d6426dbd26139$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = $f5YR6.FEATURE_NAME;
    constructor(agentRef){
        super(agentRef, $f5YR6.FEATURE_NAME);
        /** setup inspection events for window lifecycle */ this.setupInspectionEvents();
        /** feature specific APIs */ (0, $4155cd3189be20c2$export$eb2552c617008252)(agentRef);
        this.importAggregator(agentRef, ()=>(parcelRequire("iwT1r")));
    }
    setupInspectionEvents() {
        const dispatch = (evt, name)=>{
            if (!evt) return;
            (0, $klTus.dispatchGlobalEvent)({
                timeStamp: evt.timeStamp,
                loaded: evt.target.readyState === 'complete',
                type: 'window',
                name: name,
                data: evt.target.location + ''
            });
        };
        (0, $b5Hn5.onDOMContentLoaded)((evt)=>{
            dispatch(evt, 'DOMContentLoaded');
        });
        (0, $b5Hn5.onWindowLoad)((evt)=>{
            dispatch(evt, 'load');
        });
        (0, $b5Hn5.onPopstateChange)((evt)=>{
            dispatch(evt, 'navigate');
        });
        this.ee.on((0, $44Lnf.SESSION_EVENTS).UPDATE, (_, data)=>{
            (0, $klTus.dispatchGlobalEvent)({
                type: 'lifecycle',
                name: 'session',
                data: data
            });
        });
    }
}
const $013d6426dbd26139$export$27788728f3c41a49 = $013d6426dbd26139$export$25ef33f358b07cf4;



var $juL0p = parcelRequire("juL0p");

var $jkuUu = parcelRequire("jkuUu");

var $9EKMI = parcelRequire("9EKMI");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jkuUu = parcelRequire("jkuUu");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $37680abd18226c91$export$d28515d4b4a9c0c1(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.SET_CUSTOM_ATTRIBUTE), function(name, value, persistAttribute = false) {
        if (typeof name !== 'string') {
            (0, $jkuUu.warn)(39, typeof name);
            return;
        }
        if (!([
            'string',
            'number',
            'boolean'
        ].includes(typeof value) || value === null)) {
            (0, $jkuUu.warn)(40, typeof value);
            return;
        }
        return (0, $dVxdm.appendJsAttribute)(agent, name, value, (0, $4uE6N.SET_CUSTOM_ATTRIBUTE), persistAttribute);
    }, agent);
}


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jkuUu = parcelRequire("jkuUu");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");

var $gy0pT = parcelRequire("gy0pT");
function $b238e90b7308a067$export$162095e463e94662(agent) {
    /**
    * Attach the 'enduser.id' attribute onto agent payloads. This may be used in NR queries to group all browser events by specific users.
    * @param {string|null} value - unique user identifier; a null user id suggests none should exist
   *  @param {boolean} [resetSession=false] - Optional param. When true, resets the current session ONLY when changing user id from an existing value to another value or null. If the current user id is null when calling the API, the session cannot be reset.
    * @returns @see apiCall
    */ (0, $dVxdm.setupAPI)((0, $4uE6N.SET_USER_ID), function(value, resetSession = false) {
        if (!(typeof value === 'string' || value === null)) {
            (0, $jkuUu.warn)(41, typeof value);
            return;
        }
        const currUser = agent.info.jsAttributes['enduser.id'];
        // reset session ONLY if we are updating the userid (from one value to another, or from a value to null/undefined)
        const shouldAttemptReset = resetSession && currUser !== undefined && currUser !== null && currUser !== value;
        if (shouldAttemptReset) (0, $gy0pT.handle)((0, $4uE6N.prefix) + 'setUserIdAndResetSession', [
            value
        ], undefined, 'session', agent.ee);
        else (0, $dVxdm.appendJsAttribute)(agent, 'enduser.id', value, (0, $4uE6N.SET_USER_ID), true);
    }, agent);
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jkuUu = parcelRequire("jkuUu");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $a59c6a23b386b87b$export$4853ee1fa0df26ad(agent) {
    /**
   * Attach the 'applcation.version' attribute onto agent payloads. This may be used in NR queries to group all browser events by a specific customer-defined release.
   * @param {string|null} value - Application version -- if null, will "unset" the value
   * @returns @see apiCall
   */ (0, $dVxdm.setupAPI)((0, $4uE6N.SET_APPLICATION_VERSION), function(value) {
        if (!(typeof value === 'string' || value === null)) {
            (0, $jkuUu.warn)(42, typeof value);
            return;
        }
        return (0, $dVxdm.appendJsAttribute)(agent, 'application.version', value, (0, $4uE6N.SET_APPLICATION_VERSION), false);
    }, agent);
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $ce9d0269780d2d22$export$8e4bf423390e136(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.START), function() {
        agent.ee.emit('manual-start-all');
    }, agent);
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");

var $gy0pT = parcelRequire("gy0pT");

var $jkuUu = parcelRequire("jkuUu");
function $ac0a0a0589639b49$export$d66a853b5fa81cbf(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.CONSENT), function(accept = true) {
        if (typeof accept !== 'boolean') {
            (0, $jkuUu.warn)(65, typeof accept);
            return;
        }
        /** harvester, by way of "consented" getter, checks session state first, and falls back on runtime state if not available. Set both here */ (0, $gy0pT.handle)((0, $4uE6N.prefix) + (0, $4uE6N.CONSENT), [
            accept
        ], undefined, 'session', agent.ee); // sets session state (if available)
        agent.runtime.consented = accept; // sets runtime state
        /** if consent is granted, attempt to make a PageView event harvest if one has not already been made */ if (accept) {
            const pveInst = agent.features.page_view_event;
            pveInst.onAggregateImported.then((loaded)=>{
                const pveAgg = pveInst.featAggregate;
                if (loaded && !pveAgg.sentRum) pveAgg.sendRum();
            });
        }
    }, agent);
}


class $8ac64a97b1a43781$export$f05c48a4001d5356 extends (0, $azp24.AgentBase) {
    /**
   * @param {AgentOptions} options
   */ constructor(options){
        super();
        if (!(0, $9EKMI.globalScope)) {
            // We could not determine the runtime environment. Short-circuite the agent here
            // to avoid possible exceptions later that may cause issues with customer's application.
            (0, $jkuUu.warn)(21);
            return;
        }
        this.features = {};
        (0, $juL0p.setNREUMInitializedAgent)(this.agentIdentifier, this); // append this agent onto the global NREUM.initializedAgents
        this.desiredFeatures = new Set(options.features || []); // expected to be a list of static Instrument/InstrumentBase classes, see "spa.js" for example
        // For Now... ALL agents must make the rum call whether the page_view_event feature was enabled or not.
        // NR1 creates an index on the rum call, and if not seen for a few days, will remove the browser app!
        // Future work is being planned to evaluate removing this behavior from the backend, but for now we must ensure this call is made
        this.desiredFeatures.add((0, $013d6426dbd26139$export$25ef33f358b07cf4));
        (0, $8ncaL.configure)(this, options, options.loaderType || 'agent'); // add api, exposed, and other config properties
        /** assign base agent-level API definitions, feature-level APIs will be handled by the features to allow better code-splitting */ (0, $37680abd18226c91$export$d28515d4b4a9c0c1)(this);
        (0, $b238e90b7308a067$export$162095e463e94662)(this);
        (0, $a59c6a23b386b87b$export$4853ee1fa0df26ad)(this);
        (0, $ce9d0269780d2d22$export$8e4bf423390e136)(this);
        (0, $ac0a0a0589639b49$export$d66a853b5fa81cbf)(this);
        this.run();
    }
    get config() {
        return {
            info: this.info,
            init: this.init,
            loader_config: this.loader_config,
            runtime: this.runtime
        };
    }
    get api() {
        return this;
    }
    run() {
        // Attempt to initialize all the requested features (sequentially in prio order & synchronously), with any failure aborting the whole process.
        try {
            const enabledFeatures = (0, $fa0853a1d774eb4d$export$b223b1e857b805e7)(this.init);
            const featuresToStart = [
                ...this.desiredFeatures
            ];
            featuresToStart.sort((a, b)=>(0, $3R40a.featurePriority)[a.featureName] - (0, $3R40a.featurePriority)[b.featureName]);
            featuresToStart.forEach((InstrumentCtor)=>{
                if (!enabledFeatures[InstrumentCtor.featureName] && InstrumentCtor.featureName !== (0, $3R40a.FEATURE_NAMES).pageViewEvent) return; // PVE is required to run even if it's marked disabled
                const dependencies = (0, $ee23bbfa53b85079$export$3d76026a5ff16223)(InstrumentCtor.featureName);
                const missingDependencies = dependencies.filter((featName)=>!(featName in this.features)); // any other feature(s) this depends on should've been initialized on prior iterations by priority order
                if (missingDependencies.length > 0) (0, $jkuUu.warn)(36, {
                    targetFeature: InstrumentCtor.featureName,
                    missingDependencies: missingDependencies
                });
                this.features[InstrumentCtor.featureName] = new InstrumentCtor(this);
            });
        } catch (err) {
            (0, $jkuUu.warn)(22, err);
            for(const featName in this.features)// this.features hold only features that have been instantiated
            this.features[featName].abortHandler?.();
            const newrelic = (0, $juL0p.gosNREUM)();
            delete newrelic.initializedAgents[this.agentIdentifier]?.features; // GC mem used internally by features
            delete this.sharedAggregator;
            // Keep the initialized agent object with its configs for troubleshooting purposes.
            const thisEE = newrelic.ee.get(this.agentIdentifier);
            thisEE.abort(); // set flag and clear backlog
            return false;
        }
    }
}


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $kx4OV = parcelRequire("kx4OV");


var $gOaMh = parcelRequire("gOaMh");

var $9EKMI = parcelRequire("9EKMI");

var $1Z3KE = parcelRequire("1Z3KE");

class $6f9f9b7b88a73616$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = (0, $gOaMh.FEATURE_NAME);
    constructor(agentRef){
        super(agentRef, (0, $gOaMh.FEATURE_NAME));
        if (!(0, $9EKMI.isBrowserScope)) return; // CWV is irrelevant outside web context
        // While we try to replicate web-vital's visibilitywatcher logic in an effort to defer that library to post-pageload, this isn't perfect and doesn't consider prerendering.
        (0, $kx4OV.subscribeToVisibilityChange)(()=>(0, $gy0pT.handle)('docHidden', [
                (0, $1Z3KE.now)()
            ], undefined, (0, $gOaMh.FEATURE_NAME), this.ee), true);
        // Window fires its pagehide event (typically on navigation--this occurrence is a *subset* of vis change); don't defer this unless it's guarantee it cannot happen before load(?)
        (0, $kx4OV.subscribeToPageUnload)(()=>(0, $gy0pT.handle)('winPagehide', [
                (0, $1Z3KE.now)()
            ], undefined, (0, $gOaMh.FEATURE_NAME), this.ee));
        this.importAggregator(agentRef, ()=>(parcelRequire("hseEw")));
    }
}
const $6f9f9b7b88a73616$export$fcee77ffd513106b = $6f9f9b7b88a73616$export$25ef33f358b07cf4;


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $bu0p3 = parcelRequire("bu0p3");

class $ff2e4c1166cc1ee7$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = (0, $bu0p3.FEATURE_NAME);
    constructor(agentRef){
        super(agentRef, (0, $bu0p3.FEATURE_NAME));
        this.importAggregator(agentRef, ()=>(parcelRequire("38uIx")));
    }
}
const $ff2e4c1166cc1ee7$export$ed9166ec0f465b5e = $ff2e4c1166cc1ee7$export$25ef33f358b07cf4;


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");


var $3o0w7 = parcelRequire("3o0w7");

var $9EKMI = parcelRequire("9EKMI");

var $8FJov = parcelRequire("8FJov");

var $1Z3KE = parcelRequire("1Z3KE");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $8KO5M = parcelRequire("8KO5M");
class $ce3ce6259d43b1ca$export$35a01904520dae1b {
    constructor(message, filename, lineno, colno, newrelic){
        this.name = 'UncaughtError';
        this.message = typeof message === 'string' ? message : (0, $8KO5M.stringify)(message);
        this.sourceURL = filename;
        this.line = lineno;
        this.column = colno;
        this.__newrelic = newrelic;
    }
}


function $a85190656292aff3$export$5b4a007fa330967f(error) {
    /** Sometimes a browser can emit an error object with no stack */ if ($a85190656292aff3$var$canTrustError(error)) return error;
    /**
     * The thrown value may contain a message property. If it does, try to treat the thrown
     * value as an Error-like object.
     */ return new (0, $ce3ce6259d43b1ca$export$35a01904520dae1b)(error?.message !== undefined ? error.message : error, error?.filename || error?.sourceURL, error?.lineno || error?.line, error?.colno || error?.col, error?.__newrelic, error?.cause);
}
function $a85190656292aff3$export$129374953be01ba(promiseRejectionEvent) {
    const prefix = 'Unhandled Promise Rejection: ';
    /**
   * If the casted return value is falsy like this, it will get dropped and not produce an error event for harvest.
   * We drop promise rejections that could not form a valid error stack or message deriving from the .reason attribute
   * -- such as a manually invoked rejection without an argument -- since they lack reproduction value and create confusion.
   * */ if (!promiseRejectionEvent?.reason) return;
    if ($a85190656292aff3$var$canTrustError(promiseRejectionEvent.reason)) {
        try {
            if (!promiseRejectionEvent.reason.message.startsWith(prefix)) promiseRejectionEvent.reason.message = prefix + promiseRejectionEvent.reason.message;
        } catch (e) {
        // failed to modify the message, do nothing else
        }
        return $a85190656292aff3$export$5b4a007fa330967f(promiseRejectionEvent.reason);
    }
    const error = $a85190656292aff3$export$5b4a007fa330967f(promiseRejectionEvent.reason);
    if (!(error.message || '').startsWith(prefix)) error.message = prefix + error.message;
    return error;
}
function $a85190656292aff3$export$9a8f1be0e6183c7e(errorEvent) {
    if (errorEvent.error instanceof SyntaxError && !/:\d+$/.test(errorEvent.error.stack?.trim())) {
        const error = new (0, $ce3ce6259d43b1ca$export$35a01904520dae1b)(errorEvent.message, errorEvent.filename, errorEvent.lineno, errorEvent.colno, errorEvent.error.__newrelic, errorEvent.cause);
        error.name = SyntaxError.name;
        return error;
    }
    if ($a85190656292aff3$var$canTrustError(errorEvent.error)) return errorEvent.error;
    return $a85190656292aff3$export$5b4a007fa330967f(errorEvent);
}
function $a85190656292aff3$var$canTrustError(error) {
    return error instanceof Error && !!error.stack;
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $1Z3KE = parcelRequire("1Z3KE");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $7968f46faaa1de84$export$786e0e69b511ee7d(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.NOTICE_ERROR), (err, customAttributes)=>$7968f46faaa1de84$export$913138fc7e99dbd3(err, customAttributes, agent), agent);
}
function $7968f46faaa1de84$export$913138fc7e99dbd3(err, customAttributes, agentRef, target, timestamp = (0, $1Z3KE.now)()) {
    if (typeof err === 'string') err = new Error(err);
    (0, $gy0pT.handle)('err', [
        err,
        timestamp,
        false,
        customAttributes,
        agentRef.runtime.isRecording,
        undefined,
        target
    ], undefined, (0, $3R40a.FEATURE_NAMES).jserrors, agentRef.ee);
    (0, $gy0pT.handle)('uaErr', [], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, agentRef.ee);
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $8f5cd1f33eb667b9$export$eae9b745ac58380b(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.SET_ERROR_HANDLER), function(callback) {
        agent.runtime.onerror = callback;
    }, agent);
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $827b7c69f93c4e0a$export$9e20a01b8f684b14(agent) {
    let releaseCount = 0;
    (0, $dVxdm.setupAPI)((0, $4uE6N.ADD_RELEASE), function(name, id) {
        if (++releaseCount > 10) return;
        this.runtime.releaseIds[name.slice(-200)] = ('' + id).slice(-200);
    }, agent);
}


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $jkuUu = parcelRequire("jkuUu");

var $cPnWJ = parcelRequire("cPnWJ");

var $3R40a = parcelRequire("3R40a");

var $1Z3KE = parcelRequire("1Z3KE");

var $bu0p3 = parcelRequire("bu0p3");

var $dVxdm = parcelRequire("dVxdm");

var $4uE6N = parcelRequire("4uE6N");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $1Z3KE = parcelRequire("1Z3KE");

var $9RUUB = parcelRequire("9RUUB");

var $8FTye = parcelRequire("8FTye");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $cdaa056a33e152e9$export$82bbccfb817a681(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.LOG), (message, options)=>$cdaa056a33e152e9$export$bef1f36f5486a6a3(message, options, agent), agent);
}
function $cdaa056a33e152e9$export$bef1f36f5486a6a3(message, { customAttributes: customAttributes = {}, level: level = (0, $9RUUB.LOG_LEVELS).INFO } = {}, agentRef, target, timestamp = (0, $1Z3KE.now)()) {
    (0, $8FTye.bufferLog)(agentRef.ee, message, customAttributes, level, false, target, timestamp);
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $1Z3KE = parcelRequire("1Z3KE");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $993f5d61e78f0e40$export$39f865c8bdc8e0b2(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.ADD_PAGE_ACTION), (name, attributes)=>$993f5d61e78f0e40$export$da8763bc9c87dc9f(name, attributes, agent), agent);
}
function $993f5d61e78f0e40$export$da8763bc9c87dc9f(name, attributes, agentRef, target, timestamp = (0, $1Z3KE.now)()) {
    (0, $gy0pT.handle)((0, $4uE6N.prefix) + (0, $4uE6N.ADD_PAGE_ACTION), [
        timestamp,
        name,
        attributes,
        target
    ], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, agentRef.ee);
}




var $letnH = parcelRequire("letnH");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $1Z3KE = parcelRequire("1Z3KE");

var $jkuUu = parcelRequire("jkuUu");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $c0107e1a5b272c27$export$4afeeb8632ab3067(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.MEASURE), (name, options)=>$c0107e1a5b272c27$export$83602b44513dc228(name, options, agent), agent);
}
function $c0107e1a5b272c27$export$83602b44513dc228(name, options, agentRef, target, timestamp = (0, $1Z3KE.now)()) {
    const { start: start, end: end, customAttributes: customAttributes } = options || {};
    const returnObj = {
        customAttributes: customAttributes || {}
    };
    if (typeof returnObj.customAttributes !== 'object' || typeof name !== 'string' || name.length === 0) {
        (0, $jkuUu.warn)(57);
        return;
    }
    /**
     * getValueFromTiming - Helper function to extract a numeric value from a supplied option.
     * @param {Number|PerformanceMark} [timing] The timing value
     * @param {Number} [d] The default value to return if timing is invalid
     * @returns {Number} The timing value or the default value
     */ const getValueFromTiming = (timing, d)=>{
        if (timing == null) return d;
        if (typeof timing === 'number') return timing;
        if (timing instanceof PerformanceMark) return timing.startTime;
        return Number.NaN;
    };
    returnObj.start = getValueFromTiming(start, 0);
    returnObj.end = getValueFromTiming(end, timestamp);
    if (Number.isNaN(returnObj.start) || Number.isNaN(returnObj.end)) {
        (0, $jkuUu.warn)(57);
        return;
    }
    returnObj.duration = returnObj.end - returnObj.start;
    if (returnObj.duration < 0) {
        (0, $jkuUu.warn)(58);
        return;
    }
    (0, $gy0pT.handle)((0, $4uE6N.prefix) + (0, $4uE6N.MEASURE), [
        returnObj,
        name,
        target
    ], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, agentRef.ee);
    return returnObj;
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $1Z3KE = parcelRequire("1Z3KE");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $662eb61fcebf96c5$export$cb7bf6307fa273ba(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.RECORD_CUSTOM_EVENT), (eventType, attributes)=>$662eb61fcebf96c5$export$b50bdc6e8a495e8(eventType, attributes, agent), agent);
}
function $662eb61fcebf96c5$export$b50bdc6e8a495e8(eventType, attributes = {}, agentRef, target, timestamp = (0, $1Z3KE.now)()) {
    (0, $gy0pT.handle)((0, $4uE6N.prefix) + (0, $4uE6N.RECORD_CUSTOM_EVENT), [
        timestamp,
        eventType,
        attributes,
        target
    ], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, agentRef.ee);
}



var $kx4OV = parcelRequire("kx4OV");

var $dOQdv = parcelRequire("dOQdv");

var $6sT7C = parcelRequire("6sT7C");
/**
 * @typedef {import('./register-api-types').RegisterAPI} RegisterAPI
 */ const $6ff5d677d16b3f9d$var$PROTECTED_KEYS = [
    'name',
    'id',
    'type'
];
/**
 * Map of API methods to their names (prevents minification from breaking method name references)
 * @private
 */ const $6ff5d677d16b3f9d$var$METHOD_NAMES = new Map([
    [
        (0, $993f5d61e78f0e40$export$da8763bc9c87dc9f),
        'addPageAction'
    ],
    [
        (0, $cdaa056a33e152e9$export$bef1f36f5486a6a3),
        'log'
    ],
    [
        (0, $c0107e1a5b272c27$export$83602b44513dc228),
        'measure'
    ],
    [
        (0, $7968f46faaa1de84$export$913138fc7e99dbd3),
        'noticeError'
    ],
    [
        (0, $662eb61fcebf96c5$export$b50bdc6e8a495e8),
        'recordCustomEvent'
    ]
]);
const $6ff5d677d16b3f9d$export$cce7aaa89215f32b = {
    experimental: (0, $letnH.single)(()=>(0, $jkuUu.warn)(54, 'newrelic.register')),
    disabled: (0, $letnH.single)(()=>(0, $jkuUu.warn)(55)),
    invalidTarget: (0, $letnH.single)((target)=>(0, $jkuUu.warn)(48, target)),
    deregistered: (0, $letnH.single)(()=>(0, $jkuUu.warn)(68))
};
function $6ff5d677d16b3f9d$export$86b839ffa8705791(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.REGISTER), function(target) {
        return $6ff5d677d16b3f9d$var$register(agent, target);
    }, agent);
}
/**
 * Builds the api object that will be returned from the register api method.
 * Also conducts certain side-effects, such as harvesting a PageView event when triggered and gathering metadata for the registered entity.
 * @param {Object} agentRef the reference to the base agent instance
 * @param {import('./register-api-types').RegisterAPIConstructor} target
 * @returns {RegisterAPI} the api object to be returned from the register api method
 */ function $6ff5d677d16b3f9d$var$register(agentRef, target) {
    $6ff5d677d16b3f9d$export$cce7aaa89215f32b.experimental();
    target ||= {};
    target.instance = (0, $6sT7C.generateRandomHexString)(8);
    target.type = (0, $cPnWJ.V2_TYPES).MFE;
    target.licenseKey ||= agentRef.info.licenseKey; // will inherit the license key from the container agent if not provided for brevity. A future state may dictate that we need different license keys to do different things.
    target.blocked = false;
    if (typeof target.tags !== 'object' || target.tags === null || Array.isArray(target.tags)) target.tags = {};
    target.parent ??= {
        get id () {
            return agentRef.runtime.appMetadata.agents[0].entityGuid;
        },
        // getter because this is asyncronously set
        type: (0, $cPnWJ.V2_TYPES).BA
    };
    const timings = (0, $dOQdv.findScriptTimings)();
    const attrs = {};
    // Only define attributes getter if it doesn't already exist
    if (!Object.prototype.hasOwnProperty.call(target, 'attributes')) Object.defineProperty(target, 'attributes', {
        get () {
            return {
                ...attrs,
                'source.id': target.id,
                'source.name': target.name,
                'source.type': target.type,
                'parent.type': target.parent?.type || (0, $cPnWJ.V2_TYPES).BA,
                'parent.id': target.parent?.id
            };
        }
    });
    // Process tags object and add to attrs, excluding protected keys
    Object.entries(target.tags).forEach(([key, value])=>{
        if (!$6ff5d677d16b3f9d$var$PROTECTED_KEYS.includes(key)) attrs["source.".concat(key)] = value;
    });
    /** @type {Function} a function that is set and reports when APIs are triggered -- warns the customer of the invalid state  */ let invalidApiResponse = ()=>{};
    /** @type {Array} the array of registered target APIs */ const registeredEntities = agentRef.runtime.registeredEntities;
    /**
   * Block the API, and supply a warning function to display a message to end users
   * @param {Function} warning
   */ const block = (warning)=>{
        target.blocked = true;
        invalidApiResponse = warning;
    };
    function hasValidValue(val) {
        return typeof val === 'string' && !!val.trim() && val.trim().length < 501;
    }
    /** primary cases that can block the register API from working at init time */ if (!agentRef.init.api.register.enabled) block($6ff5d677d16b3f9d$export$cce7aaa89215f32b.disabled);
    if (!hasValidValue(target.id) || !hasValidValue(target.name)) block(()=>$6ff5d677d16b3f9d$export$cce7aaa89215f32b.invalidTarget(target));
    /** @type {RegisterAPI} */ const api = {
        addPageAction: (name, attributes = {})=>report((0, $993f5d61e78f0e40$export$da8763bc9c87dc9f), [
                name,
                {
                    ...attrs,
                    ...attributes
                },
                agentRef
            ], target),
        deregister: ()=>{
            /** note: blocking this instance will disable access for all entities sharing the instance, and will invalidate it from the v2 checks */ reportTimings();
            block($6ff5d677d16b3f9d$export$cce7aaa89215f32b.deregistered);
        },
        log: (message, options = {})=>report((0, $cdaa056a33e152e9$export$bef1f36f5486a6a3), [
                message,
                {
                    ...options,
                    customAttributes: {
                        ...attrs,
                        ...options.customAttributes || {}
                    }
                },
                agentRef
            ], target),
        measure: (name, options = {})=>report((0, $c0107e1a5b272c27$export$83602b44513dc228), [
                name,
                {
                    ...options,
                    customAttributes: {
                        ...attrs,
                        ...options.customAttributes || {}
                    }
                },
                agentRef
            ], target),
        noticeError: (error, attributes = {})=>report((0, $7968f46faaa1de84$export$913138fc7e99dbd3), [
                error,
                {
                    ...attrs,
                    ...attributes
                },
                agentRef
            ], target),
        recordCustomEvent: (eventType, attributes = {})=>report((0, $662eb61fcebf96c5$export$b50bdc6e8a495e8), [
                eventType,
                {
                    ...attrs,
                    ...attributes
                },
                agentRef
            ], target),
        setApplicationVersion: (value)=>setLocalValue('application.version', value),
        setCustomAttribute: (key, value)=>setLocalValue(key, value),
        setUserId: (value)=>setLocalValue('enduser.id', value),
        /** metadata */ metadata: {
            get customAttributes () {
                return attrs;
            },
            target: target,
            timings: timings
        }
    };
    /**
   * Check if the API is blocked and emit a warning message describing the blockage
   * @returns {boolean}
   */ const isBlocked = ()=>{
        if (target.blocked) invalidApiResponse();
        return target.blocked;
    };
    /** only allow registered APIs to be tracked in the agent runtime */ if (!isBlocked()) {
        registeredEntities.push(api);
        (0, $kx4OV.subscribeToPageUnload)(reportTimings);
    }
    /**
   * Reports the gathered timings for the registered entity through a custom event to the container agent. Only reports once
   * by checking for the presence of the reportedAt timing.
   * @returns {void}
   */ function reportTimings() {
        // only ever report the timings the first time this is called
        if (timings.reportedAt) return;
        timings.reportedAt = (0, $1Z3KE.now)();
        const timeToFetch = timings.fetchEnd - timings.fetchStart; // fetchStart to fetchEnd
        const timeToExecute = timings.scriptEnd - timings.scriptStart; // scriptStart to scriptEnd
        api.recordCustomEvent('MicroFrontEndTiming', {
            assetUrl: timings.asset,
            // the url of the script that was registered, or undefined if it could not be determined (inline or no match)
            assetType: timings.type,
            // the type of asset that was associated with the timings, one of 'script', 'link' (if preloaded and found in the resource timing buffer), 'preload' (if preloaded but not found in the resource timing buffer), or "unknown" if it could not be determined
            timeAlive: timings.reportedAt - timings.registeredAt,
            // registeredAt to reportedAt
            timeToBeRequested: timings.fetchStart,
            timeToExecute: // origin to fetchStart
            timeToExecute,
            timeToFetch: // scriptStart to scriptEnd
            timeToFetch,
            // fetchStart to fetchEnd
            timeToLoad: timeToFetch + timeToExecute,
            // fetch time and script time together
            timeToRegister: timings.registeredAt // timestamp when register() was called
        });
    }
    /**
   * Sets a value local to the registered API attrs. Will do nothing if APIs are deregistered.
   * @param {string} key The attribute key
   * @param {*} value the attribute value
   * @returns {void}
   */ const setLocalValue = (key, value)=>{
        if (isBlocked()) return;
        attrs[key] = value;
    };
    /**
     * The reporter method that will be used to report the data to the container agent's API method. If invalid, will log a warning and not execute.
     * If the api.register.duplicate_data_to_container configuration value is set to true, the data will be reported to BOTH the container and the external target
     * @param {*} methodToCall the container agent's API method to call
     * @param {*} args the arguments to supply to the container agent's API method
     * @param {string} target the target to report the data to. If undefined, will report to the container agent's target.
     * @returns
     */ const report = (methodToCall, args, target)=>{
        /** Even if we are blocked, if registering we should still return a child register API so nested API calls do not throw errors */ if (isBlocked() && methodToCall !== $6ff5d677d16b3f9d$var$register) return;
        /** set the timestamp before the async part of waiting for the rum response for better accuracy */ const timestamp = (0, $1Z3KE.now)();
        const methodName = $6ff5d677d16b3f9d$var$METHOD_NAMES.get(methodToCall) || 'unknown';
        (0, $gy0pT.handle)((0, $bu0p3.SUPPORTABILITY_METRIC_CHANNEL), [
            "API/register/".concat(methodName, "/called")
        ], undefined, (0, $3R40a.FEATURE_NAMES).metrics, agentRef.ee);
        try {
            return methodToCall(...args, target, timestamp); // always report to target
        } catch (err) {
            (0, $jkuUu.warn)(50, err);
        }
    };
    return api;
}



class $749ce9262c8db632$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = (0, $3o0w7.FEATURE_NAME);
    constructor(agentRef){
        super(agentRef, (0, $3o0w7.FEATURE_NAME));
        /** feature specific APIs */ (0, $7968f46faaa1de84$export$786e0e69b511ee7d)(agentRef);
        (0, $8f5cd1f33eb667b9$export$eae9b745ac58380b)(agentRef);
        (0, $827b7c69f93c4e0a$export$9e20a01b8f684b14)(agentRef);
        (0, $6ff5d677d16b3f9d$export$86b839ffa8705791)(agentRef);
        try {
            // this try-catch can be removed when IE11 is completely unsupported & gone
            this.removeOnAbort = new AbortController();
        } catch (e) {}
        this.ee.on('internal-error', (error, reason)=>{
            if (!this.abortHandler) return;
            (0, $gy0pT.handle)('ierr', [
                (0, $a85190656292aff3$export$5b4a007fa330967f)(error),
                (0, $1Z3KE.now)(),
                true,
                {},
                agentRef.runtime.isRecording,
                reason
            ], undefined, this.featureName, this.ee);
        });
        (0, $9EKMI.globalScope).addEventListener('unhandledrejection', (promiseRejectionEvent)=>{
            if (!this.abortHandler) return;
            (0, $gy0pT.handle)('err', [
                (0, $a85190656292aff3$export$129374953be01ba)(promiseRejectionEvent),
                (0, $1Z3KE.now)(),
                false,
                {
                    unhandledPromiseRejection: 1
                },
                agentRef.runtime.isRecording
            ], undefined, this.featureName, this.ee);
        }, (0, $8FJov.eventListenerOpts)(false, this.removeOnAbort?.signal));
        (0, $9EKMI.globalScope).addEventListener('error', (errorEvent)=>{
            if (!this.abortHandler) return;
            (0, $gy0pT.handle)('err', [
                (0, $a85190656292aff3$export$9a8f1be0e6183c7e)(errorEvent),
                (0, $1Z3KE.now)(),
                false,
                {},
                agentRef.runtime.isRecording
            ], undefined, this.featureName, this.ee);
        }, (0, $8FJov.eventListenerOpts)(false, this.removeOnAbort?.signal));
        this.abortHandler = this.#abort; // we also use this as a flag to denote that the feature is active or on and handling errors
        this.importAggregator(agentRef, ()=>(parcelRequire("5C29L")));
    }
    /** Restoration and resource release tasks to be done if JS error loader is being aborted. Unwind changes to globals. */ #abort() {
        this.removeOnAbort?.abort();
        this.abortHandler = undefined; // weakly allow this abort op to run only once
    }
}
const $749ce9262c8db632$export$88e6cfaf33474106 = $749ce9262c8db632$export$25ef33f358b07cf4;


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $juL0p = parcelRequire("juL0p");

var $gy0pT = parcelRequire("gy0pT");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $iGnFd = parcelRequire("iGnFd");

var $9EKMI = parcelRequire("9EKMI");
// Start assigning ids at 1 so 0 can always be used for Window or WorkerGlobalScope, without
// actually setting it (which would create a global variable).
let $cbf1f745360bc82d$var$index = 1;
const $cbf1f745360bc82d$var$prop = 'nr@id';
function $cbf1f745360bc82d$export$d560c7e4a29451c2(obj) {
    const type = typeof obj;
    // We can only tag objects, functions, and arrays with ids.
    // For all primitive values we instead return -1.
    if (!obj || !(type === 'object' || type === 'function')) return -1;
    if (obj === (0, $9EKMI.globalScope)) return 0;
    return (0, $iGnFd.getOrSet)(obj, $cbf1f745360bc82d$var$prop, function() {
        return $cbf1f745360bc82d$var$index++;
    });
}



var $9EKMI = parcelRequire("9EKMI");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $8KO5M = parcelRequire("8KO5M");
function $fc7477179bcb58a6$export$a191cda1360036(data) {
    if (typeof data === 'string' && data.length) return data.length;
    if (typeof data !== 'object') return undefined;
    // eslint-disable-next-line
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer && data.byteLength) return data.byteLength;
    if (typeof Blob !== 'undefined' && data instanceof Blob && data.size) return data.size;
    if (typeof FormData !== 'undefined' && data instanceof FormData) return undefined;
    try {
        return (0, $8KO5M.stringify)(data).length;
    } catch (e) {
        return undefined;
    }
}



var $8FJov = parcelRequire("8FJov");
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Wraps AJAX (XHR) related methods for instrumentation.
 * This module is used by: ajax, jserrors.
 */ 
var $32kbo = parcelRequire("32kbo");

var $im7dd = parcelRequire("im7dd");

var $8FJov = parcelRequire("8FJov");

var $gRz07 = parcelRequire("gRz07");

var $9EKMI = parcelRequire("9EKMI");

var $jkuUu = parcelRequire("jkuUu");

var $cPnWJ = parcelRequire("cPnWJ");
const $a6c7b8521094eb4c$var$wrapped = {};
const $a6c7b8521094eb4c$var$XHR_PROPS = [
    'open',
    'send'
]; // these are the specific funcs being wrapped on all XMLHttpRequests(.prototype)
function $a6c7b8521094eb4c$export$b3d77aa926f142b4(sharedEE, agentRef) {
    var baseEE = sharedEE || (0, $im7dd.ee);
    const ee = $a6c7b8521094eb4c$export$b88e0ef4192fcaff(baseEE);
    if (typeof (0, $9EKMI.globalScope).XMLHttpRequest === 'undefined') return ee;
    // Notice if our wrapping never ran yet, the falsy NaN will not early return; but if it has,
    // then we increment the count to track # of feats using this at runtime.
    if ($a6c7b8521094eb4c$var$wrapped[ee.debugId]++) return ee;
    $a6c7b8521094eb4c$var$wrapped[ee.debugId] = 1; // otherwise, first feature to wrap XHR
    (0, $32kbo.wrapEvents)(baseEE); // wrap-events patches XMLHttpRequest.prototype.addEventListener for us
    var wrapFn = (0, $gRz07.createWrapperWithEmitter)(ee);
    var OrigXHR = (0, $9EKMI.globalScope).XMLHttpRequest;
    var MutationObserver = (0, $9EKMI.globalScope).MutationObserver;
    var Promise = (0, $9EKMI.globalScope).Promise;
    var setImmediate = (0, $9EKMI.globalScope).setInterval;
    var READY_STATE_CHANGE = 'readystatechange';
    var handlers = [
        'onload',
        'onerror',
        'onabort',
        'onloadstart',
        'onloadend',
        'onprogress',
        'ontimeout'
    ];
    var pendingXhrs = [];
    var XHR = (0, $9EKMI.globalScope).XMLHttpRequest = newXHR;
    function newXHR(opts) {
        const xhr = new OrigXHR(opts);
        const context = ee.context(xhr);
        context.targets = (0, $cPnWJ.findTargetsFromStackTrace)(agentRef);
        try {
            ee.emit('new-xhr', [
                xhr
            ], context);
            xhr.addEventListener(READY_STATE_CHANGE, wrapXHR(context), (0, $8FJov.eventListenerOpts)(false));
        } catch (e) {
            (0, $jkuUu.warn)(15, e);
            try {
                ee.emit('internal-error', [
                    e
                ]);
            } catch (err) {
            // do nothing
            }
        }
        return xhr;
    }
    copy(OrigXHR, XHR);
    XHR.prototype = OrigXHR.prototype;
    wrapFn.inPlace(XHR.prototype, $a6c7b8521094eb4c$var$XHR_PROPS, '-xhr-', getObject);
    ee.on('send-xhr-start', function(args, xhr) {
        wrapOnreadystatechange(args, xhr);
        enqueuePendingXhr(xhr);
    });
    ee.on('open-xhr-start', wrapOnreadystatechange);
    function wrapOnreadystatechange(args, xhr) {
        wrapFn.inPlace(xhr, [
            'onreadystatechange'
        ], 'fn-', getObject);
    }
    function wrapXHR(ctx) {
        return function() {
            var xhr = this;
            if (xhr.readyState > 3 && !ctx.resolved) {
                ctx.resolved = true;
                ee.emit('xhr-resolved', [], xhr);
            }
            wrapFn.inPlace(xhr, handlers, 'fn-', getObject);
        };
    }
    // Wrapping the onreadystatechange property of XHRs takes some special tricks.
    //
    // The issue is that the onreadystatechange property may be assigned *after*
    // send() is called against an XHR. This is of particular importance because
    // jQuery uses a single onreadystatechange handler to implement all of the XHR
    // callbacks thtat it provides, and it assigns that property after calling send.
    //
    // There are several 'obvious' approaches to wrapping the onreadystatechange
    // when it's assigned after send:
    //
    // 1. Try to wrap the onreadystatechange handler from a readystatechange
    //    addEventListener callback (the addEventListener callback will fire before
    //    the onreadystatechange callback).
    //
    //      Caveat: this doesn't work in Chrome or Safari, and in fact will cause
    //      the onreadystatechange handler to not be invoked at all during the
    //      firing cycle in which it is wrapped, which may break applications :(
    //
    // 2. Use Object.defineProperty to create a setter for the onreadystatechange
    //    property, and wrap from that setter.
    //
    //      Caveat: onreadystatechange is not a configurable property in Safari or
    //      older versions of the Android browser.
    //
    // 3. Schedule wrapping of the onreadystatechange property using a setTimeout
    //    call issued just before the call to send.
    //
    //      Caveat: sometimes, the onreadystatechange handler fires before the
    //      setTimeout, meaning the wrapping happens too late.
    //
    // The setTimeout approach is closest to what we use here: we want to schedule
    // the wrapping of the onreadystatechange property when send is called, but
    // ensure that our wrapping happens before onreadystatechange has a chance to
    // fire.
    //
    // We achieve this using a hybrid approach:
    //
    // * In browsers that support MutationObserver, we use that to schedule wrapping
    //   of onreadystatechange.
    //
    // * We have discovered that MutationObserver in IE causes a memory leak, so we
    //   now will prefer setImmediate for IE, and use a resolved promise to schedule
    //   the wrapping in Edge (and other browsers that support promises)
    //
    // * In older browsers that don't support MutationObserver, we rely on the fact
    //   that the call to send is probably happening within a callback that we've
    //   already wrapped, and use our existing fn-end event callback to wrap the
    //   onreadystatechange at the end of the current callback.
    //
    if (MutationObserver) {
        var resolved = Promise && Promise.resolve();
        if (!setImmediate && !Promise) {
            var toggle = 1;
            var dummyNode = document.createTextNode(toggle);
            new MutationObserver(drainPendingXhrs).observe(dummyNode, {
                characterData: true
            });
        }
    } else // this below case applies to web workers too
    baseEE.on('fn-end', function(args) {
        // We don't want to try to wrap onreadystatechange from within a
        // readystatechange callback.
        if (args[0] && args[0].type === READY_STATE_CHANGE) return;
        drainPendingXhrs();
    });
    function enqueuePendingXhr(xhr) {
        pendingXhrs.push(xhr);
        if (MutationObserver) {
            if (resolved) resolved.then(drainPendingXhrs);
            else if (setImmediate) setImmediate(drainPendingXhrs);
            else {
                toggle = -toggle;
                dummyNode.data = toggle;
            }
        }
    }
    function drainPendingXhrs() {
        for(var i = 0; i < pendingXhrs.length; i++)wrapOnreadystatechange([], pendingXhrs[i]);
        if (pendingXhrs.length) pendingXhrs = [];
    }
    // Use the object these methods are on as their
    // context store for the event emitter
    function getObject(args, obj) {
        return obj;
    }
    function copy(from, to) {
        for(var i in from)to[i] = from[i];
        return to;
    }
    return ee;
}
function $a6c7b8521094eb4c$export$b88e0ef4192fcaff(sharedEE) {
    return (sharedEE || (0, $im7dd.ee)).get('xhr');
}


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Wraps `fetch` and related methods for instrumentation.
 * This module is used by: ajax.
 */ 
var $im7dd = parcelRequire("im7dd");

var $9EKMI = parcelRequire("9EKMI");

var $cPnWJ = parcelRequire("cPnWJ");
var $5862b924e27f1665$var$prefix = 'fetch-';
var $5862b924e27f1665$var$bodyPrefix = $5862b924e27f1665$var$prefix + 'body-';
var $5862b924e27f1665$var$bodyMethods = [
    'arrayBuffer',
    'blob',
    'json',
    'text',
    'formData'
];
var $5862b924e27f1665$var$Req = (0, $9EKMI.globalScope).Request;
var $5862b924e27f1665$var$Res = (0, $9EKMI.globalScope).Response;
var $5862b924e27f1665$var$proto = 'prototype';
const $5862b924e27f1665$var$wrapped = {};
function $5862b924e27f1665$export$df01d05734964b1a(sharedEE, agentRef) {
    const ee = $5862b924e27f1665$export$b88e0ef4192fcaff(sharedEE);
    if (!($5862b924e27f1665$var$Req && $5862b924e27f1665$var$Res && (0, $9EKMI.globalScope).fetch)) return ee;
    // Notice if our wrapping never ran yet, the falsy NaN will not early return; but if it has,
    // then we increment the count to track # of feats using this at runtime.
    if ($5862b924e27f1665$var$wrapped[ee.debugId]++) return ee;
    $5862b924e27f1665$var$wrapped[ee.debugId] = 1; // otherwise, first feature to wrap fetch
    $5862b924e27f1665$var$bodyMethods.forEach((method)=>{
        wrapPromiseMethod($5862b924e27f1665$var$Req[$5862b924e27f1665$var$proto], method, $5862b924e27f1665$var$bodyPrefix);
        wrapPromiseMethod($5862b924e27f1665$var$Res[$5862b924e27f1665$var$proto], method, $5862b924e27f1665$var$bodyPrefix);
    });
    wrapPromiseMethod((0, $9EKMI.globalScope), 'fetch', $5862b924e27f1665$var$prefix);
    ee.on($5862b924e27f1665$var$prefix + 'end', function(err, res, targets) {
        var ctx = this;
        // undefined target reports to container
        ctx.targets = targets || [
            undefined
        ];
        if (res) {
            var size = res.headers.get('content-length');
            if (size !== null) ctx.rxSize = size;
            ee.emit($5862b924e27f1665$var$prefix + 'done', [
                null,
                res
            ], ctx);
        } else ee.emit($5862b924e27f1665$var$prefix + 'done', [
            err
        ], ctx);
    });
    /**
   * Wraps a Promise-returning function (referenced by `target[name]`) to emit custom events before and after
   * execution, each decorated with metadata (arguments, payloads, errors). Used to wrap the async body
   * parsing methods of Request and Response (e.g. `json`, `text`, `formData`).
   * @param {Object} target - The object having the method to be wrapped.
   * @param {string} name - The name of the method to wrap.
   * @param {string} prefix - Used to decorate event names with context.
   */ function wrapPromiseMethod(target, name, prefix) {
        var fn = target[name];
        if (typeof fn === 'function') target[name] = function() {
            var args = [
                ...arguments
            ];
            const ctx = {};
            const targets = (0, $cPnWJ.findTargetsFromStackTrace)(agentRef);
            // we are wrapping args in an array so we can preserve the reference
            ee.emit(prefix + 'before-start', [
                args
            ], ctx);
            var dtPayload;
            if (ctx[0, $im7dd.contextId] && ctx[0, $im7dd.contextId].dt) dtPayload = ctx[0, $im7dd.contextId].dt;
            var origPromiseFromFetch = fn.apply(this, args);
            ee.emit(prefix + 'start', [
                args,
                dtPayload
            ], origPromiseFromFetch);
            // Note we need to cast the returned (orig) Promise from native APIs into the current global Promise, which may or may not be our WrappedPromise.
            return origPromiseFromFetch.then(function(val) {
                ee.emit(prefix + 'end', [
                    null,
                    val,
                    targets
                ], origPromiseFromFetch);
                return val;
            }, function(err) {
                ee.emit(prefix + 'end', [
                    err,
                    undefined,
                    targets
                ], origPromiseFromFetch);
                throw err;
            });
        };
    }
    return ee;
}
function $5862b924e27f1665$export$b88e0ef4192fcaff(sharedEE) {
    return (sharedEE || (0, $im7dd.ee)).get('fetch');
}



var $5qa2T = parcelRequire("5qa2T");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $6sT7C = parcelRequire("6sT7C");

var $5qa2T = parcelRequire("5qa2T");

var $9EKMI = parcelRequire("9EKMI");

var $8KO5M = parcelRequire("8KO5M");
class $230be9cdcfe558ee$export$94660f04199121f6 {
    constructor(agentRef){
        this.agentRef = agentRef;
    }
    generateTracePayload(parsedOrigin) {
        const loaderConfig = this.agentRef.loader_config;
        if (!this.shouldGenerateTrace(parsedOrigin) || !loaderConfig) return null;
        var accountId = (loaderConfig.accountID || '').toString() || null;
        var agentId = (loaderConfig.agentID || '').toString() || null;
        var trustKey = (loaderConfig.trustKey || '').toString() || null;
        if (!accountId || !agentId) return null;
        var spanId = (0, $6sT7C.generateSpanId)();
        var traceId = (0, $6sT7C.generateTraceId)();
        var timestamp = Date.now();
        var payload = {
            spanId: spanId,
            traceId: traceId,
            timestamp: timestamp
        };
        if (parsedOrigin.sameOrigin || this.isAllowedOrigin(parsedOrigin) && this.useTraceContextHeadersForCors()) {
            payload.traceContextParentHeader = this.generateTraceContextParentHeader(spanId, traceId);
            payload.traceContextStateHeader = this.generateTraceContextStateHeader(spanId, timestamp, accountId, agentId, trustKey);
        }
        if (parsedOrigin.sameOrigin && !this.excludeNewrelicHeader() || !parsedOrigin.sameOrigin && this.isAllowedOrigin(parsedOrigin) && this.useNewrelicHeaderForCors()) payload.newrelicHeader = this.generateTraceHeader(spanId, traceId, timestamp, accountId, agentId, trustKey);
        return payload;
    }
    generateTraceContextParentHeader(spanId, traceId) {
        return '00-' + traceId + '-' + spanId + '-01';
    }
    generateTraceContextStateHeader(spanId, timestamp, accountId, appId, trustKey) {
        var version = 0;
        var transactionId = '';
        var parentType = 1;
        var sampled = '';
        var priority = '';
        return trustKey + '@nr=' + version + '-' + parentType + '-' + accountId + '-' + appId + '-' + spanId + '-' + transactionId + '-' + sampled + '-' + priority + '-' + timestamp;
    }
    generateTraceHeader(spanId, traceId, timestamp, accountId, appId, trustKey) {
        var hasBtoa = typeof (0, $9EKMI.globalScope)?.btoa === 'function';
        if (!hasBtoa) return null;
        var payload = {
            v: [
                0,
                1
            ],
            d: {
                ty: 'Browser',
                ac: accountId,
                ap: appId,
                id: spanId,
                tr: traceId,
                ti: timestamp
            }
        };
        if (trustKey && accountId !== trustKey) payload.d.tk = trustKey;
        return btoa((0, $8KO5M.stringify)(payload));
    }
    // return true if DT is enabled and the origin is allowed, either by being
    // same-origin, or included in the allowed list
    shouldGenerateTrace(parsedOrigin) {
        return this.agentRef.init?.distributed_tracing?.enabled && this.isAllowedOrigin(parsedOrigin);
    }
    isAllowedOrigin(parsedOrigin) {
        var allowed = false;
        const dtConfig = this.agentRef.init?.distributed_tracing;
        if (parsedOrigin.sameOrigin) allowed = true;
        else if (dtConfig?.allowed_origins instanceof Array) for(var i = 0; i < dtConfig.allowed_origins.length; i++){
            var allowedOrigin = (0, $5qa2T.parseUrl)(dtConfig.allowed_origins[i]);
            if (parsedOrigin.hostname === allowedOrigin.hostname && parsedOrigin.protocol === allowedOrigin.protocol && parsedOrigin.port === allowedOrigin.port) {
                allowed = true;
                break;
            }
        }
        return allowed;
    }
    // exclude the newrelic header for same-origin calls
    excludeNewrelicHeader() {
        var dt = this.agentRef.init?.distributed_tracing;
        if (dt) return !!dt.exclude_newrelic_header;
        return false;
    }
    useNewrelicHeaderForCors() {
        var dt = this.agentRef.init?.distributed_tracing;
        if (dt) return dt.cors_use_newrelic_header !== false;
        return false;
    }
    useTraceContextHeadersForCors() {
        var dt = this.agentRef.init?.distributed_tracing;
        if (dt) return !!dt.cors_use_tracecontext_headers;
        return false;
    }
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
function $73d9e4c120f68cbe$export$3d0e173d253ef884(xhr, lastSize) {
    var type = xhr.responseType;
    if (type === 'json' && lastSize !== null) return lastSize;
    // Caution! Chrome throws an error if you try to access xhr.responseText for binary data
    if (type === 'arraybuffer' || type === 'blob' || type === 'json') return (0, $fc7477179bcb58a6$export$a191cda1360036)(xhr.response);
    else if (type === 'text' || type === '' || type === undefined) // empty string type defaults to 'text'
    return (0, $fc7477179bcb58a6$export$a191cda1360036)(xhr.responseText);
    else // e.g. ms-stream and document (we do not currently determine the size of Document objects)
    return undefined;
}




var $e2uyi = parcelRequire("e2uyi");

var $3R40a = parcelRequire("3R40a");

var $bu0p3 = parcelRequire("bu0p3");

var $1Z3KE = parcelRequire("1Z3KE");

var $9ZQLQ = parcelRequire("9ZQLQ");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");

var $juL0p = parcelRequire("juL0p");
function $694d25d082b25378$export$c53fc68ceaaa90d2(target) {
    if (typeof target === 'string') return target;
    else if (target instanceof (0, $juL0p.gosNREUMOriginals)().o.REQ) return target.url;
    else if ((0, $9EKMI.globalScope)?.URL && target instanceof URL) return target.href;
}


var $b9fc03f3a542c7e9$var$handlers = [
    'load',
    'error',
    'abort',
    'timeout'
];
var $b9fc03f3a542c7e9$var$handlersLen = $b9fc03f3a542c7e9$var$handlers.length;
var $b9fc03f3a542c7e9$var$origRequest = (0, $juL0p.gosNREUMOriginals)().o.REQ;
var $b9fc03f3a542c7e9$var$origXHR = (0, $juL0p.gosNREUMOriginals)().o.XHR;
const $b9fc03f3a542c7e9$var$NR_CAT_HEADER = 'X-NewRelic-App-Data';

class $b9fc03f3a542c7e9$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = (0, $e2uyi.FEATURE_NAME);
    constructor(agentRef){
        super(agentRef, (0, $e2uyi.FEATURE_NAME));
        this.dt = new (0, $230be9cdcfe558ee$export$94660f04199121f6)(agentRef);
        this.handler = (type, args, ctx, group)=>(0, $gy0pT.handle)(type, args, ctx, group, this.ee);
        // this is a best (but imperfect) effort at capturing AJAX calls that may have fired before the agent was instantiated
        // this could happen because the agent was "improperly" set up (ie, not at the top of the head) or
        // because it was deferred from loading in some way -- e.g. 'deferred' script loading tags or other lazy-loading techniques
        //
        // it is "imperfect" because we cannot capture the following with the API vs wrapping the events directly:
        // * requestBodySize - (txSize -- request body size)
        // * method - request type (GET, POST, etc)
        // * callbackDuration - (cbTime -- sum of resulting callback time)
        try {
            const initiators = {
                xmlhttprequest: 'xhr',
                fetch: 'fetch',
                beacon: 'beacon'
            };
            (0, $9EKMI.globalScope)?.performance?.getEntriesByType('resource').forEach((resource)=>{
                if (resource.initiatorType in initiators && resource.responseStatus !== 0) {
                    const params = {
                        status: resource.responseStatus
                    };
                    const metrics = {
                        rxSize: resource.transferSize,
                        duration: Math.floor(resource.duration),
                        cbTime: 0
                    };
                    $b9fc03f3a542c7e9$var$addUrl(params, resource.name);
                    this.handler('xhr', [
                        params,
                        metrics,
                        resource.startTime,
                        resource.responseEnd,
                        initiators[resource.initiatorType]
                    ], undefined, (0, $3R40a.FEATURE_NAMES).ajax);
                }
            });
        } catch (err) {
        // do nothing
        }
        (0, $5862b924e27f1665$export$df01d05734964b1a)(this.ee, agentRef);
        (0, $a6c7b8521094eb4c$export$b3d77aa926f142b4)(this.ee, agentRef);
        $b9fc03f3a542c7e9$var$subscribeToEvents(agentRef, this.ee, this.handler, this.dt);
        this.importAggregator(agentRef, ()=>(parcelRequire("k6inY")));
    }
}
function $b9fc03f3a542c7e9$var$subscribeToEvents(agentRef, ee, handler, dt) {
    ee.on('new-xhr', onNewXhr);
    ee.on('open-xhr-start', onOpenXhrStart);
    ee.on('open-xhr-end', onOpenXhrEnd);
    ee.on('send-xhr-start', onSendXhrStart);
    ee.on('xhr-cb-time', onXhrCbTime);
    ee.on('xhr-load-added', onXhrLoadAdded);
    ee.on('xhr-load-removed', onXhrLoadRemoved);
    ee.on('xhr-resolved', onXhrResolved);
    ee.on('addEventListener-end', onAddEventListenerEnd);
    ee.on('removeEventListener-end', onRemoveEventListenerEnd);
    ee.on('fn-end', onFnEnd);
    ee.on('fetch-before-start', onFetchBeforeStart);
    ee.on('fetch-start', onFetchStart);
    ee.on('fn-start', onFnStart);
    ee.on('fetch-done', onFetchDone);
    // Setup the context for each new xhr object
    function onNewXhr(xhr) {
        var ctx = this;
        ctx.totalCbs = 0;
        ctx.called = 0;
        ctx.cbTime = 0;
        ctx.end = end;
        ctx.ended = false;
        ctx.xhrGuids = {};
        ctx.lastSize = null;
        ctx.loadCaptureCalled = false;
        ctx.params = this.params || {};
        ctx.metrics = this.metrics || {};
        ctx.latestLongtaskEnd = 0;
        xhr.addEventListener('load', function(event) {
            captureXhrData(ctx, xhr);
        }, (0, $8FJov.eventListenerOpts)(false));
        // In Firefox (v34+), XHR ProgressEvents report pre-content-decoding sizes via
        // their 'loaded' property, rather than post-decoding sizes. We want
        // post-decoding sizes for consistency with browsers where that's all we have.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1227674
        //
        // So we don't use ProgressEvents to measure XHR sizes for FF.
        if (0, $9EKMI.ffVersion) return;
        xhr.addEventListener('progress', function(event) {
            ctx.lastSize = event.loaded;
        }, (0, $8FJov.eventListenerOpts)(false));
    }
    function onOpenXhrStart(args) {
        this.params = {
            method: args[0]
        };
        $b9fc03f3a542c7e9$var$addUrl(this, args[1]);
        this.metrics = {};
    }
    function onOpenXhrEnd(args, xhr) {
        if (agentRef.loader_config.xpid && this.sameOrigin) xhr.setRequestHeader('X-NewRelic-ID', agentRef.loader_config.xpid);
        var payload = dt.generateTracePayload(this.parsedOrigin);
        if (payload) {
            var added = false;
            if (payload.newrelicHeader) {
                xhr.setRequestHeader('newrelic', payload.newrelicHeader);
                added = true;
            }
            if (payload.traceContextParentHeader) {
                xhr.setRequestHeader('traceparent', payload.traceContextParentHeader);
                if (payload.traceContextStateHeader) xhr.setRequestHeader('tracestate', payload.traceContextStateHeader);
                added = true;
            }
            if (added) this.dt = payload;
        }
    }
    function onSendXhrStart(args, xhr) {
        var metrics = this.metrics;
        var data = args[0];
        var context = this;
        if (metrics && data) {
            var size = (0, $fc7477179bcb58a6$export$a191cda1360036)(data);
            if (size) metrics.txSize = size;
        }
        this.startTime = (0, $1Z3KE.now)();
        this.body = data;
        this.listener = function(evt) {
            try {
                if (evt.type === 'abort' && !context.loadCaptureCalled) context.params.aborted = true;
                if (evt.type !== 'load' || context.called === context.totalCbs && (context.onloadCalled || typeof xhr.onload !== 'function') && typeof context.end === 'function') context.end(xhr);
            } catch (e) {
                try {
                    ee.emit('internal-error', [
                        e
                    ]);
                } catch (err) {
                // do nothing
                }
            }
        };
        for(var i = 0; i < $b9fc03f3a542c7e9$var$handlersLen; i++)xhr.addEventListener($b9fc03f3a542c7e9$var$handlers[i], this.listener, (0, $8FJov.eventListenerOpts)(false));
    }
    function onXhrCbTime(time, onload, xhr) {
        this.cbTime += time;
        if (onload) this.onloadCalled = true;
        else this.called += 1;
        if (this.called === this.totalCbs && (this.onloadCalled || typeof xhr.onload !== 'function') && typeof this.end === 'function') this.end(xhr);
    }
    function onXhrLoadAdded(cb, useCapture) {
        // Ignore if the same arguments are passed to addEventListener twice
        var idString = '' + (0, $cbf1f745360bc82d$export$d560c7e4a29451c2)(cb) + !!useCapture;
        if (!this.xhrGuids || this.xhrGuids[idString]) return;
        this.xhrGuids[idString] = true;
        this.totalCbs += 1;
    }
    function onXhrLoadRemoved(cb, useCapture) {
        // Ignore if event listener didn't exist for this xhr object
        var idString = '' + (0, $cbf1f745360bc82d$export$d560c7e4a29451c2)(cb) + !!useCapture;
        if (!this.xhrGuids || !this.xhrGuids[idString]) return;
        delete this.xhrGuids[idString];
        this.totalCbs -= 1;
    }
    function onXhrResolved() {
        this.endTime = (0, $1Z3KE.now)();
    }
    // Listen for load listeners to be added to xhr objects
    function onAddEventListenerEnd(args, xhr) {
        if (xhr instanceof $b9fc03f3a542c7e9$var$origXHR && args[0] === 'load') ee.emit('xhr-load-added', [
            args[1],
            args[2]
        ], xhr);
    }
    function onRemoveEventListenerEnd(args, xhr) {
        if (xhr instanceof $b9fc03f3a542c7e9$var$origXHR && args[0] === 'load') ee.emit('xhr-load-removed', [
            args[1],
            args[2]
        ], xhr);
    }
    // Listen for those load listeners to be called.
    function onFnStart(args, xhr, methodName) {
        if (xhr instanceof $b9fc03f3a542c7e9$var$origXHR) {
            if (methodName === 'onload') this.onload = true;
            if ((args[0] && args[0].type) === 'load' || this.onload) this.xhrCbStart = (0, $1Z3KE.now)();
        }
    }
    function onFnEnd(args, xhr) {
        if (this.xhrCbStart) ee.emit('xhr-cb-time', [
            (0, $1Z3KE.now)() - this.xhrCbStart,
            this.onload,
            xhr
        ], xhr);
    }
    // this event only handles DT
    function onFetchBeforeStart(args) {
        var opts = args[1] || {};
        var url;
        if (typeof args[0] === 'string') {
            // argument is USVString
            url = args[0];
            if (url.length === 0 && (0, $9EKMI.isBrowserScope)) url = '' + (0, $9EKMI.globalScope).location.href;
        } else if (args[0] && args[0].url) // argument is Request object
        url = args[0].url;
        else if ((0, $9EKMI.globalScope)?.URL && args[0] && args[0] instanceof URL) // argument is URL object
        url = args[0].href;
        else if (typeof args[0].toString === 'function') url = args[0].toString();
        if (typeof url !== 'string' || url.length === 0) // Short-circuit DT since we could not determine the URL of the fetch call
        // this is very unlikely to happen
        return;
        if (url) {
            this.parsedOrigin = (0, $5qa2T.parseUrl)(url);
            this.sameOrigin = this.parsedOrigin.sameOrigin;
        }
        var payload = dt.generateTracePayload(this.parsedOrigin);
        if (!payload || !payload.newrelicHeader && !payload.traceContextParentHeader) return;
        if (args[0] && args[0].headers) {
            if (addHeaders(args[0].headers, payload)) this.dt = payload;
        } else {
            var clone = {};
            for(var key in opts)clone[key] = opts[key];
            clone.headers = new Headers(opts.headers || {});
            if (addHeaders(clone.headers, payload)) this.dt = payload;
            if (args.length > 1) args[1] = clone;
            else args.push(clone);
        }
        function addHeaders(headersObj, payload) {
            var added = false;
            if (payload.newrelicHeader) {
                headersObj.set('newrelic', payload.newrelicHeader);
                added = true;
            }
            if (payload.traceContextParentHeader) {
                headersObj.set('traceparent', payload.traceContextParentHeader);
                if (payload.traceContextStateHeader) headersObj.set('tracestate', payload.traceContextStateHeader);
                added = true;
            }
            return added;
        }
    }
    function onFetchStart(fetchArguments, dtPayload) {
        this.params = {};
        this.metrics = {};
        this.startTime = (0, $1Z3KE.now)();
        this.dt = dtPayload;
        let [target, opts = {}] = fetchArguments;
        $b9fc03f3a542c7e9$var$addUrl(this, (0, $694d25d082b25378$export$c53fc68ceaaa90d2)(target));
        const method = ('' + (target && target instanceof $b9fc03f3a542c7e9$var$origRequest && target.method || opts.method || 'GET')).toUpperCase();
        this.params.method = method;
        this.body = opts.body;
        this.txSize = (0, $fc7477179bcb58a6$export$a191cda1360036)(opts.body) || 0;
    }
    // we capture failed call as status 0, the actual error is ignored
    // eslint-disable-next-line handle-callback-err
    function onFetchDone(_, res) {
        this.endTime = (0, $1Z3KE.now)();
        if (!this.params) this.params = {};
        if ((0, $9ZQLQ.hasUndefinedHostname)(this.params)) return; // don't bother with fetch to url with no hostname
        this.params.status = res ? res.status : 0;
        // convert rxSize to a number
        let responseSize;
        if (typeof this.rxSize === 'string' && this.rxSize.length > 0) responseSize = +this.rxSize;
        const metrics = {
            txSize: this.txSize,
            rxSize: responseSize,
            duration: (0, $1Z3KE.now)() - this.startTime
        };
        const payload = [
            this.params,
            metrics,
            this.startTime,
            this.endTime,
            'fetch'
        ];
        this.targets.forEach((target)=>reportToAgg(payload, this, target));
    }
    // Create report for XHR request that has finished
    function end(xhr) {
        const params = this.params;
        const metrics = this.metrics;
        if (this.ended) return;
        this.ended = true;
        for(let i = 0; i < $b9fc03f3a542c7e9$var$handlersLen; i++)xhr.removeEventListener($b9fc03f3a542c7e9$var$handlers[i], this.listener, false);
        if (params.aborted) return;
        if ((0, $9ZQLQ.hasUndefinedHostname)(params)) return; // don't bother with XHR of url with no hostname
        metrics.duration = (0, $1Z3KE.now)() - this.startTime;
        if (!this.loadCaptureCalled && xhr.readyState === 4) captureXhrData(this, xhr);
        else if (params.status == null) params.status = 0;
        // Always send cbTime, even if no noticeable time was taken.
        metrics.cbTime = this.cbTime;
        const payload = [
            params,
            metrics,
            this.startTime,
            this.endTime,
            'xhr'
        ];
        this.targets.forEach((target)=>reportToAgg(payload, this, target));
    }
    function reportToAgg(payload, context, target) {
        handler('xhr', [
            ...payload,
            target
        ], context, (0, $3R40a.FEATURE_NAMES).ajax);
    }
    function captureXhrData(ctx, xhr) {
        ctx.params.status = xhr.status;
        var size = (0, $73d9e4c120f68cbe$export$3d0e173d253ef884)(xhr, ctx.lastSize);
        if (size) ctx.metrics.rxSize = size;
        if (ctx.sameOrigin && xhr.getAllResponseHeaders().indexOf($b9fc03f3a542c7e9$var$NR_CAT_HEADER) >= 0) {
            var header = xhr.getResponseHeader($b9fc03f3a542c7e9$var$NR_CAT_HEADER);
            if (header) {
                (0, $gy0pT.handle)((0, $bu0p3.SUPPORTABILITY_METRIC), [
                    'Ajax/CrossApplicationTracing/Header/Seen'
                ], undefined, (0, $3R40a.FEATURE_NAMES).metrics, ee);
                ctx.params.cat = header.split(', ').pop();
            }
        }
        ctx.loadCaptureCalled = true;
    }
}
function $b9fc03f3a542c7e9$var$addUrl(ctx, url) {
    var parsed = (0, $5qa2T.parseUrl)(url);
    var params = ctx.params || ctx;
    params.hostname = parsed.hostname;
    params.port = parsed.port;
    params.protocol = parsed.protocol;
    params.host = parsed.hostname + ':' + parsed.port;
    params.pathname = parsed.pathname;
    ctx.parsedOrigin = parsed;
    ctx.sameOrigin = parsed.sameOrigin;
}
const $b9fc03f3a542c7e9$export$7a330199b2e76989 = $b9fc03f3a542c7e9$export$25ef33f358b07cf4;


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Wraps `pushState` and `replaceState` methods of `window.history` object for instrumentation.
 * This module is used by: session_trace, soft_navigations.
 */ 
var $im7dd = parcelRequire("im7dd");

var $gRz07 = parcelRequire("gRz07");

var $9EKMI = parcelRequire("9EKMI");
const $90bb56ea558bd526$var$wrapped = {};
const $90bb56ea558bd526$var$HISTORY_FNS = [
    'pushState',
    'replaceState'
];
function $90bb56ea558bd526$export$7bd1d3939ac0b192(sharedEE) {
    const ee = $90bb56ea558bd526$export$b88e0ef4192fcaff(sharedEE);
    // Notice if our wrapping never ran yet, the falsy NaN will not early return; but if it has,
    // then we increment the count to track # of feats using this at runtime. History API is only
    // available in browser DOM context.
    if (!(0, $9EKMI.isBrowserScope) || $90bb56ea558bd526$var$wrapped[ee.debugId]++) return ee;
    $90bb56ea558bd526$var$wrapped[ee.debugId] = 1; // otherwise, first feature to wrap history
    var wrapFn = (0, $gRz07.createWrapperWithEmitter)(ee);
    /*
   * For objects that will be instantiated more than once, we wrap the object's prototype methods. The history object
   * is instantiated only once, so we can wrap its methods directly--and we must wrap the history methods directly as
   * long as [Chromium issue 783382](https://bugs.chromium.org/p/chromium/issues/detail?id=783382) remains unresolved.
   */ wrapFn.inPlace(window.history, $90bb56ea558bd526$var$HISTORY_FNS, '-');
    return ee;
}
function $90bb56ea558bd526$export$b88e0ef4192fcaff(sharedEE) {
    return (sharedEE || (0, $im7dd.ee)).get('history');
}



var $32kbo = parcelRequire("32kbo");


var $adIx8 = parcelRequire("adIx8");

var $3R40a = parcelRequire("3R40a");

var $1orxZ = parcelRequire("1orxZ");

var $1Z3KE = parcelRequire("1Z3KE");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");

var $gy0pT = parcelRequire("gy0pT");

var $jkuUu = parcelRequire("jkuUu");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $4ff02c11237625ba$export$10fbefa260136c3a(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.ADD_TO_TRACE), function(evt) {
        if (!(evt && typeof evt === 'object' && evt.name && evt.start)) return;
        const report = {
            n: evt.name,
            s: evt.start - (0, $9EKMI.originTime),
            e: (evt.end || evt.start) - (0, $9EKMI.originTime),
            o: evt.origin || '',
            t: 'api'
        };
        if (report.s < 0 || report.e < 0 || report.e < report.s) {
            (0, $jkuUu.warn)(61, {
                start: report.s,
                end: report.e
            });
            return;
        }
        (0, $gy0pT.handle)('bstApi', [
            report
        ], undefined, (0, $3R40a.FEATURE_NAMES).sessionTrace, agent.ee);
    }, agent);
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");

var $gy0pT = parcelRequire("gy0pT");

var $jkuUu = parcelRequire("jkuUu");

var $bu0p3 = parcelRequire("bu0p3");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $c1baabe200c8f115$export$e2f3e76b55a5733e(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.FINISHED), function(unixTime = Date.now()) {
        const relativeTime = unixTime - (0, $9EKMI.originTime);
        if (relativeTime < 0) (0, $jkuUu.warn)(62, unixTime);
        (0, $gy0pT.handle)((0, $bu0p3.CUSTOM_METRIC_CHANNEL), [
            (0, $4uE6N.FINISHED),
            {
                time: relativeTime
            }
        ], undefined, (0, $3R40a.FEATURE_NAMES).metrics, agent.ee);
        agent.addToTrace({
            name: (0, $4uE6N.FINISHED),
            start: unixTime,
            origin: 'nr'
        });
        (0, $gy0pT.handle)((0, $4uE6N.prefix) + (0, $4uE6N.ADD_PAGE_ACTION), [
            relativeTime,
            (0, $4uE6N.FINISHED)
        ], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, agent.ee);
    }, agent);
}


const { BST_RESOURCE: $ecb6e9bf14f82981$var$BST_RESOURCE, RESOURCE: $ecb6e9bf14f82981$var$RESOURCE, START: $ecb6e9bf14f82981$var$START, END: $ecb6e9bf14f82981$var$END, FEATURE_NAME: $ecb6e9bf14f82981$var$FEATURE_NAME, FN_END: $ecb6e9bf14f82981$var$FN_END, FN_START: $ecb6e9bf14f82981$var$FN_START, PUSH_STATE: $ecb6e9bf14f82981$var$PUSH_STATE } = $adIx8;

class $ecb6e9bf14f82981$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = $ecb6e9bf14f82981$var$FEATURE_NAME;
    constructor(agentRef){
        super(agentRef, $ecb6e9bf14f82981$var$FEATURE_NAME);
        /** feature specific APIs */ (0, $4ff02c11237625ba$export$10fbefa260136c3a)(agentRef);
        (0, $c1baabe200c8f115$export$e2f3e76b55a5733e)(agentRef);
        const canTrackSession = (0, $1orxZ.canEnableSessionTracking)(agentRef.init);
        if (!canTrackSession) {
            this.deregisterDrain();
            return;
        }
        const thisInstrumentEE = this.ee;
        (0, $90bb56ea558bd526$export$7bd1d3939ac0b192)(thisInstrumentEE);
        this.eventsEE = (0, $32kbo.wrapEvents)(thisInstrumentEE);
        this.eventsEE.on($ecb6e9bf14f82981$var$FN_START, function(args, target) {
            this.bstStart = (0, $1Z3KE.now)();
        });
        this.eventsEE.on($ecb6e9bf14f82981$var$FN_END, function(args, target) {
            // ISSUE: when target is XMLHttpRequest, nr@context should have params so we can calculate event origin
            // When ajax is disabled, this may fail without making ajax a dependency of session_trace
            (0, $gy0pT.handle)('bst', [
                args[0],
                target,
                this.bstStart,
                (0, $1Z3KE.now)()
            ], undefined, (0, $3R40a.FEATURE_NAMES).sessionTrace, thisInstrumentEE);
        });
        thisInstrumentEE.on($ecb6e9bf14f82981$var$PUSH_STATE + $ecb6e9bf14f82981$var$START, function(args) {
            this.time = (0, $1Z3KE.now)();
            this.startPath = location.pathname + location.hash;
        });
        thisInstrumentEE.on($ecb6e9bf14f82981$var$PUSH_STATE + $ecb6e9bf14f82981$var$END, function(args) {
            (0, $gy0pT.handle)('bstHist', [
                location.pathname + location.hash,
                this.startPath,
                this.time
            ], undefined, (0, $3R40a.FEATURE_NAMES).sessionTrace, thisInstrumentEE);
        });
        let observer;
        try {
            // Capture initial resources and watch for future ones. Don't defer this given there's a default cap on the number of buffered entries.
            observer = new PerformanceObserver((list)=>{
                // eslint-disable-line no-undef
                const entries = list.getEntries();
                (0, $gy0pT.handle)($ecb6e9bf14f82981$var$BST_RESOURCE, [
                    entries
                ], undefined, (0, $3R40a.FEATURE_NAMES).sessionTrace, thisInstrumentEE);
            });
            observer.observe({
                type: $ecb6e9bf14f82981$var$RESOURCE,
                buffered: true
            });
        } catch (e) {
        // Per NEWRELIC-8525, we don't have a fallback for capturing resources for older versions that don't support PO at this time.
        }
        this.importAggregator(agentRef, ()=>(parcelRequire("grVnN")), {
            resourceObserver: observer
        });
    }
}
const $ecb6e9bf14f82981$export$b52f3cc8e7cc15ed = $ecb6e9bf14f82981$export$25ef33f358b07cf4;


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Primes the Session Replay feature for lazy loading.
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $44Lnf = parcelRequire("44Lnf");


var $24qgc = parcelRequire("24qgc");

var $6bsRh = parcelRequire("6bsRh");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $b0eb11a578779fb8$export$66c6de3171b6483c(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.RECORD_REPLAY), function() {
        (0, $gy0pT.handle)((0, $4uE6N.RECORD_REPLAY), [], undefined, (0, $3R40a.FEATURE_NAMES).sessionReplay, agent.ee);
    }, agent);
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $565fb199d4aa0ab4$export$ca945b2d46b476a(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.PAUSE_REPLAY), function() {
        (0, $gy0pT.handle)((0, $4uE6N.PAUSE_REPLAY), [], undefined, (0, $3R40a.FEATURE_NAMES).sessionReplay, agent.ee);
    }, agent);
}



var $4uE6N = parcelRequire("4uE6N");


class $35726f286b1a2372$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = (0, $6bsRh.FEATURE_NAME);
    /** @type {Promise|undefined} A promise that resolves when the recorder module is imported and added to the class. Undefined if the recorder has never been staged to import with `importRecorder`. */ #stagedImport;
    /** The RRWEB recorder instance, if imported */ recorder;
    constructor(agentRef){
        super(agentRef, (0, $6bsRh.FEATURE_NAME));
        /** feature specific APIs */ (0, $b0eb11a578779fb8$export$66c6de3171b6483c)(agentRef);
        (0, $565fb199d4aa0ab4$export$ca945b2d46b476a)(agentRef);
        let session;
        try {
            session = JSON.parse(localStorage.getItem("".concat((0, $44Lnf.PREFIX), "_").concat((0, $44Lnf.DEFAULT_KEY))));
        } catch (err) {}
        if ((0, $24qgc.hasReplayPrerequisite)(agentRef.init)) this.ee.on((0, $4uE6N.RECORD_REPLAY), ()=>this.#apiStartOrRestartReplay());
        if (this.#canPreloadRecorder(session)) this.importRecorder().then((recorder)=>{
            recorder.startRecording((0, $6bsRh.TRIGGERS).PRELOAD, session?.sessionReplayMode);
        }); // could handle specific fail-state behaviors with a .catch block here
        this.importAggregator(this.agentRef, ()=>(parcelRequire("dWGbK")), this);
        /** If the recorder is running, we can pass error events on to the agg to help it switch to full mode later */ this.ee.on('err', (e)=>{
            if (this.blocked) return;
            if (this.agentRef.runtime.isRecording) {
                this.errorNoticed = true;
                (0, $gy0pT.handle)((0, $6bsRh.ERROR_DURING_REPLAY), [
                    e
                ], undefined, this.featureName, this.ee);
            }
        });
    }
    // At this point wherein session state exists already but we haven't init SessionEntity aka verify timers.
    #canPreloadRecorder(session) {
        if (!session) // this might be a new session if entity initializes: conservatively start recording if first-time config allows
        // Note: users with SR enabled, as well as these other configs enabled by-default, will be penalized by the recorder overhead EVEN IF they don't actually have or get
        // entitlement or sampling decision, or otherwise intentionally opted-in for the feature.
        return (0, $24qgc.isPreloadAllowed)(this.agentRef.init);
        else if (session.sessionReplayMode === (0, $44Lnf.MODE).FULL || session.sessionReplayMode === (0, $44Lnf.MODE).ERROR) return true; // existing sessions get to continue recording, regardless of this page's configs or if it has expired (conservatively)
        else // SR mode was OFF but may potentially be turned on if session resets and configs allows the new session to have replay...
        return (0, $24qgc.isPreloadAllowed)(this.agentRef.init);
    }
    /**
   * Returns a promise that imports the recorder module. Only lets the recorder module be imported and instantiated once. Rejects if failed to import/instantiate.
   * @returns {Promise}
   */ importRecorder() {
        /** if we already have a recorder fully set up, just return it */ if (this.recorder) return Promise.resolve(this.recorder);
        /** conditional -- if we have never started importing, stage the import and store it in state */ this.#stagedImport ??= (parcelRequire("bSuiD")).then(({ Recorder: Recorder })=>{
            this.recorder = new Recorder(this);
            /** return the recorder for promise chaining */ return this.recorder;
        }).catch((err)=>{
            this.ee.emit('internal-error', [
                err
            ]);
            this.blocked = true;
            /** return the err for promise chaining */ throw err;
        });
        return this.#stagedImport;
    }
    /**
   * Called whenever startReplay API is used. That could occur any time, pre or post load.
   */ #apiStartOrRestartReplay() {
        if (this.blocked) return;
        if (this.featAggregate) // post-load; there's possibly already an ongoing recording
        {
            if (this.featAggregate.mode !== (0, $44Lnf.MODE).FULL) this.featAggregate.initializeRecording((0, $44Lnf.MODE).FULL, true, (0, $6bsRh.TRIGGERS).API);
        } else this.importRecorder().then(()=>{
            this.recorder.startRecording((0, $6bsRh.TRIGGERS).API, (0, $44Lnf.MODE).FULL);
        }); // could handle specific fail-state behaviors with a .catch block here
    }
}
const $35726f286b1a2372$export$d9dca5e363d7847f = $35726f286b1a2372$export$25ef33f358b07cf4;


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");

var $gy0pT = parcelRequire("gy0pT");

var $8FJov = parcelRequire("8FJov");

var $letnH = parcelRequire("letnH");







var $4UPGI = parcelRequire("4UPGI");

var $3R40a = parcelRequire("3R40a");




var $5qa2T = parcelRequire("5qa2T");

/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $9EKMI = parcelRequire("9EKMI");

var $6sT7C = parcelRequire("6sT7C");

var $1Z3KE = parcelRequire("1Z3KE");

var $jWywI = parcelRequire("jWywI");

var $juL0p = parcelRequire("juL0p");

var $kx4OV = parcelRequire("kx4OV");
const $9c06266611940d56$var$wrapped = {};
const $9c06266611940d56$var$openWebSockets = new Set(); // track all instances to close out metrics on page unload
function $9c06266611940d56$export$2b14d11840eff2ae(sharedEE) {
    const originals = (0, $juL0p.gosNREUMOriginals)().o;
    if (!originals.WS) return sharedEE;
    const wsEE = sharedEE.get('websockets');
    if ($9c06266611940d56$var$wrapped[wsEE.debugId]++) return wsEE;
    $9c06266611940d56$var$wrapped[wsEE.debugId] = 1; // otherwise, first feature to wrap events
    // This handles page navigation scenarios where the browser closes WebSockets after pagehide fires
    (0, $kx4OV.subscribeToPageUnload)(()=>{
        const unloadTime = (0, $1Z3KE.now)();
        $9c06266611940d56$var$openWebSockets.forEach((ws)=>{
            ws.nrData.closedAt = unloadTime;
            ws.nrData.closeCode = 1001; // Going Away - standard code for page navigation
            ws.nrData.closeReason = 'Page navigating away';
            ws.nrData.closeWasClean = false;
            if (ws.nrData.openedAt) ws.nrData.connectedDuration = unloadTime - ws.nrData.openedAt;
            wsEE.emit('ws', [
                ws.nrData
            ], ws);
        });
    });
    class WrappedWebSocket extends WebSocket {
        static name = 'WebSocket';
        static toString() {
            // fake native WebSocket when static class is stringified
            return 'function WebSocket() { [native code] }';
        }
        toString() {
            // fake [object WebSocket] when instance is stringified
            return '[object WebSocket]';
        }
        get [Symbol.toStringTag]() {
            // fake [object WebSocket] when Object.prototype.toString.call is used on instance
            return WrappedWebSocket.name;
        }
        // Private method to tag send, close, and event listener errors with WebSocket ID for JSErrors feature
        #tagError(error) {
            (error.__newrelic ??= {}).socketId = this.nrData.socketId;
            this.nrData.hasErrors ??= true;
        }
        constructor(...args){
            super(...args);
            /** @type {WebSocketData} */ this.nrData = new $9c06266611940d56$var$WebSocketData(args[0], args[1]);
            this.addEventListener('open', ()=>{
                this.nrData.openedAt = (0, $1Z3KE.now)();
                [
                    'protocol',
                    'extensions',
                    'binaryType'
                ].forEach((prop)=>{
                    this.nrData[prop] = this[prop];
                });
                $9c06266611940d56$var$openWebSockets.add(this);
            });
            this.addEventListener('message', (event)=>{
                const { type: type, size: size } = $9c06266611940d56$var$getDataInfo(event.data);
                this.nrData.messageOrigin ??= (0, $jWywI.cleanURL)(event.origin); // the origin of messages thru WS lifetime cannot be changed, so set once is sufficient
                this.nrData.messageCount++;
                this.nrData.messageBytes += size;
                this.nrData.messageBytesMin = Math.min(this.nrData.messageBytesMin || Infinity, size);
                this.nrData.messageBytesMax = Math.max(this.nrData.messageBytesMax, size);
                if (!(this.nrData.messageTypes ?? '').includes(type)) this.nrData.messageTypes = this.nrData.messageTypes ? "".concat(this.nrData.messageTypes, ",").concat(type) : type;
            });
            this.addEventListener('close', (event)=>{
                this.nrData.closedAt = (0, $1Z3KE.now)();
                this.nrData.closeCode = event.code;
                if (event.reason) this.nrData.closeReason = event.reason;
                this.nrData.closeWasClean = event.wasClean;
                this.nrData.connectedDuration = this.nrData.closedAt - this.nrData.openedAt;
                $9c06266611940d56$var$openWebSockets.delete(this); // remove from tracking set since it's now closed
                wsEE.emit('ws', [
                    this.nrData
                ], this);
            });
        }
        addEventListener(type, listener, ...rest) {
            const wsInstance = this;
            const wrappedListener = typeof listener === 'function' ? function(...args) {
                try {
                    return listener.apply(this, args);
                } catch (error) {
                    wsInstance.#tagError(error);
                    throw error;
                }
            } : listener?.handleEvent ? {
                // case for listener === object with handleEvent
                handleEvent: function(...args) {
                    try {
                        return listener.handleEvent.apply(listener, args);
                    } catch (error) {
                        wsInstance.#tagError(error);
                        throw error;
                    }
                }
            } : listener; // case for listener === null
            return super.addEventListener(type, wrappedListener, ...rest);
        }
        send(data) {
            // Only track metrics if the connection is OPEN; data sent in CONNECTING state throws, and data sent in CLOSING/CLOSED states is silently discarded
            if (this.readyState === WebSocket.OPEN) {
                const { type: type, size: size } = $9c06266611940d56$var$getDataInfo(data);
                this.nrData.sendCount++;
                this.nrData.sendBytes += size;
                this.nrData.sendBytesMin = Math.min(this.nrData.sendBytesMin || Infinity, size);
                this.nrData.sendBytesMax = Math.max(this.nrData.sendBytesMax, size);
                if (!(this.nrData.sendTypes ?? '').includes(type)) this.nrData.sendTypes = this.nrData.sendTypes ? "".concat(this.nrData.sendTypes, ",").concat(type) : type;
            }
            try {
                return super.send(data);
            } catch (error) {
                this.#tagError(error);
                throw error;
            }
        }
        close(...args) {
            try {
                super.close(...args);
            } catch (error) {
                this.#tagError(error);
                throw error;
            }
        }
    }
    (0, $9EKMI.globalScope).WebSocket = WrappedWebSocket;
    return wsEE;
}
/**
 * Returns the data type and size of the WebSocket send data
 * @param {*} data - The data being sent
 * @returns {{ type: string, size: number }} - The type name and size in bytes
 */ function $9c06266611940d56$var$getDataInfo(data) {
    if (typeof data === 'string') return {
        type: 'string',
        size: new TextEncoder().encode(data).length // efficient way to calculate the # of UTF-8 bytes that WS sends (cannot use string length)
    };
    if (data instanceof ArrayBuffer) return {
        type: 'ArrayBuffer',
        size: data.byteLength
    };
    if (data instanceof Blob) return {
        type: 'Blob',
        size: data.size
    };
    if (data instanceof DataView) return {
        type: 'DataView',
        size: data.byteLength
    };
    if (ArrayBuffer.isView(data)) return {
        type: 'TypedArray',
        size: data.byteLength
    };
    return {
        type: 'unknown',
        size: 0
    };
}
/**
 * WebSocket instrumentation data model
 */ class $9c06266611940d56$var$WebSocketData {
    /**
   * @param {string} requestedUrl - The URL passed to WebSocket constructor
   * @param {string|string[]} [requestedProtocols] - The protocols passed to WebSocket constructor
   */ constructor(requestedUrl, requestedProtocols){
        /** @type {number} Timestamp when the WebSocket was constructed (relative time); will be time corrected later when timeKeeper is available */ this.timestamp = (0, $1Z3KE.now)();
        /** @type {string} Most current URL when WebSocket was created; relevant for SPA */ this.currentUrl = (0, $jWywI.cleanURL)(window.location.href);
        /*
     * pageUrl will be set by addEvent later; unlike timestamp and currentUrl, it's not sensitive to *when* it is set.
     * It should not be explicitly defined here as it will overwrite the default provided by Generic Events later.
    */ /** @type {string} Unique identifier for this WebSocket connection */ this.socketId = (0, $6sT7C.generateRandomHexString)(8);
        /** @type {string} The URL requested for the WebSocket connection */ this.requestedUrl = (0, $jWywI.cleanURL)(requestedUrl);
        /** @type {string} Comma-separated list of requested protocols */ this.requestedProtocols = Array.isArray(requestedProtocols) ? requestedProtocols.join(',') : requestedProtocols || '';
        // Properties set when connection opens
        /** @type {number} [openedAt] Timestamp when connection opened */ this.openedAt = undefined;
        /** @type {string} [protocol] The sub-protocol selected by the server */ this.protocol = undefined;
        /** @type {string} [extensions] The extensions selected by the server */ this.extensions = undefined;
        /** @type {string} [binaryType] The binary type ('blob' or 'arraybuffer') */ this.binaryType = undefined;
        // Message received metrics
        /** @type {string} [messageOrigin] Origin of messages (set once) */ this.messageOrigin = undefined;
        /** @type {number} Total number of messages received */ this.messageCount = 0;
        /** @type {number} Total bytes received */ this.messageBytes = 0;
        /** @type {number} Minimum message size received */ this.messageBytesMin = 0;
        /** @type {number} Maximum message size received */ this.messageBytesMax = 0;
        /** @type {string} [messageTypes] Comma-separated list of message types received */ this.messageTypes = undefined;
        // Send metrics
        /** @type {number} Total number of messages sent */ this.sendCount = 0;
        /** @type {number} Total bytes sent */ this.sendBytes = 0;
        /** @type {number} Minimum message size sent */ this.sendBytesMin = 0;
        /** @type {number} Maximum message size sent */ this.sendBytesMax = 0;
        /** @type {string} [sendTypes] Comma-separated list of message types sent */ this.sendTypes = undefined;
        // Close metrics
        /** @type {number} [closedAt] Timestamp when connection closed */ this.closedAt = undefined;
        /** @type {number} [closeCode] WebSocket close code */ this.closeCode = undefined;
        /** @type {string} WebSocket close reason */ this.closeReason = 'unknown';
        /** @type {boolean} [closeWasClean] Whether the connection closed cleanly */ this.closeWasClean = undefined;
        /** @type {number} Duration of the connection in milliseconds */ this.connectedDuration = 0;
        // Error tracking
        /** @type {boolean} [hasErrors] Whether any errors occurred */ this.hasErrors = undefined;
    }
}



class $c0632d1fb573e6e3$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = (0, $4UPGI.FEATURE_NAME);
    constructor(agentRef){
        super(agentRef, (0, $4UPGI.FEATURE_NAME));
        const websocketsEnabled = agentRef.init.feature_flags.includes('websockets');
        const securityPolicyViolationEnabled = !agentRef.init.feature_flags.includes('no_spv');
        /** config values that gate whether the generic events aggregator should be imported at all */ const genericEventSourceConfigs = [
            agentRef.init.page_action.enabled,
            agentRef.init.performance.capture_marks,
            agentRef.init.performance.capture_measures,
            agentRef.init.performance.resources.enabled,
            agentRef.init.user_actions.enabled,
            websocketsEnabled,
            securityPolicyViolationEnabled
        ];
        /** feature specific APIs */ (0, $993f5d61e78f0e40$export$39f865c8bdc8e0b2)(agentRef);
        (0, $662eb61fcebf96c5$export$cb7bf6307fa273ba)(agentRef);
        (0, $c1baabe200c8f115$export$e2f3e76b55a5733e)(agentRef);
        (0, $6ff5d677d16b3f9d$export$86b839ffa8705791)(agentRef);
        (0, $c0107e1a5b272c27$export$4afeeb8632ab3067)(agentRef);
        this.removeOnAbort = new AbortController();
        this.abortHandler = ()=>{
            this.removeOnAbort.abort();
            this.abortHandler = undefined; // weakly allow this abort op to run only once
        };
        let historyEE;
        if (websocketsEnabled) {
            // this can apply outside browser scope such as in worker
            const websocketsEE = (0, $9c06266611940d56$export$2b14d11840eff2ae)(this.ee);
            websocketsEE.on('ws', (nrData)=>{
                (0, $gy0pT.handle)('ws-complete', [
                    nrData
                ], undefined, this.featureName, this.ee);
            });
        }
        if (securityPolicyViolationEnabled) (0, $9EKMI.globalScope).addEventListener('securitypolicyviolation', (evt)=>{
            (0, $gy0pT.handle)('spv', [
                evt
            ], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, this.ee);
        }, (0, $8FJov.eventListenerOpts)(false, this.removeOnAbort.signal));
        if (0, $9EKMI.isBrowserScope) {
            (0, $5862b924e27f1665$export$df01d05734964b1a)(this.ee, agentRef);
            (0, $a6c7b8521094eb4c$export$b3d77aa926f142b4)(this.ee, agentRef);
            historyEE = (0, $90bb56ea558bd526$export$7bd1d3939ac0b192)(this.ee);
            if (agentRef.init.user_actions.enabled) {
                (0, $4UPGI.OBSERVED_EVENTS).forEach((eventType)=>(0, $8FJov.windowAddEventListener)(eventType, (evt)=>(0, $gy0pT.handle)('ua', [
                            evt
                        ], undefined, this.featureName, this.ee), true));
                (0, $4UPGI.OBSERVED_WINDOW_EVENTS).forEach((eventType)=>{
                    const debounceHandler = (0, $letnH.debounce)((evt)=>{
                        (0, $gy0pT.handle)('ua', [
                            evt
                        ], undefined, this.featureName, this.ee);
                    }, 500, {
                        leading: true
                    });
                    (0, $8FJov.windowAddEventListener)(eventType, debounceHandler);
                });
                (0, $9EKMI.globalScope).addEventListener('error', ()=>{
                    (0, $gy0pT.handle)('uaErr', [], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, this.ee);
                }, (0, $8FJov.eventListenerOpts)(false, this.removeOnAbort.signal));
                this.ee.on('open-xhr-start', (args, xhr)=>{
                    if (!isInternalTraffic(args[1])) xhr.addEventListener('readystatechange', ()=>{
                        if (xhr.readyState === 2) // HEADERS_RECEIVED
                        (0, $gy0pT.handle)('uaXhr', [], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, this.ee);
                    }, (0, $8FJov.eventListenerOpts)(undefined, this.removeOnAbort.signal));
                });
                this.ee.on('fetch-start', (fetchArguments)=>{
                    if (fetchArguments.length >= 1 && !isInternalTraffic((0, $694d25d082b25378$export$c53fc68ceaaa90d2)(fetchArguments[0]))) (0, $gy0pT.handle)('uaXhr', [], undefined, (0, $3R40a.FEATURE_NAMES).genericEvents, this.ee);
                });
                function isInternalTraffic(url) {
                    const parsedUrl = (0, $5qa2T.parseUrl)(url);
                    return agentRef.beacons.includes(parsedUrl.hostname + ':' + parsedUrl.port);
                }
                historyEE.on('pushState-end', navigationChange);
                historyEE.on('replaceState-end', navigationChange);
                window.addEventListener('hashchange', navigationChange, (0, $8FJov.eventListenerOpts)(true, this.removeOnAbort.signal));
                window.addEventListener('popstate', navigationChange, (0, $8FJov.eventListenerOpts)(true, this.removeOnAbort.signal));
                function navigationChange() {
                    historyEE.emit('navChange');
                }
            }
            if (agentRef.init.performance.resources.enabled && (0, $9EKMI.globalScope).PerformanceObserver?.supportedEntryTypes.includes('resource')) {
                const observer = new PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        (0, $gy0pT.handle)('browserPerformance.resource', [
                            entry
                        ], undefined, this.featureName, this.ee);
                    });
                });
                observer.observe({
                    type: 'resource',
                    buffered: true
                });
            }
        }
        /** If any of the sources are active, import the aggregator. otherwise deregister */ if (genericEventSourceConfigs.some((x)=>x)) this.importAggregator(agentRef, ()=>(parcelRequire("4vZgp")));
        else this.deregisterDrain();
    }
}
const $c0632d1fb573e6e3$export$be83be99246b37f5 = $c0632d1fb573e6e3$export$25ef33f358b07cf4;


/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $9RUUB = parcelRequire("9RUUB");

var $8FTye = parcelRequire("8FTye");
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @file Wraps native timeout and interval methods for instrumentation.
 * This module is used by: logging.
 */ 
var $im7dd = parcelRequire("im7dd");

var $3MOOm = parcelRequire("3MOOm");

var $jkuUu = parcelRequire("jkuUu");

var $gRz07 = parcelRequire("gRz07");
const $820223508ba080bf$var$contextMap = new Map();
function $820223508ba080bf$export$c0b220cb4a61be37(sharedEE, parent, loggerFn, context, autoCaptured = true, agentRef) {
    if (!(typeof parent === 'object' && !!parent && typeof loggerFn === 'string' && !!loggerFn && typeof parent[loggerFn] === 'function')) return (0, $jkuUu.warn)(29);
    const ee = $820223508ba080bf$export$b88e0ef4192fcaff(sharedEE);
    const wrapFn = (0, $gRz07.createWrapperWithEmitter)(ee, undefined, agentRef);
    /**
   * This section contains the context that will be shared across all invoked calls of the wrapped function,
   * which will be used to decorate the log data later at agg time
  */ const ctx = new (0, $3MOOm.EventContext)((0, $im7dd.contextId));
    ctx.level = context.level;
    ctx.customAttributes = context.customAttributes;
    ctx.autoCaptured = autoCaptured;
    const contextLookupKey = parent[loggerFn]?.[0, $gRz07.flag] || parent[loggerFn];
    $820223508ba080bf$var$contextMap.set(contextLookupKey, ctx);
    /** observe calls to <loggerFn> and emit events prefixed with `wrap-logger-`
   * inform the inplace wrapper to evaluate the stack for targets of the log execution,
   * so that logs can be attributed to a matching MFE source if being used. */ wrapFn.inPlace(parent, [
        loggerFn
    ], 'wrap-logger-', ()=>$820223508ba080bf$var$contextMap.get(contextLookupKey), undefined, true);
    return ee;
}
function $820223508ba080bf$export$b88e0ef4192fcaff(sharedEE) {
    return (sharedEE || (0, $im7dd.ee)).get('logger');
}



var $9EKMI = parcelRequire("9EKMI");

/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $9RUUB = parcelRequire("9RUUB");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $f00716205e760bb5$export$4f4bc3a88a8420ba(agent) {
    (0, $dVxdm.setupAPI)((0, $4uE6N.WRAP_LOGGER), (parent, functionName, { customAttributes: customAttributes = {}, level: level = (0, $9RUUB.LOG_LEVELS).INFO } = {})=>{
        (0, $820223508ba080bf$export$c0b220cb4a61be37)(agent.ee, parent, functionName, {
            customAttributes: customAttributes,
            level: level
        }, false, agent);
    }, agent);
}




var $7QTAt = parcelRequire("7QTAt");

class $5f588d296575b17b$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = (0, $9RUUB.FEATURE_NAME);
    constructor(agentRef){
        super(agentRef, (0, $9RUUB.FEATURE_NAME));
        /** feature specific APIs */ (0, $cdaa056a33e152e9$export$82bbccfb817a681)(agentRef);
        (0, $f00716205e760bb5$export$4f4bc3a88a8420ba)(agentRef);
        (0, $6ff5d677d16b3f9d$export$86b839ffa8705791)(agentRef);
        const instanceEE = this.ee;
        const globals = [
            'log',
            'error',
            'warn',
            'info',
            'debug',
            'trace'
        ];
        globals.forEach((method)=>{
            (0, $7QTAt.isNative)((0, $9EKMI.globalScope).console[method]);
            (0, $820223508ba080bf$export$c0b220cb4a61be37)(instanceEE, (0, $9EKMI.globalScope).console, method, {
                level: method === 'log' ? 'info' : method
            }, undefined, agentRef);
        });
        /** emitted by wrap-logger function */ this.ee.on('wrap-logger-end', function handleLog([message], _, __, targets = []) {
            const { level: level, customAttributes: customAttributes, autoCaptured: autoCaptured } = this;
            targets.forEach((target)=>{
                (0, $8FTye.bufferLog)(instanceEE, message, customAttributes, level, autoCaptured, target);
            });
        });
        this.importAggregator(agentRef, ()=>(parcelRequire("52LFv")));
    }
}
const $5f588d296575b17b$export$f13b02179817fff = $5f588d296575b17b$export$25ef33f358b07cf4;


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $juL0p = parcelRequire("juL0p");

var $9EKMI = parcelRequire("9EKMI");

var $gy0pT = parcelRequire("gy0pT");

var $8FJov = parcelRequire("8FJov");

var $letnH = parcelRequire("letnH");



var $1ZAXp = parcelRequire("1ZAXp");

var $1Z3KE = parcelRequire("1Z3KE");
/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $gy0pT = parcelRequire("gy0pT");

var $1Z3KE = parcelRequire("1Z3KE");

var $bu0p3 = parcelRequire("bu0p3");

var $3R40a = parcelRequire("3R40a");

var $4uE6N = parcelRequire("4uE6N");

var $dVxdm = parcelRequire("dVxdm");
function $932c35362b94adf0$export$d454a25575ab7cfa(agent) {
    const tracerEE = agent.ee.get('tracer');
    (0, $dVxdm.setupAPI)((0, $4uE6N.INTERACTION), function(options) {
        return new InteractionHandle().get(typeof options === 'object' ? options : {});
    }, agent);
    function InteractionHandle() {}
    const InteractionApiProto = InteractionHandle.prototype = {
        createTracer: function(name, cb) {
            // Primarily used by old SPA feature to create custom child tracers under an interaction.
            // Soft navigations won't support Tracer nodes, but this fn should still work the same otherwise (e.g., run the orig cb).
            var contextStore = {};
            var ixn = this;
            var hasCb = typeof cb === 'function';
            (0, $gy0pT.handle)((0, $bu0p3.SUPPORTABILITY_METRIC_CHANNEL), [
                'API/createTracer/called'
            ], undefined, (0, $3R40a.FEATURE_NAMES).metrics, agent.ee);
            return function() {
                tracerEE.emit((hasCb ? '' : 'no-') + 'fn-start', [
                    (0, $1Z3KE.now)(),
                    ixn,
                    hasCb
                ], contextStore);
                if (hasCb) try {
                    return cb.apply(this, arguments);
                } catch (err) {
                    const error = typeof err === 'string' ? new Error(err) : err;
                    tracerEE.emit('fn-err', [
                        arguments,
                        this,
                        error
                    ], contextStore);
                    // the error came from outside the agent, so don't swallow
                    throw error;
                } finally{
                    tracerEE.emit('fn-end', [
                        (0, $1Z3KE.now)()
                    ], contextStore);
                }
            };
        }
    };
    [
        'actionText',
        'setName',
        'setAttribute',
        'save',
        'ignore',
        'onEnd',
        'getContext',
        'end',
        'get'
    ].forEach((name)=>{
        (0, $dVxdm.setupAPI).apply(this, [
            name,
            function() {
                (0, $gy0pT.handle)((0, $4uE6N.spaPrefix) + name, [
                    performance.now(),
                    ...arguments
                ], this, (0, $3R40a.FEATURE_NAMES).softNav, agent.ee);
                return this;
            },
            agent,
            InteractionApiProto
        ]);
    });
    (0, $dVxdm.setupAPI)((0, $4uE6N.SET_CURRENT_ROUTE_NAME), function() {
        (0, $gy0pT.handle)((0, $4uE6N.spaPrefix) + 'routeName', [
            performance.now(),
            ...arguments
        ], undefined, (0, $3R40a.FEATURE_NAMES).softNav, agent.ee);
    }, agent);
}


/**
 * The minimal time after a UI event for which no further events will be processed - i.e. a throttling rate to reduce spam.
 * This also give some time for the new interaction to complete without being discarded by a subsequent UI event and wrongly attributed.
 * This value is still subject to change and critique, as it is derived from beyond worst case time to next frame of a page.
 */ const $921c782111571ccd$var$UI_WAIT_INTERVAL = 100; // assume 10 fps

class $921c782111571ccd$export$25ef33f358b07cf4 extends (0, $2591173c660a4e27$export$53233a09ca4736e9) {
    static featureName = (0, $1ZAXp.FEATURE_NAME);
    constructor(agentRef){
        super(agentRef, (0, $1ZAXp.FEATURE_NAME));
        /** feature specific APIs */ (0, $932c35362b94adf0$export$d454a25575ab7cfa)(agentRef);
        if (!(0, $9EKMI.isBrowserScope) || !(0, $juL0p.gosNREUMOriginals)().o.MO) return; // soft navigations is not supported outside web env or browsers without the mutation observer API
        const historyEE = (0, $90bb56ea558bd526$export$7bd1d3939ac0b192)(this.ee);
        try {
            this.removeOnAbort = new AbortController();
        } catch (e) {}
        (0, $1ZAXp.INTERACTION_TRIGGERS).forEach((trigger)=>{
            (0, $8FJov.windowAddEventListener)(trigger, (evt)=>{
                processUserInteraction(evt);
            }, true, this.removeOnAbort?.signal);
        });
        const trackURLChange = ()=>(0, $gy0pT.handle)('newURL', [
                (0, $1Z3KE.now)(),
                '' + window.location
            ], undefined, this.featureName, this.ee);
        historyEE.on('pushState-end', trackURLChange);
        historyEE.on('replaceState-end', trackURLChange);
        (0, $8FJov.windowAddEventListener)((0, $1ZAXp.POPSTATE_TRIGGER), (evt)=>{
            // popstate is unique in that it serves as BOTH a UI event and a notification of URL change
            processUserInteraction(evt);
            (0, $gy0pT.handle)('newURL', [
                evt.timeStamp,
                '' + window.location
            ], undefined, this.featureName, this.ee);
        }, true, this.removeOnAbort?.signal);
        let oncePerFrame = false; // attempt to reduce dom noice since the observer runs very frequently with below options
        const domObserver = new ((0, $juL0p.gosNREUMOriginals)()).o.MO((domChanges, observer)=>{
            if (oncePerFrame) return;
            oncePerFrame = true;
            requestAnimationFrame(()=>{
                // waiting for next frame to time when any visuals are supposedly updated
                (0, $gy0pT.handle)('newDom', [
                    (0, $1Z3KE.now)()
                ], undefined, this.featureName, this.ee);
                oncePerFrame = false;
            });
        });
        const processUserInteraction = (0, $letnH.debounce)((event)=>{
            if (document.readyState === 'loading') return; // document.body is not expected to be defined yet during loading, so only "interactive" or "complete" is considered "legit" user interaction
            (0, $gy0pT.handle)('newUIEvent', [
                event
            ], undefined, this.featureName, this.ee);
            domObserver.observe(document.body, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });
        }, $921c782111571ccd$var$UI_WAIT_INTERVAL, {
            leading: true
        });
        this.abortHandler = abort;
        this.importAggregator(agentRef, ()=>(parcelRequire("5k7MW")), {
            domObserver: domObserver
        });
        function abort() {
            this.removeOnAbort?.abort();
            domObserver.disconnect();
            this.abortHandler = undefined; // weakly allow this abort op to run only once
        }
    }
}
const $921c782111571ccd$export$b0ef7a017d8859d8 = $921c782111571ccd$export$25ef33f358b07cf4;


class $15f96e47c3fe7d31$export$4b720938abd886b1 extends (0, $8ac64a97b1a43781$export$f05c48a4001d5356) {
    /**
   * @param {import('./agent').AgentOptions} options
   */ constructor(options){
        super({
            ...options,
            features: [
                (0, $b9fc03f3a542c7e9$export$25ef33f358b07cf4),
                (0, $013d6426dbd26139$export$25ef33f358b07cf4),
                (0, $6f9f9b7b88a73616$export$25ef33f358b07cf4),
                (0, $ecb6e9bf14f82981$export$25ef33f358b07cf4),
                (0, $ff2e4c1166cc1ee7$export$25ef33f358b07cf4),
                (0, $749ce9262c8db632$export$25ef33f358b07cf4),
                (0, $921c782111571ccd$export$25ef33f358b07cf4),
                (0, $35726f286b1a2372$export$25ef33f358b07cf4),
                (0, $c0632d1fb573e6e3$export$25ef33f358b07cf4),
                (0, $5f588d296575b17b$export$25ef33f358b07cf4)
            ],
            loaderType: 'browser-agent'
        });
    }
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // loader files



var $8ncaL = parcelRequire("8ncaL");

var $juL0p = parcelRequire("juL0p");

var $3R40a = parcelRequire("3R40a");

var $jkuUu = parcelRequire("jkuUu");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $6sT7C = parcelRequire("6sT7C");

var $8e4CA = parcelRequire("8e4CA");
class $15cb7dc62f1ce411$export$50725a1cff234335 extends (0, $8e4CA.ApiBase) {
    agentIdentifier = (0, $6sT7C.generateRandomHexString)(16);
}














const $a40d01e2a6a6a221$var$nonAutoFeatures = [
    (0, $3R40a.FEATURE_NAMES).jserrors,
    (0, $3R40a.FEATURE_NAMES).genericEvents,
    (0, $3R40a.FEATURE_NAMES).metrics,
    (0, $3R40a.FEATURE_NAMES).logging
];




class $a40d01e2a6a6a221$export$6eeb09575bb88e79 extends (0, $15cb7dc62f1ce411$export$50725a1cff234335) {
    /**
   * @param {import('./agent').AgentOptions} options
   */ constructor(options){
        super();
        this.features = {};
        (0, $juL0p.setNREUMInitializedAgent)(this.agentIdentifier, this);
        (0, $8ncaL.configure)(this, {
            ...options,
            runtime: {
                isolatedBacklog: true
            }
        }, options.loaderType || 'micro-agent');
        /** assign base agent-level API definitions */ (0, $37680abd18226c91$export$d28515d4b4a9c0c1)(this);
        (0, $b238e90b7308a067$export$162095e463e94662)(this);
        (0, $a59c6a23b386b87b$export$4853ee1fa0df26ad)(this);
        (0, $ce9d0269780d2d22$export$8e4bf423390e136)(this);
        /** feature APIs that wont get set up automatically for the micro agent since it skips the inst file */ /** jserrors */ (0, $7968f46faaa1de84$export$786e0e69b511ee7d)(this);
        (0, $8f5cd1f33eb667b9$export$eae9b745ac58380b)(this);
        (0, $827b7c69f93c4e0a$export$9e20a01b8f684b14)(this);
        /** generic events */ (0, $993f5d61e78f0e40$export$39f865c8bdc8e0b2)(this);
        (0, $662eb61fcebf96c5$export$cb7bf6307fa273ba)(this);
        (0, $c1baabe200c8f115$export$e2f3e76b55a5733e)(this);
        /** logging */ (0, $cdaa056a33e152e9$export$82bbccfb817a681)(this);
        (0, $f00716205e760bb5$export$4f4bc3a88a8420ba)(this);
        /**
     * Starts a set of agent features if not running in "autoStart" mode
     * {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/start/}
     * @param {string|string[]} [featureNames] The feature name(s) to start.  If no name(s) are passed, all features will be started
     */ this.start = (featureNames)=>{
            try {
                if (featureNames === undefined || Array.isArray(featureNames) && featureNames.length === 0) featureNames = $a40d01e2a6a6a221$var$nonAutoFeatures;
                else if (typeof featureNames === 'string') featureNames = [
                    featureNames
                ];
                if (featureNames.some((f)=>!$a40d01e2a6a6a221$var$nonAutoFeatures.includes(f))) (0, $jkuUu.warn)(37, $a40d01e2a6a6a221$var$nonAutoFeatures);
                const enabledFeatures = (0, $fa0853a1d774eb4d$export$b223b1e857b805e7)(this.init);
                try {
                    // a biproduct of doing this is that the "session manager" is automatically handled through importing this feature
                    this.features.page_view_event = new (0, $013d6426dbd26139$export$25ef33f358b07cf4)(this);
                } catch (err) {
                    (0, $jkuUu.warn)(24, err);
                }
                this.features.page_view_event.onAggregateImported.then(()=>{
                    /* The following features do not import an "instrument" file, meaning they are only hooked up to the API.
          Since the missing instrument-base class handles drain-gating (racing behavior) and PVE handles some setup, these are chained until after PVE has finished initializing
          so as to avoid the race condition of things like session and sharedAggregator not being ready by features that uses them right away. */ $a40d01e2a6a6a221$var$nonAutoFeatures.forEach((f)=>{
                        if (enabledFeatures[f] && featureNames.includes(f)) {
                            let lazyImport;
                            /** Define these imports with static strings to not break tools like roll-up */ switch(f){
                                case 'jserrors':
                                    lazyImport = (parcelRequire("5C29L"));
                                    break;
                                case 'generic_events':
                                    lazyImport = (parcelRequire("4vZgp"));
                                    break;
                                case 'metrics':
                                    lazyImport = (parcelRequire("38uIx"));
                                    break;
                                case 'logging':
                                    lazyImport = (parcelRequire("52LFv"));
                                    break;
                            }
                            lazyImport.then(({ Aggregate: Aggregate })=>{
                                this.features[f] = new Aggregate(this);
                                this.runtime.harvester.initializedAggregates.push(this.features[f]); // so that harvester will poll this feature agg on interval
                            }).catch((err)=>(0, $jkuUu.warn)(25, err));
                        }
                    });
                });
                return true;
            } catch (err) {
                (0, $jkuUu.warn)(26, err);
                return false;
            }
        };
        this.start($a40d01e2a6a6a221$var$nonAutoFeatures.filter((featureName)=>!!this.init[featureName].autoStart));
    }
    get config() {
        return {
            info: this.info,
            init: this.init,
            loader_config: this.loader_config,
            runtime: this.runtime
        };
    }
    get api() {
        return this;
    }
}


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $2af5f712eb93dcd4$export$25ef33f358b07cf4 extends (0, $c0632d1fb573e6e3$export$25ef33f358b07cf4) {
}
const $2af5f712eb93dcd4$export$26a154e236fae0e5 = $2af5f712eb93dcd4$export$25ef33f358b07cf4;




/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 




var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
'use strict';
var $47cfd4084854a574$exports = {};
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;




var $bh6RR = parcelRequire("bh6RR");
const $38311d640b87f30b$export$38ee920e59704589 = /*#__PURE__*/ (0, $bh6RR.createContext)();
const $38311d640b87f30b$var$FILTERS = {
    FAVORITES: "FAVORITES",
    ZONE: "ZONE",
    LOCATION: "LOCATION",
    TIME: "TIME",
    CATEGORY: "CATEGORY",
    PAST: "PAST"
};
const $38311d640b87f30b$var$DAYS = {
    THU: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday"
};
const $38311d640b87f30b$var$dayValue = {
    "Thursday": 1000000,
    "Friday": 2000000,
    "Saturday": 3000000,
    "Sunday": 4000000,
    "Thu": 1000000,
    "Fri": 2000000,
    "Sat": 3000000,
    "Sun": 4000000
};
function $38311d640b87f30b$export$e5cc2dfc1df151ff({ children: children }) {
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const [filter, setFilter] = (0, $bh6RR.useState)("");
    const [menu, setMenu] = (0, $bh6RR.useState)(false);
    const [favorites, setFavorites] = (0, $bh6RR.useState)(()=>{
        // Check local storage if favorites exist, otherwise initialize an empty array
        const cachedFavorites = localStorage.getItem("favorites");
        return cachedFavorites ? JSON.parse(cachedFavorites) : [];
    });
    const [activeTab, setActiveTab] = (0, $bh6RR.useState)("THU");
    const [query, setQuery] = (0, $bh6RR.useState)("");
    const [showPast, setShowPast] = (0, $bh6RR.useState)(false);
    const [showAllDay, setShowAllDay] = (0, $bh6RR.useState)(true);
    const [install, setInstall] = (0, $bh6RR.useState)(false);
    const [showMap, setShowMap] = (0, $bh6RR.useState)(false);
    const [data, setData] = (0, $bh6RR.useState)(null); // Initialize as null
    const [error, setError] = (0, $bh6RR.useState)(null); // Add error state
    const fetchData = async ()=>{
        setLoading(true);
        try {
            const response = await fetch("./schedule.json");
            if (!response.ok) throw new Error(`Failed to fetch data: ${response.statusText}`);
            const result = await response.json();
            setData(result); // Update data state with fetched data
        } catch (err) {
            setError(err.message); // Handle fetch error
        } finally{
            setLoading(false);
        }
    };
    // Fetch data on component mount
    (0, $bh6RR.useEffect)(()=>{
        fetchData();
    }, []);
    // Fetch when page becomes visible
    (0, $bh6RR.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === "visible") fetchData();
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    // Set default day
    (0, $bh6RR.useEffect)(()=>{
        if (Date().split(" ")[0].toUpperCase() == "FRI") {
            setActiveTab("FRI");
            return;
        }
        if (Date().split(" ")[0].toUpperCase() == "SAT") {
            setActiveTab("SAT");
            return;
        }
        if (Date().split(" ")[0].toUpperCase() == "SUN") {
            setActiveTab("SUN");
            return;
        }
        setActiveTab("THU");
    }, []);
    // Handles toggling the filter view between favorited events and all events
    const handleFilterFavorites = (e)=>{
        // Prevents toggling the menu accordion when clicking on favorites
        e.stopPropagation();
        // If the favorites filter is already active, unset it (toggle)
        const newFilter = filter === $38311d640b87f30b$var$FILTERS.FAVORITES ? "" : $38311d640b87f30b$var$FILTERS.FAVORITES;
        setFilter(newFilter);
    };
    // Handles toggling an individual event into or out of the favorites list
    const handleToggleFavorited = (uid)=>{
        setFavorites((prev)=>{
            const prevIndex = prev.findIndex((favorite)=>favorite.uid === uid);
            // Check if the event is already favorited
            // If it is, unfavorite it
            // If it isn't, use its id to look up the corresponding event data and add it to the favorites list
            const newFavorites = prevIndex !== -1 ? prev.filter((favorite)=>favorite.uid !== uid) : [
                ...prev,
                events.find((event)=>event.uid === uid)
            ];
            // Set favorite into local storage
            localStorage.setItem("favorites", JSON.stringify(newFavorites));
            return newFavorites;
        });
    };
    // Returns a string to be used as a classname for conditional styling
    const handleFavoriteDisplay = (id)=>{
        const isFavorited = favorites.some((favorite)=>favorite.uid === id);
        return isFavorited;
    };
    const handleTabClick = (day)=>{
        setActiveTab(day);
    };
    const handleSearch = (query)=>{
        setQuery(query);
    };
    const handleFilterClick = (button)=>{
        if (query === button) setQuery("");
        if (query === "") setQuery(button);
    };
    const events = (0, $bh6RR.useMemo)(()=>{
        if (!data) return []; // Return empty array if data is not yet loaded
        return data.filter((event)=>{
            // Favorites Feature
            const filterByFavorites = filter === $38311d640b87f30b$var$FILTERS.FAVORITES ? favorites.some((favorite)=>favorite.uid === event.uid) : true;
            // Day of the Week Footer Feature
            const filterByActiveTab = event.occurrence.long.split(" ")[0] === $38311d640b87f30b$var$DAYS[activeTab];
            // Search Feature
            const filterBySearchQuery = query ? [
                event.title,
                event.description,
                event.location,
                event.neighborhood
            ].some((attr)=>attr?.toLowerCase().includes(query.toLowerCase())) : true;
            // Filter Out Past Feature
            const date = new Date();
            const showPastEvents = !showPast ? Date.parse(event.occurrence.end_time) > Date.parse(date) : true;
            // Filter Out All Day Feature
            const showAllDayEvents = !showAllDay ? !event.occurrence.short.includes("24hrs") : true;
            // Filter those out
            return filterByFavorites && filterByActiveTab && showPastEvents && showAllDayEvents && filterBySearchQuery;
        });
    }, [
        data,
        favorites,
        activeTab,
        filter,
        query,
        showPast,
        showAllDay
    ]);
    (0, $bh6RR.useEffect)(()=>{
        localStorage.setItem("favorites", JSON.stringify(favorites));
    }, [
        favorites
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($38311d640b87f30b$export$38ee920e59704589.Provider, {
        value: {
            loading: loading,
            setLoading: setLoading,
            filter: filter,
            setFilter: setFilter,
            menu: menu,
            setMenu: setMenu,
            events: events,
            handleFilterFavorites: handleFilterFavorites,
            handleToggleFavorited: handleToggleFavorited,
            handleFavoriteDisplay: handleFavoriteDisplay,
            handleFilterClick: handleFilterClick,
            FILTERS: $38311d640b87f30b$var$FILTERS,
            activeTab: activeTab,
            handleTabClick: handleTabClick,
            setInstall: setInstall,
            install: install,
            query: query,
            setQuery: setQuery,
            handleSearch: handleSearch,
            showPast: showPast,
            setShowPast: setShowPast,
            showAllDay: showAllDay,
            setShowAllDay: setShowAllDay,
            showMap: showMap,
            setShowMap: setShowMap,
            error: error
        },
        children: children
    });
}
const $38311d640b87f30b$export$1c72fe480f599e97 = ()=>{
    const { loading: loading, setLoading: setLoading } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        loading: loading,
        setLoading: setLoading
    };
};
const $38311d640b87f30b$export$86f8f9f08863e403 = ()=>{
    const { showMap: showMap, setShowMap: setShowMap } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        showMap: showMap,
        setShowMap: setShowMap
    };
};
const $38311d640b87f30b$export$3274cf84b703fff = ()=>{
    const { filter: filter, setFilter: setFilter, FILTERS: FILTERS, handleFavoriteDisplay: handleFavoriteDisplay, handleFilterFavorites: handleFilterFavorites, handleToggleFavorited: handleToggleFavorited, handleFilterClick: handleFilterClick } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        filter: filter,
        setFilter: setFilter,
        FILTERS: FILTERS,
        handleFavoriteDisplay: handleFavoriteDisplay,
        handleFilterFavorites: handleFilterFavorites,
        handleToggleFavorited: handleToggleFavorited,
        handleFilterClick: handleFilterClick
    };
};
const $38311d640b87f30b$export$38eaa17faae8f579 = ()=>{
    const { menu: menu, setMenu: setMenu } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        menu: menu,
        setMenu: setMenu
    };
};
const $38311d640b87f30b$export$32391a757e6b1b69 = ()=>{
    const { showPast: showPast, setShowPast: setShowPast } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        showPast: showPast,
        setShowPast: setShowPast
    };
};
const $38311d640b87f30b$export$ffb9577af324dc6a = ()=>{
    const { showAllDay: showAllDay, setShowAllDay: setShowAllDay } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        showAllDay: showAllDay,
        setShowAllDay: setShowAllDay
    };
};
const $38311d640b87f30b$export$91a992459f6e0f07 = ()=>{
    const { events: events } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return events.sort((a, b)=>{
        const days = [
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
        ];
        return days.indexOf(a.day) - days.indexOf(b.day) || $38311d640b87f30b$export$c9698ec7f05a07e1(a.occurrence.start_time) - $38311d640b87f30b$export$c9698ec7f05a07e1(b.occurrence.start_time);
    });
};
const $38311d640b87f30b$export$d2589202ac9c89c3 = ()=>{
    const { activeTab: activeTab, handleTabClick: handleTabClick } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        activeTab: activeTab,
        handleTabClick: handleTabClick
    };
};
const $38311d640b87f30b$export$56bafadbb0c4d7e5 = ()=>{
    const { install: install, setInstall: setInstall } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        install: install,
        setInstall: setInstall
    };
};
const $38311d640b87f30b$export$e51e224239492327 = ()=>{
    const { date: date } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        date: date
    };
};
const $38311d640b87f30b$export$bd221a7c56b93941 = ()=>{
    const { query: query, setQuery: setQuery, handleSearch: handleSearch } = (0, $bh6RR.useContext)($38311d640b87f30b$export$38ee920e59704589);
    return {
        query: query,
        setQuery: setQuery,
        handleSearch: handleSearch
    };
};
const $38311d640b87f30b$export$c9698ec7f05a07e1 = (str)=>{
    if (str.includes("T")) {
        let time = str.split("T")[1].split(":").join("");
        return time;
    }
    let time = str.split(":").join("");
    return time;
};



parcelRequire("bh6RR");

parcelRequire("bh6RR");

parcelRequire("bh6RR");
var $e38850c377240f3d$exports = {};
'use strict';
Object.defineProperty($e38850c377240f3d$exports, '__esModule', {
    value: true
});
function $e38850c377240f3d$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $bh6RR = parcelRequire("bh6RR");
var $e38850c377240f3d$var$React__default = $e38850c377240f3d$var$_interopDefault($bh6RR);

var $dj0NU = parcelRequire("dj0NU");
var $e38850c377240f3d$var$ClientUAInstance = new $dj0NU();
var $e38850c377240f3d$var$browser = $e38850c377240f3d$var$ClientUAInstance.getBrowser();
var $e38850c377240f3d$var$cpu = $e38850c377240f3d$var$ClientUAInstance.getCPU();
var $e38850c377240f3d$var$device = $e38850c377240f3d$var$ClientUAInstance.getDevice();
var $e38850c377240f3d$var$engine = $e38850c377240f3d$var$ClientUAInstance.getEngine();
var $e38850c377240f3d$var$os = $e38850c377240f3d$var$ClientUAInstance.getOS();
var $e38850c377240f3d$var$ua = $e38850c377240f3d$var$ClientUAInstance.getUA();
var $e38850c377240f3d$var$setUa = function setUa(userAgentString) {
    return $e38850c377240f3d$var$ClientUAInstance.setUA(userAgentString);
};
var $e38850c377240f3d$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $dj0NU(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $e38850c377240f3d$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $e38850c377240f3d$var$ClientUAInstance,
    browser: $e38850c377240f3d$var$browser,
    cpu: $e38850c377240f3d$var$cpu,
    device: $e38850c377240f3d$var$device,
    engine: $e38850c377240f3d$var$engine,
    os: $e38850c377240f3d$var$os,
    ua: $e38850c377240f3d$var$ua,
    setUa: $e38850c377240f3d$var$setUa,
    parseUserAgent: $e38850c377240f3d$var$parseUserAgent
});
function $e38850c377240f3d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e38850c377240f3d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e38850c377240f3d$var$ownKeys(Object(source), true).forEach(function(key) {
            $e38850c377240f3d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e38850c377240f3d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e38850c377240f3d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e38850c377240f3d$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $e38850c377240f3d$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e38850c377240f3d$var$_typeof(obj);
}
function $e38850c377240f3d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e38850c377240f3d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e38850c377240f3d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e38850c377240f3d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e38850c377240f3d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e38850c377240f3d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e38850c377240f3d$var$_extends() {
    $e38850c377240f3d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e38850c377240f3d$var$_extends.apply(this, arguments);
}
function $e38850c377240f3d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e38850c377240f3d$var$_setPrototypeOf(subClass, superClass);
}
function $e38850c377240f3d$var$_getPrototypeOf(o) {
    $e38850c377240f3d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e38850c377240f3d$var$_getPrototypeOf(o);
}
function $e38850c377240f3d$var$_setPrototypeOf(o, p) {
    $e38850c377240f3d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e38850c377240f3d$var$_setPrototypeOf(o, p);
}
function $e38850c377240f3d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e38850c377240f3d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e38850c377240f3d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e38850c377240f3d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e38850c377240f3d$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e38850c377240f3d$var$_assertThisInitialized(self);
}
function $e38850c377240f3d$var$_slicedToArray(arr, i) {
    return $e38850c377240f3d$var$_arrayWithHoles(arr) || $e38850c377240f3d$var$_iterableToArrayLimit(arr, i) || $e38850c377240f3d$var$_unsupportedIterableToArray(arr, i) || $e38850c377240f3d$var$_nonIterableRest();
}
function $e38850c377240f3d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e38850c377240f3d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e38850c377240f3d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e38850c377240f3d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e38850c377240f3d$var$_arrayLikeToArray(o, minLen);
}
function $e38850c377240f3d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e38850c377240f3d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $e38850c377240f3d$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $e38850c377240f3d$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $e38850c377240f3d$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $e38850c377240f3d$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $e38850c377240f3d$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $e38850c377240f3d$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $e38850c377240f3d$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $e38850c377240f3d$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $e38850c377240f3d$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $e38850c377240f3d$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $e38850c377240f3d$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $e38850c377240f3d$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $e38850c377240f3d$var$InitialDeviceTypes;
    }
};
var $e38850c377240f3d$var$setUserAgent = function setUserAgent(userAgent) {
    return $e38850c377240f3d$var$setUa(userAgent);
};
var $e38850c377240f3d$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $e38850c377240f3d$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $e38850c377240f3d$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $e38850c377240f3d$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $e38850c377240f3d$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $e38850c377240f3d$var$setDefaults(browser.major),
        browserFullVersion: $e38850c377240f3d$var$setDefaults(browser.version),
        browserName: $e38850c377240f3d$var$setDefaults(browser.name),
        engineName: $e38850c377240f3d$var$setDefaults(engine.name),
        engineVersion: $e38850c377240f3d$var$setDefaults(engine.version),
        osName: $e38850c377240f3d$var$setDefaults(os.name),
        osVersion: $e38850c377240f3d$var$setDefaults(os.version),
        userAgent: $e38850c377240f3d$var$setDefaults(ua)
    };
};
var $e38850c377240f3d$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $e38850c377240f3d$var$_objectSpread2({}, type, {
        vendor: $e38850c377240f3d$var$setDefaults(device.vendor),
        model: $e38850c377240f3d$var$setDefaults(device.model),
        os: $e38850c377240f3d$var$setDefaults(os.name),
        osVersion: $e38850c377240f3d$var$setDefaults(os.version),
        ua: $e38850c377240f3d$var$setDefaults(ua)
    });
};
var $e38850c377240f3d$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $e38850c377240f3d$var$setDefaults(engine.name),
        engineVersion: $e38850c377240f3d$var$setDefaults(engine.version),
        osName: $e38850c377240f3d$var$setDefaults(os.name),
        osVersion: $e38850c377240f3d$var$setDefaults(os.version),
        userAgent: $e38850c377240f3d$var$setDefaults(ua)
    };
};
var $e38850c377240f3d$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $e38850c377240f3d$var$setDefaults(engine.name),
        engineVersion: $e38850c377240f3d$var$setDefaults(engine.version),
        osName: $e38850c377240f3d$var$setDefaults(os.name),
        osVersion: $e38850c377240f3d$var$setDefaults(os.version),
        userAgent: $e38850c377240f3d$var$setDefaults(ua)
    };
};
var $e38850c377240f3d$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $e38850c377240f3d$var$setDefaults(engine.name),
        engineVersion: $e38850c377240f3d$var$setDefaults(engine.version),
        osName: $e38850c377240f3d$var$setDefaults(os.name),
        osVersion: $e38850c377240f3d$var$setDefaults(os.version),
        userAgent: $e38850c377240f3d$var$setDefaults(ua)
    };
};
var $e38850c377240f3d$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $e38850c377240f3d$var$setDefaults(device.vendor),
        model: $e38850c377240f3d$var$setDefaults(device.model),
        engineName: $e38850c377240f3d$var$setDefaults(engine.name),
        engineVersion: $e38850c377240f3d$var$setDefaults(engine.version),
        osName: $e38850c377240f3d$var$setDefaults(os.name),
        osVersion: $e38850c377240f3d$var$setDefaults(os.version),
        userAgent: $e38850c377240f3d$var$setDefaults(ua)
    };
};
function $e38850c377240f3d$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $e38850c377240f3d$var$parseUserAgent(userAgent) : $e38850c377240f3d$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $e38850c377240f3d$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $e38850c377240f3d$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $e38850c377240f3d$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $e38850c377240f3d$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $e38850c377240f3d$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $e38850c377240f3d$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $e38850c377240f3d$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $e38850c377240f3d$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $e38850c377240f3d$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $e38850c377240f3d$var$DeviceTypes.Mobile;
};
var $e38850c377240f3d$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $e38850c377240f3d$var$DeviceTypes.Tablet;
};
var $e38850c377240f3d$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $e38850c377240f3d$var$DeviceTypes.Mobile || type === $e38850c377240f3d$var$DeviceTypes.Tablet;
};
var $e38850c377240f3d$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $e38850c377240f3d$var$DeviceTypes.SmartTv;
};
var $e38850c377240f3d$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $e38850c377240f3d$var$DeviceTypes.Browser;
};
var $e38850c377240f3d$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $e38850c377240f3d$var$DeviceTypes.Wearable;
};
var $e38850c377240f3d$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $e38850c377240f3d$var$DeviceTypes.Console;
};
var $e38850c377240f3d$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $e38850c377240f3d$var$DeviceTypes.Embedded;
};
var $e38850c377240f3d$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $e38850c377240f3d$var$setDefaults(vendor);
};
var $e38850c377240f3d$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $e38850c377240f3d$var$setDefaults(model);
};
var $e38850c377240f3d$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $e38850c377240f3d$var$setDefaults(type, 'browser');
}; // os types
var $e38850c377240f3d$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $e38850c377240f3d$var$OsTypes.Android;
};
var $e38850c377240f3d$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $e38850c377240f3d$var$OsTypes.Windows;
};
var $e38850c377240f3d$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $e38850c377240f3d$var$OsTypes.MAC_OS;
};
var $e38850c377240f3d$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $e38850c377240f3d$var$OsTypes.WindowsPhone;
};
var $e38850c377240f3d$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $e38850c377240f3d$var$OsTypes.IOS;
};
var $e38850c377240f3d$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $e38850c377240f3d$var$setDefaults(version);
};
var $e38850c377240f3d$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $e38850c377240f3d$var$setDefaults(name);
}; // browser types
var $e38850c377240f3d$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $e38850c377240f3d$var$BrowserTypes.Chrome;
};
var $e38850c377240f3d$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $e38850c377240f3d$var$BrowserTypes.Firefox;
};
var $e38850c377240f3d$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $e38850c377240f3d$var$BrowserTypes.Chromium;
};
var $e38850c377240f3d$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $e38850c377240f3d$var$BrowserTypes.Edge;
};
var $e38850c377240f3d$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $e38850c377240f3d$var$BrowserTypes.Yandex;
};
var $e38850c377240f3d$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $e38850c377240f3d$var$BrowserTypes.Safari || name === $e38850c377240f3d$var$BrowserTypes.MobileSafari;
};
var $e38850c377240f3d$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $e38850c377240f3d$var$BrowserTypes.MobileSafari;
};
var $e38850c377240f3d$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $e38850c377240f3d$var$BrowserTypes.Opera;
};
var $e38850c377240f3d$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $e38850c377240f3d$var$BrowserTypes.InternetExplorer || name === $e38850c377240f3d$var$BrowserTypes.Ie;
};
var $e38850c377240f3d$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $e38850c377240f3d$var$BrowserTypes.MIUI;
};
var $e38850c377240f3d$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $e38850c377240f3d$var$BrowserTypes.SamsungBrowser;
};
var $e38850c377240f3d$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $e38850c377240f3d$var$setDefaults(version);
};
var $e38850c377240f3d$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $e38850c377240f3d$var$setDefaults(major);
};
var $e38850c377240f3d$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $e38850c377240f3d$var$setDefaults(name);
}; // engine types
var $e38850c377240f3d$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $e38850c377240f3d$var$setDefaults(name);
};
var $e38850c377240f3d$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $e38850c377240f3d$var$setDefaults(version);
};
var $e38850c377240f3d$var$isElectronType = function isElectronType() {
    var nav = $e38850c377240f3d$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $e38850c377240f3d$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $e38850c377240f3d$var$getIOS13 = function getIOS13() {
    var nav = $e38850c377240f3d$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $e38850c377240f3d$var$getIPad13 = function getIPad13() {
    return $e38850c377240f3d$var$isIOS13Check('iPad');
};
var $e38850c377240f3d$var$getIphone13 = function getIphone13() {
    return $e38850c377240f3d$var$isIOS13Check('iPhone');
};
var $e38850c377240f3d$var$getIPod13 = function getIPod13() {
    return $e38850c377240f3d$var$isIOS13Check('iPod');
};
var $e38850c377240f3d$var$getUseragent = function getUseragent(userAg) {
    return $e38850c377240f3d$var$setDefaults(userAg);
};
function $e38850c377240f3d$var$buildSelectorsObject(options) {
    var _ref = options ? options : $e38850c377240f3d$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $e38850c377240f3d$var$isSmartTVType(device),
        isConsole: $e38850c377240f3d$var$isConsoleType(device),
        isWearable: $e38850c377240f3d$var$isWearableType(device),
        isEmbedded: $e38850c377240f3d$var$isEmbeddedType(device),
        isMobileSafari: $e38850c377240f3d$var$isMobileSafariType(browser) || $e38850c377240f3d$var$getIPad13(),
        isChromium: $e38850c377240f3d$var$isChromiumType(browser),
        isMobile: $e38850c377240f3d$var$isMobileAndTabletType(device) || $e38850c377240f3d$var$getIPad13(),
        isMobileOnly: $e38850c377240f3d$var$isMobileType(device),
        isTablet: $e38850c377240f3d$var$isTabletType(device) || $e38850c377240f3d$var$getIPad13(),
        isBrowser: $e38850c377240f3d$var$isBrowserType(device),
        isDesktop: $e38850c377240f3d$var$isBrowserType(device),
        isAndroid: $e38850c377240f3d$var$isAndroidType(os),
        isWinPhone: $e38850c377240f3d$var$isWinPhoneType(os),
        isIOS: $e38850c377240f3d$var$isIOSType(os) || $e38850c377240f3d$var$getIPad13(),
        isChrome: $e38850c377240f3d$var$isChromeType(browser),
        isFirefox: $e38850c377240f3d$var$isFirefoxType(browser),
        isSafari: $e38850c377240f3d$var$isSafariType(browser),
        isOpera: $e38850c377240f3d$var$isOperaType(browser),
        isIE: $e38850c377240f3d$var$isIEType(browser),
        osVersion: $e38850c377240f3d$var$getOsVersion(os),
        osName: $e38850c377240f3d$var$getOsName(os),
        fullBrowserVersion: $e38850c377240f3d$var$getBrowserFullVersion(browser),
        browserVersion: $e38850c377240f3d$var$getBrowserVersion(browser),
        browserName: $e38850c377240f3d$var$getBrowserName(browser),
        mobileVendor: $e38850c377240f3d$var$getMobileVendor(device),
        mobileModel: $e38850c377240f3d$var$getMobileModel(device),
        engineName: $e38850c377240f3d$var$getEngineName(engine),
        engineVersion: $e38850c377240f3d$var$getEngineVersion(engine),
        getUA: $e38850c377240f3d$var$getUseragent(ua),
        isEdge: $e38850c377240f3d$var$isEdgeType(browser) || $e38850c377240f3d$var$isEdgeChromiumType(ua),
        isYandex: $e38850c377240f3d$var$isYandexType(browser),
        deviceType: $e38850c377240f3d$var$getDeviceType(device),
        isIOS13: $e38850c377240f3d$var$getIOS13(),
        isIPad13: $e38850c377240f3d$var$getIPad13(),
        isIPhone13: $e38850c377240f3d$var$getIphone13(),
        isIPod13: $e38850c377240f3d$var$getIPod13(),
        isElectron: $e38850c377240f3d$var$isElectronType(),
        isEdgeChromium: $e38850c377240f3d$var$isEdgeChromiumType(ua),
        isLegacyEdge: $e38850c377240f3d$var$isEdgeType(browser) && !$e38850c377240f3d$var$isEdgeChromiumType(ua),
        isWindows: $e38850c377240f3d$var$isWindowsType(os),
        isMacOs: $e38850c377240f3d$var$isMacOsType(os),
        isMIUI: $e38850c377240f3d$var$isMIUIType(browser),
        isSamsungBrowser: $e38850c377240f3d$var$isSamsungBrowserType(browser)
    };
}
var $e38850c377240f3d$var$isSmartTV = $e38850c377240f3d$var$isSmartTVType($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$isConsole = $e38850c377240f3d$var$isConsoleType($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$isWearable = $e38850c377240f3d$var$isWearableType($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$isEmbedded = $e38850c377240f3d$var$isEmbeddedType($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$isMobileSafari = $e38850c377240f3d$var$isMobileSafariType($e38850c377240f3d$var$browser) || $e38850c377240f3d$var$getIPad13();
var $e38850c377240f3d$var$isChromium = $e38850c377240f3d$var$isChromiumType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$isMobile = $e38850c377240f3d$var$isMobileAndTabletType($e38850c377240f3d$var$device) || $e38850c377240f3d$var$getIPad13();
var $e38850c377240f3d$var$isMobileOnly = $e38850c377240f3d$var$isMobileType($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$isTablet = $e38850c377240f3d$var$isTabletType($e38850c377240f3d$var$device) || $e38850c377240f3d$var$getIPad13();
var $e38850c377240f3d$var$isBrowser = $e38850c377240f3d$var$isBrowserType($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$isDesktop = $e38850c377240f3d$var$isBrowserType($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$isAndroid = $e38850c377240f3d$var$isAndroidType($e38850c377240f3d$var$os);
var $e38850c377240f3d$var$isWinPhone = $e38850c377240f3d$var$isWinPhoneType($e38850c377240f3d$var$os);
var $e38850c377240f3d$var$isIOS = $e38850c377240f3d$var$isIOSType($e38850c377240f3d$var$os) || $e38850c377240f3d$var$getIPad13();
var $e38850c377240f3d$var$isChrome = $e38850c377240f3d$var$isChromeType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$isFirefox = $e38850c377240f3d$var$isFirefoxType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$isSafari = $e38850c377240f3d$var$isSafariType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$isOpera = $e38850c377240f3d$var$isOperaType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$isIE = $e38850c377240f3d$var$isIEType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$osVersion = $e38850c377240f3d$var$getOsVersion($e38850c377240f3d$var$os);
var $e38850c377240f3d$var$osName = $e38850c377240f3d$var$getOsName($e38850c377240f3d$var$os);
var $e38850c377240f3d$var$fullBrowserVersion = $e38850c377240f3d$var$getBrowserFullVersion($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$browserVersion = $e38850c377240f3d$var$getBrowserVersion($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$browserName = $e38850c377240f3d$var$getBrowserName($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$mobileVendor = $e38850c377240f3d$var$getMobileVendor($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$mobileModel = $e38850c377240f3d$var$getMobileModel($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$engineName = $e38850c377240f3d$var$getEngineName($e38850c377240f3d$var$engine);
var $e38850c377240f3d$var$engineVersion = $e38850c377240f3d$var$getEngineVersion($e38850c377240f3d$var$engine);
var $e38850c377240f3d$var$getUA = $e38850c377240f3d$var$getUseragent($e38850c377240f3d$var$ua);
var $e38850c377240f3d$var$isEdge = $e38850c377240f3d$var$isEdgeType($e38850c377240f3d$var$browser) || $e38850c377240f3d$var$isEdgeChromiumType($e38850c377240f3d$var$ua);
var $e38850c377240f3d$var$isYandex = $e38850c377240f3d$var$isYandexType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$deviceType = $e38850c377240f3d$var$getDeviceType($e38850c377240f3d$var$device);
var $e38850c377240f3d$var$isIOS13 = $e38850c377240f3d$var$getIOS13();
var $e38850c377240f3d$var$isIPad13 = $e38850c377240f3d$var$getIPad13();
var $e38850c377240f3d$var$isIPhone13 = $e38850c377240f3d$var$getIphone13();
var $e38850c377240f3d$var$isIPod13 = $e38850c377240f3d$var$getIPod13();
var $e38850c377240f3d$var$isElectron = $e38850c377240f3d$var$isElectronType();
var $e38850c377240f3d$var$isEdgeChromium = $e38850c377240f3d$var$isEdgeChromiumType($e38850c377240f3d$var$ua);
var $e38850c377240f3d$var$isLegacyEdge = $e38850c377240f3d$var$isEdgeType($e38850c377240f3d$var$browser) && !$e38850c377240f3d$var$isEdgeChromiumType($e38850c377240f3d$var$ua);
var $e38850c377240f3d$var$isWindows = $e38850c377240f3d$var$isWindowsType($e38850c377240f3d$var$os);
var $e38850c377240f3d$var$isMacOs = $e38850c377240f3d$var$isMacOsType($e38850c377240f3d$var$os);
var $e38850c377240f3d$var$isMIUI = $e38850c377240f3d$var$isMIUIType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$isSamsungBrowser = $e38850c377240f3d$var$isSamsungBrowserType($e38850c377240f3d$var$browser);
var $e38850c377240f3d$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $e38850c377240f3d$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $e38850c377240f3d$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $e38850c377240f3d$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isAndroid ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isBrowser ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isIE ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isIOS ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isMobile ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isTablet ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isWinPhone ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $e38850c377240f3d$var$isMobileOnly ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isSmartTV ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isConsole ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $e38850c377240f3d$var$isWearable ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
var $e38850c377240f3d$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $e38850c377240f3d$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $e38850c377240f3d$var$React__default.createElement($bh6RR.Fragment, null, children) : $e38850c377240f3d$var$React__default.createElement("div", props, children) : null;
};
function $e38850c377240f3d$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $e38850c377240f3d$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $e38850c377240f3d$var$_classCallCheck(this, _class);
            _this = $e38850c377240f3d$var$_possibleConstructorReturn(this, $e38850c377240f3d$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($e38850c377240f3d$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($e38850c377240f3d$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($e38850c377240f3d$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $e38850c377240f3d$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $e38850c377240f3d$var$_typeof(window)) !== undefined && $e38850c377240f3d$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $e38850c377240f3d$var$React__default.createElement(WrappedComponent, $e38850c377240f3d$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($e38850c377240f3d$var$React__default.Component);
}
function $e38850c377240f3d$var$useMobileOrientation() {
    var _useState = $bh6RR.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $e38850c377240f3d$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $bh6RR.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $bh6RR.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $e38850c377240f3d$var$_typeof(window)) !== undefined && $e38850c377240f3d$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $e38850c377240f3d$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $e38850c377240f3d$var$parseUserAgent(hookUserAgent);
}
function $e38850c377240f3d$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $e38850c377240f3d$var$useDeviceData(hookUserAgent);
    var selectors = $e38850c377240f3d$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$e38850c377240f3d$exports.AndroidView = $e38850c377240f3d$var$AndroidView;
$e38850c377240f3d$exports.BrowserTypes = $e38850c377240f3d$var$BrowserTypes;
$e38850c377240f3d$exports.BrowserView = $e38850c377240f3d$var$BrowserView;
$e38850c377240f3d$exports.ConsoleView = $e38850c377240f3d$var$ConsoleView;
$e38850c377240f3d$exports.CustomView = $e38850c377240f3d$var$CustomView;
$e38850c377240f3d$exports.IEView = $e38850c377240f3d$var$IEView;
$e38850c377240f3d$exports.IOSView = $e38850c377240f3d$var$IOSView;
$e38850c377240f3d$exports.MobileOnlyView = $e38850c377240f3d$var$MobileOnlyView;
$e38850c377240f3d$exports.MobileView = $e38850c377240f3d$var$MobileView;
$e38850c377240f3d$exports.OsTypes = $e38850c377240f3d$var$OsTypes;
$e38850c377240f3d$exports.SmartTVView = $e38850c377240f3d$var$SmartTVView;
$e38850c377240f3d$exports.TabletView = $e38850c377240f3d$var$TabletView;
$e38850c377240f3d$exports.WearableView = $e38850c377240f3d$var$WearableView;
$e38850c377240f3d$exports.WinPhoneView = $e38850c377240f3d$var$WinPhoneView;
$e38850c377240f3d$exports.browserName = $e38850c377240f3d$var$browserName;
$e38850c377240f3d$exports.browserVersion = $e38850c377240f3d$var$browserVersion;
$e38850c377240f3d$exports.deviceDetect = $e38850c377240f3d$var$deviceDetect;
$e38850c377240f3d$exports.deviceType = $e38850c377240f3d$var$deviceType;
$e38850c377240f3d$exports.engineName = $e38850c377240f3d$var$engineName;
$e38850c377240f3d$exports.engineVersion = $e38850c377240f3d$var$engineVersion;
$e38850c377240f3d$exports.fullBrowserVersion = $e38850c377240f3d$var$fullBrowserVersion;
$e38850c377240f3d$exports.getSelectorsByUserAgent = $e38850c377240f3d$var$getSelectorsByUserAgent;
$e38850c377240f3d$exports.getUA = $e38850c377240f3d$var$getUA;
$e38850c377240f3d$exports.isAndroid = $e38850c377240f3d$var$isAndroid;
$e38850c377240f3d$exports.isBrowser = $e38850c377240f3d$var$isBrowser;
$e38850c377240f3d$exports.isChrome = $e38850c377240f3d$var$isChrome;
$e38850c377240f3d$exports.isChromium = $e38850c377240f3d$var$isChromium;
$e38850c377240f3d$exports.isConsole = $e38850c377240f3d$var$isConsole;
$e38850c377240f3d$exports.isDesktop = $e38850c377240f3d$var$isDesktop;
$e38850c377240f3d$exports.isEdge = $e38850c377240f3d$var$isEdge;
$e38850c377240f3d$exports.isEdgeChromium = $e38850c377240f3d$var$isEdgeChromium;
$e38850c377240f3d$exports.isElectron = $e38850c377240f3d$var$isElectron;
$e38850c377240f3d$exports.isEmbedded = $e38850c377240f3d$var$isEmbedded;
$e38850c377240f3d$exports.isFirefox = $e38850c377240f3d$var$isFirefox;
$e38850c377240f3d$exports.isIE = $e38850c377240f3d$var$isIE;
$e38850c377240f3d$exports.isIOS = $e38850c377240f3d$var$isIOS;
$e38850c377240f3d$exports.isIOS13 = $e38850c377240f3d$var$isIOS13;
$e38850c377240f3d$exports.isIPad13 = $e38850c377240f3d$var$isIPad13;
$e38850c377240f3d$exports.isIPhone13 = $e38850c377240f3d$var$isIPhone13;
$e38850c377240f3d$exports.isIPod13 = $e38850c377240f3d$var$isIPod13;
$e38850c377240f3d$exports.isLegacyEdge = $e38850c377240f3d$var$isLegacyEdge;
$e38850c377240f3d$exports.isMIUI = $e38850c377240f3d$var$isMIUI;
$e38850c377240f3d$exports.isMacOs = $e38850c377240f3d$var$isMacOs;
$e38850c377240f3d$exports.isMobile = $e38850c377240f3d$var$isMobile;
$e38850c377240f3d$exports.isMobileOnly = $e38850c377240f3d$var$isMobileOnly;
$e38850c377240f3d$exports.isMobileSafari = $e38850c377240f3d$var$isMobileSafari;
$e38850c377240f3d$exports.isOpera = $e38850c377240f3d$var$isOpera;
$e38850c377240f3d$exports.isSafari = $e38850c377240f3d$var$isSafari;
$e38850c377240f3d$exports.isSamsungBrowser = $e38850c377240f3d$var$isSamsungBrowser;
$e38850c377240f3d$exports.isSmartTV = $e38850c377240f3d$var$isSmartTV;
$e38850c377240f3d$exports.isTablet = $e38850c377240f3d$var$isTablet;
$e38850c377240f3d$exports.isWearable = $e38850c377240f3d$var$isWearable;
$e38850c377240f3d$exports.isWinPhone = $e38850c377240f3d$var$isWinPhone;
$e38850c377240f3d$exports.isWindows = $e38850c377240f3d$var$isWindows;
$e38850c377240f3d$exports.isYandex = $e38850c377240f3d$var$isYandex;
$e38850c377240f3d$exports.mobileModel = $e38850c377240f3d$var$mobileModel;
$e38850c377240f3d$exports.mobileVendor = $e38850c377240f3d$var$mobileVendor;
$e38850c377240f3d$exports.osName = $e38850c377240f3d$var$osName;
$e38850c377240f3d$exports.osVersion = $e38850c377240f3d$var$osVersion;
$e38850c377240f3d$exports.parseUserAgent = $e38850c377240f3d$var$parseUserAgent;
$e38850c377240f3d$exports.setUserAgent = $e38850c377240f3d$var$setUserAgent;
$e38850c377240f3d$exports.useDeviceData = $e38850c377240f3d$var$useDeviceData;
$e38850c377240f3d$exports.useDeviceSelectors = $e38850c377240f3d$var$useDeviceSelectors;
$e38850c377240f3d$exports.useMobileOrientation = $e38850c377240f3d$var$useMobileOrientation;
$e38850c377240f3d$exports.withOrientationChange = $e38850c377240f3d$var$withOrientationChange;





var $bh6RR = parcelRequire("bh6RR");
function $387d43bfdba45524$var$Saved(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2",
        width: "2em",
        height: "2em",
        viewBox: "0 0 128 128",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("style", {
                    children: ".prefix__cls-1{fill:none;stroke-width:0}"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "prefix__Layer_1-2",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-1",
                        d: "M0 0h128v128H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        strokeWidth: 0,
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M92.18 110.755c-.45 0-.894-.113-1.32-.338L69.561 99.22c-1.708-.899-3.632-1.373-5.562-1.373s-3.853.474-5.562 1.373L37.14 110.417a2.816 2.816 0 01-1.322.338c-.82 0-1.64-.388-2.187-1.038a2.733 2.733 0 01-.608-2.291l4.068-23.714a11.947 11.947 0 00-3.438-10.58l-17.23-16.795a2.783 2.783 0 01-.717-2.907 2.784 2.784 0 012.29-1.932l23.81-3.46a11.952 11.952 0 009-6.538l10.65-21.576c.488-.99 1.44-1.581 2.543-1.581s2.055.59 2.543 1.58L77.193 41.5a11.945 11.945 0 009 6.538l23.81 3.46c1.093.16 1.95.88 2.29 1.932a2.783 2.783 0 01-.718 2.907l-17.23 16.795a11.95 11.95 0 00-3.437 10.58l4.068 23.715a2.733 2.733 0 01-.608 2.29c-.548.65-1.366 1.038-2.187 1.038z",
                                fill: props.fill || "#faaf40"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M64 20.842c.21 0 .26.104.302.188L74.95 42.606a14.45 14.45 0 0010.883 7.907l23.81 3.46c.093.013.208.03.272.229.065.199-.018.28-.085.345L92.6 71.342a14.45 14.45 0 00-4.156 12.792l4.067 23.715c.024.136.002.189-.054.256-.073.087-.19.15-.277.15a.364.364 0 01-.157-.05L70.725 97.006c-2.065-1.086-4.391-1.66-6.725-1.66s-4.66.574-6.725 1.66l-21.298 11.197a.363.363 0 01-.157.05c-.088 0-.204-.062-.277-.15-.056-.066-.078-.118-.054-.255l4.067-23.715A14.45 14.45 0 0035.4 71.342L18.17 54.547c-.067-.065-.15-.146-.085-.345.064-.2.18-.216.271-.23l23.811-3.46a14.45 14.45 0 0010.882-7.906L63.7 21.03c.04-.084.092-.188.301-.188m0-5c-1.903 0-3.807.992-4.785 2.975l-10.65 21.577a9.453 9.453 0 01-7.117 5.17l-23.81 3.46c-4.378.637-6.126 6.016-2.958 9.103l17.23 16.795a9.453 9.453 0 012.718 8.367l-4.067 23.715c-.592 3.45 2.149 6.25 5.259 6.25.82 0 1.667-.195 2.484-.624L59.6 101.433a9.448 9.448 0 018.798 0l21.297 11.197c.818.43 1.664.625 2.484.625 3.11 0 5.85-2.802 5.26-6.25l-4.068-23.716a9.453 9.453 0 012.718-8.367l17.23-16.795c3.168-3.087 1.42-8.466-2.957-9.102l-23.811-3.46a9.453 9.453 0 01-7.118-5.171L68.785 18.817c-.978-1.983-2.882-2.975-4.785-2.975z",
                                fill: "#1a1a1a"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-1",
                        d: "M0 0h128v128H0z"
                    })
                ]
            })
        ]
    });
}
const $387d43bfdba45524$var$MemoSaved = /*#__PURE__*/ $bh6RR.memo($387d43bfdba45524$var$Saved);
var $387d43bfdba45524$export$2e2bcd8739ae039 = $387d43bfdba45524$var$MemoSaved;



parcelRequire("bh6RR");

const $e7ecfdd78d0f4ae4$export$4b85d3515bd863a5 = ()=>{
    const { query: query, handleSearch: handleSearch } = (0, $38311d640b87f30b$export$bd221a7c56b93941)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "search-input-wrapper",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
            placeholder: "Search...",
            value: query,
            onChange: ({ target: target })=>handleSearch(target.value),
            onClick: ()=>handleSearch("")
        })
    });
};



parcelRequire("bh6RR");

function $369a771300366aee$var$FilterOptions() {
    const { showPast: showPast, setShowPast: setShowPast } = (0, $38311d640b87f30b$export$32391a757e6b1b69)();
    const { showAllDay: showAllDay, setShowAllDay: setShowAllDay } = (0, $38311d640b87f30b$export$ffb9577af324dc6a)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "menu-filter-container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "menu-filter-title",
                children: "FILTERS"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                htmlFor: "allDay",
                className: "menu-filter-label",
                children: [
                    "All Day",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "menu-filter-switch",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                type: "checkbox",
                                id: "allDay",
                                name: "allDay",
                                // className="menu-filter-slider"
                                value: "showAllDay",
                                checked: showAllDay,
                                onChange: ()=>setShowAllDay(!showAllDay)
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: "menu-filter-slider"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                htmlFor: "pastEvents",
                className: "menu-filter-label",
                children: [
                    "The Past",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "menu-filter-switch",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                type: "checkbox",
                                id: "pastEvents",
                                name: "pastEvents",
                                value: "showPast",
                                checked: showPast,
                                onChange: ()=>setShowPast(!showPast)
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: "menu-filter-slider"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $369a771300366aee$export$2e2bcd8739ae039 = $369a771300366aee$var$FilterOptions;



parcelRequire("bh6RR");
const $ca4968f1fdafc5e8$var$SvgAsset21SoakIcons = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 2",
        className: "icons",
        viewBox: "0 0 128 128",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
            "data-name": "Layer 1",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M64 119.277c31.48 0 57-24.748 57-55.276S95.48 8.723 64 8.723 7 33.472 7 64.001c0 30.528 25.52 55.276 57 55.276",
                    style: {
                        strokeWidth: 0,
                        fill: "#1a1a1a"
                    }
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M54.039 94.13 83.833 64 54.04 33.87",
                    style: {
                        fill: "none",
                        stroke: "#e9eaeb",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 6
                    }
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M0 0h128v128H0z",
                    style: {
                        strokeWidth: 0,
                        fill: "none"
                    }
                })
            ]
        })
    });
var $ca4968f1fdafc5e8$export$2e2bcd8739ae039 = $ca4968f1fdafc5e8$var$SvgAsset21SoakIcons;


var $815f827d334037ce$exports = {};
$815f827d334037ce$exports = $parcel$resolve("7FX8R");


const $06f08e8e9c61cd60$export$d9b273488cd8ce6f = ()=>{
    const { menu: menu, setMenu: setMenu } = (0, $38311d640b87f30b$export$38eaa17faae8f579)();
    const { filter: filter, FILTERS: FILTERS, handleFilterFavorites: handleFilterFavorites } = (0, $38311d640b87f30b$export$3274cf84b703fff)();
    const { setInstall: setInstall } = (0, $38311d640b87f30b$export$56bafadbb0c4d7e5)();
    const { showMap: showMap, setShowMap: setShowMap } = (0, $38311d640b87f30b$export$86f8f9f08863e403)();
    const imageUrl = new URL($815f827d334037ce$exports);
    function handleInstallClick() {
        setInstall(true);
        setMenu(false);
    }
    function handleMapClick() {
        setShowMap(!showMap);
        setMenu(false);
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "menu-header-wrapper",
        children: [
            !showMap ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "menu-header-content",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e7ecfdd78d0f4ae4$export$4b85d3515bd863a5), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("section", {
                        className: "menu-header-icon-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "menu-favorites-svg-wrapper",
                                onClick: handleFilterFavorites,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $387d43bfdba45524$export$2e2bcd8739ae039), {
                                    className: "menu-favorites-svg",
                                    fill: filter === FILTERS.FAVORITES ? "#faaf40" : "none"
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ca4968f1fdafc5e8$export$2e2bcd8739ae039), {
                                className: `menu-header-svg ${menu ? "expanded" : "closed"}`,
                                onClick: ()=>setMenu(!menu)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        hidden: "hidden",
                        src: imageUrl
                    })
                ]
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "menu-header-map",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "event-details-footer-button",
                    onClick: ()=>handleMapClick(),
                    children: "BACK"
                })
            }),
            menu && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "menu-accordian-drawer",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $369a771300366aee$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "install-button-wrapper",
                        children: [
                            (0, $e38850c377240f3d$exports.isMobile) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                className: "event-details-footer-button",
                                onClick: ()=>handleInstallClick(),
                                children: "INSTALL"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                className: "event-details-footer-button",
                                onClick: ()=>handleMapClick(),
                                children: "MAP"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "menu-accordian-contact",
                        children: [
                            "Created by ZeroDay ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            "With Ahoo, Spooky, and Overboard ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "menu-accordian-links",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        href: "mailto:nick.day.fsd@gmail.com?subject=WWW%20APP%20of%202025",
                                        className: "menu-contact-us-link",
                                        children: "Feedback/Kudos (email)"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        href: "https://ecograder.com/report/c2OWNACPj6X08fDIuoiDqowy",
                                        children: "Ecograde"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("bh6RR");

parcelRequire("bh6RR");

parcelRequire("bh6RR");

parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
function $f75ed97c03989eb1$var$Save(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2",
        width: "2em",
        height: "2em",
        viewBox: "0 0 128 128",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("style", {
                    children: ".prefix__cls-1,.prefix__cls-2{fill:none;stroke-width:0}.prefix__cls-2{fill:#1a1a1a}"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "prefix__Layer_1-2",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-1",
                        d: "M0 0h128v128H0z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M64 20.842c.21 0 .26.104.302.188L74.95 42.606a14.45 14.45 0 0010.883 7.907l23.81 3.46c.093.013.208.03.272.229.065.199-.018.28-.085.345L92.6 71.342a14.45 14.45 0 00-4.156 12.792l4.067 23.715c.024.136.002.189-.054.256-.073.087-.19.15-.277.15a.364.364 0 01-.157-.05L70.726 97.006c-2.066-1.086-4.392-1.66-6.726-1.66s-4.66.574-6.725 1.66l-21.298 11.197a.363.363 0 01-.157.05c-.088 0-.204-.062-.277-.15-.056-.066-.078-.118-.054-.255l4.067-23.715A14.45 14.45 0 0035.4 71.342L18.17 54.547c-.067-.065-.15-.146-.085-.345.064-.2.18-.216.271-.23l23.812-3.46a14.45 14.45 0 0010.881-7.906L63.7 21.03c.04-.084.092-.188.301-.188m0-5c-1.903 0-3.807.992-4.785 2.975l-10.65 21.577a9.453 9.453 0 01-7.116 5.17l-23.812 3.46c-4.377.637-6.125 6.016-2.957 9.103l17.23 16.795a9.453 9.453 0 012.718 8.367l-4.067 23.715c-.592 3.45 2.149 6.25 5.259 6.25.82 0 1.667-.195 2.484-.624L59.6 101.433a9.449 9.449 0 018.798 0l21.297 11.197c.818.43 1.664.625 2.484.625 3.11 0 5.85-2.802 5.26-6.25l-4.068-23.716a9.453 9.453 0 012.718-8.367l17.23-16.795c3.168-3.087 1.42-8.466-2.957-9.102l-23.811-3.46a9.453 9.453 0 01-7.118-5.171L68.786 18.817c-.98-1.983-2.883-2.975-4.786-2.975z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M101.04 40.757a2.5 2.5 0 01-2.5-2.5v-25.6a2.5 2.5 0 115 0v25.6a2.5 2.5 0 01-2.5 2.5z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M113.84 27.957h-25.6a2.5 2.5 0 110-5h25.6a2.5 2.5 0 110 5z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-1",
                        d: "M0 0h128v128H0z"
                    })
                ]
            })
        ]
    });
}
const $f75ed97c03989eb1$var$MemoSave = /*#__PURE__*/ $bh6RR.memo($f75ed97c03989eb1$var$Save);
var $f75ed97c03989eb1$export$2e2bcd8739ae039 = $f75ed97c03989eb1$var$MemoSave;




function $80f4641d11dfd750$var$FavIcon({ event: event }) {
    const { handleFavoriteDisplay: handleFavoriteDisplay, handleToggleFavorited: handleToggleFavorited } = (0, $38311d640b87f30b$export$3274cf84b703fff)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: handleFavoriteDisplay(event.uid) ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $387d43bfdba45524$export$2e2bcd8739ae039), {
            className: "event-details-fav",
            onClick: ()=>handleToggleFavorited(event.uid)
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f75ed97c03989eb1$export$2e2bcd8739ae039), {
            className: "event-details-fav",
            onClick: ()=>handleToggleFavorited(event.uid)
        })
    });
}
var $80f4641d11dfd750$export$2e2bcd8739ae039 = $80f4641d11dfd750$var$FavIcon;



parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
function $b764818d31ecdf56$var$AllDay(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2",
        width: "2.2em",
        height: "2.2em",
        viewBox: "0 0 128 128",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("style", {
                    children: ".prefix__cls-2{stroke-width:0;fill:#1a1a1a}"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "prefix__Layer_1-2",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M36.43 54.255c-9.829 0-17.825-7.996-17.825-17.825s7.996-17.825 17.824-17.825c9.83 0 17.826 7.996 17.826 17.825s-7.996 17.825-17.826 17.825zm0-30.65c-7.072 0-12.825 5.753-12.825 12.825s5.753 12.825 12.824 12.825c7.073 0 12.826-5.753 12.826-12.825s-5.753-12.825-12.826-12.825zM36.43 14.883a2.5 2.5 0 01-2.5-2.5V6.22a2.5 2.5 0 115 0v6.163a2.5 2.5 0 01-2.5 2.5zM53.433 21.926a2.5 2.5 0 01-1.768-4.268l4.358-4.357a2.5 2.5 0 113.535 3.535l-4.357 4.358a2.492 2.492 0 01-1.768.732zM66.64 38.93h-6.163a2.5 2.5 0 110-5h6.162a2.5 2.5 0 110 5zM57.79 60.291c-.639 0-1.279-.244-1.767-.732L51.666 55.2a2.5 2.5 0 113.535-3.535l4.357 4.358a2.5 2.5 0 01-1.767 4.267zM36.43 69.14a2.5 2.5 0 01-2.5-2.5v-6.163a2.5 2.5 0 115 0v6.162a2.5 2.5 0 01-2.5 2.5zM15.07 60.291a2.5 2.5 0 01-1.768-4.268l4.357-4.357a2.5 2.5 0 113.535 3.535l-4.357 4.358a2.492 2.492 0 01-1.768.732zM12.383 38.93H6.22a2.5 2.5 0 110-5h6.163a2.5 2.5 0 110 5zM19.427 21.926c-.64 0-1.28-.244-1.768-.732l-4.357-4.358a2.5 2.5 0 113.535-3.535l4.357 4.357a2.5 2.5 0 01-1.767 4.268zM86.446 119.313c-13.954 0-26.419-8.868-31.017-22.067a2.502 2.502 0 01.98-2.907 2.502 2.502 0 013.06.232c4.6 4.166 10.522 6.46 16.68 6.46 13.72 0 24.882-11.162 24.882-24.882 0-6.158-2.294-12.081-6.46-16.679a2.499 2.499 0 012.675-4.04c13.198 4.597 22.066 17.061 22.066 31.016 0 18.123-14.744 32.867-32.866 32.867zm-21.864-15.625c5.184 6.576 13.185 10.625 21.864 10.625 15.365 0 27.866-12.501 27.866-27.867 0-8.68-4.048-16.68-10.624-21.864a29.692 29.692 0 012.343 11.567c0 16.477-13.405 29.882-29.882 29.882-4.009 0-7.934-.808-11.567-2.343zM13.057 122.72a2.5 2.5 0 01-1.768-4.268L118.454 11.29a2.5 2.5 0 113.535 3.535L14.825 121.988a2.492 2.492 0 01-1.768.732z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        strokeWidth: 0,
                        fill: "none",
                        d: "M0 0h128v128H0z"
                    })
                ]
            })
        ]
    });
}
const $b764818d31ecdf56$var$MemoAllDay = /*#__PURE__*/ $bh6RR.memo($b764818d31ecdf56$var$AllDay);
var $b764818d31ecdf56$export$2e2bcd8739ae039 = $b764818d31ecdf56$var$MemoAllDay;




var $bh6RR = parcelRequire("bh6RR");
function $d4a267126faa6510$var$DayTime(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2",
        width: "2.2em",
        height: "2.2em",
        viewBox: "0 0 128 128",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("style", {
                    children: ".prefix__cls-2{stroke-width:0;fill:#1a1a1a}"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "prefix__Layer_1-2",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M64 99.146C44.62 99.146 28.853 83.38 28.853 64c0-19.38 15.767-35.146 35.147-35.146S99.146 44.62 99.146 64c0 19.38-15.766 35.146-35.146 35.146zm0-65.292c-16.623 0-30.147 13.523-30.147 30.146S47.377 94.146 64 94.146 94.146 80.623 94.146 64 80.623 33.854 64 33.854zM64 20.331a2.5 2.5 0 01-2.5-2.5V6a2.5 2.5 0 115 0V17.83a2.5 2.5 0 01-2.5 2.5zM96.646 33.854a2.5 2.5 0 01-1.768-4.268l8.367-8.366a2.5 2.5 0 113.535 3.535l-8.366 8.366a2.492 2.492 0 01-1.768.733zM122 66.5h-11.831a2.5 2.5 0 110-5h11.83a2.5 2.5 0 110 5zM105.013 107.512c-.64 0-1.28-.244-1.768-.732l-8.366-8.366a2.5 2.5 0 113.535-3.536l8.366 8.366a2.5 2.5 0 01-1.767 4.268zM64 124.5a2.5 2.5 0 01-2.5-2.5v-11.831a2.5 2.5 0 115 0v11.83a2.5 2.5 0 01-2.5 2.5zM22.988 107.512a2.5 2.5 0 01-1.768-4.268l8.366-8.365a2.5 2.5 0 113.535 3.535l-8.365 8.366a2.492 2.492 0 01-1.768.732zM17.83 66.5H6a2.5 2.5 0 110-5h11.83a2.5 2.5 0 110 5zM31.353 33.854c-.64 0-1.279-.244-1.767-.733l-8.365-8.366a2.5 2.5 0 113.535-3.535l8.365 8.366a2.5 2.5 0 01-1.768 4.268z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        strokeWidth: 0,
                        fill: "none",
                        d: "M0 0h128v128H0z"
                    })
                ]
            })
        ]
    });
}
const $d4a267126faa6510$var$MemoDayTime = /*#__PURE__*/ $bh6RR.memo($d4a267126faa6510$var$DayTime);
var $d4a267126faa6510$export$2e2bcd8739ae039 = $d4a267126faa6510$var$MemoDayTime;




var $bh6RR = parcelRequire("bh6RR");
function $87c1873e01ee97fc$var$NightTime(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        "data-name": "Layer 2",
        width: "2.2em",
        height: "2.2em",
        viewBox: "0 0 128 128",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
            "data-name": "Layer 1",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M62.463 119.5c-24.216 0-45.846-15.39-53.824-38.296a2.501 2.501 0 014.04-2.674c8.624 7.814 19.736 12.117 31.29 12.117 25.738 0 46.677-20.94 46.677-46.677 0-11.555-4.302-22.667-12.116-31.292a2.499 2.499 0 012.675-4.04c22.905 7.979 38.295 29.61 38.295 53.825 0 31.45-25.587 57.037-57.037 57.037zm-45.2-31.337c9.125 16.058 26.3 26.337 45.2 26.337 28.693 0 52.037-23.344 52.037-52.037 0-18.9-10.28-36.075-26.337-45.2a51.389 51.389 0 017.483 26.707c0 28.495-23.181 51.677-51.676 51.677-9.48 0-18.69-2.614-26.707-7.484z",
                    fill: "#1a1a1a"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fill: "none",
                    d: "M0 0h128v128H0z"
                })
            ]
        })
    });
}
const $87c1873e01ee97fc$var$MemoNightTime = /*#__PURE__*/ $bh6RR.memo($87c1873e01ee97fc$var$NightTime);
var $87c1873e01ee97fc$export$2e2bcd8739ae039 = $87c1873e01ee97fc$var$MemoNightTime;



function $6fa9f22a067f151c$var$SolarIcon({ event: event }) {
    // Figure out which icon to display based on event time
    const startTime = (0, $38311d640b87f30b$export$c9698ec7f05a07e1)(event.occurrence.start_time);
    const sunrise = (0, $38311d640b87f30b$export$c9698ec7f05a07e1)("05:30:00");
    const sunset = (0, $38311d640b87f30b$export$c9698ec7f05a07e1)("20:45:00");
    if (event.occurrence.short.includes("24hrs")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b764818d31ecdf56$export$2e2bcd8739ae039), {})
    });
    if (startTime > sunrise && startTime < sunset) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4a267126faa6510$export$2e2bcd8739ae039), {})
    });
    if (startTime < sunrise || startTime > sunset) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87c1873e01ee97fc$export$2e2bcd8739ae039), {})
    });
}
var $6fa9f22a067f151c$export$2e2bcd8739ae039 = $6fa9f22a067f151c$var$SolarIcon;


function $4a86d076ec401c58$var$EventTileHeader({ event: event }) {
    let when = event.occurrence.long.split(" ")[1].replace("-", " to ");
    if (event.occurrence.short.includes("24hrs")) when = "All Day";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("section", {
        className: "event-header-title",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6fa9f22a067f151c$export$2e2bcd8739ae039), {
                event: event
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "event-header-title-left",
                children: when
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $80f4641d11dfd750$export$2e2bcd8739ae039), {
                event: event
            })
        ]
    });
}
var $4a86d076ec401c58$export$2e2bcd8739ae039 = $4a86d076ec401c58$var$EventTileHeader;




var $bh6RR = parcelRequire("bh6RR");
function $2a62b23e56945f63$var$EventDescription({ event: event }) {
    const [showMore, setShowMore] = (0, $bh6RR.useState)(false);
    const MAX_LENGTH = 175;
    const description = event.description;
    if (description.length <= MAX_LENGTH) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("section", {
        className: "event-details-container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "event-details-title",
                children: event.title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "event-details-description",
                children: description
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: description.length > MAX_LENGTH && showMore === false ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("section", {
            className: "event-details-container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "event-details-title",
                    children: event.title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    className: "event-details-description",
                    children: [
                        `${description.substring(0, MAX_LENGTH)}...`,
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "event-details-description-more",
                            style: {
                                color: "#6169ff"
                            },
                            onClick: ()=>setShowMore(true),
                            children: "Read more"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("section", {
            className: "event-details-container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "event-details-title",
                    children: event.title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    className: "event-details-description",
                    children: [
                        description,
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "event-details-description-more",
                            style: {
                                color: "#6169ff"
                            },
                            onClick: ()=>setShowMore(false),
                            children: "Show less"
                        })
                    ]
                })
            ]
        })
    });
}
var $2a62b23e56945f63$export$2e2bcd8739ae039 = $2a62b23e56945f63$var$EventDescription;



parcelRequire("bh6RR");

function $40cb6c9cca0ab5f3$var$EventTileFooter({ event: event }) {
    const { handleFilterClick: handleFilterClick } = (0, $38311d640b87f30b$export$3274cf84b703fff)();
    const area = {
        Mezzanine: "#3c4978",
        "Lower Bowl": "#3c4978",
        "Main Field": "#408040",
        "Upper Bowl": "#408040",
        Riverside: "#408040",
        "North Point Forest": "#408040",
        "Mobile Art": "#408040",
        Around: "#408040",
        "Forest Entry": "#894a94",
        "The Meadow": "#894a94"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("section", {
        className: "event-details-footer",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                className: "event-details-footer-button",
                style: {
                    backgroundColor: area[event.neighborhood]
                },
                onClick: ()=>handleFilterClick(event.location),
                children: event.location
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                className: "event-details-footer-button",
                style: {
                    backgroundColor: area[event.neighborhood]
                },
                onClick: ()=>handleFilterClick(event.neighborhood),
                children: event.neighborhood
            })
        ]
    });
}
var $40cb6c9cca0ab5f3$export$2e2bcd8739ae039 = $40cb6c9cca0ab5f3$var$EventTileFooter;



parcelRequire("bh6RR");

parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
function $244ce85a94c71565$var$CatArt(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2",
        width: "2em",
        height: "2em",
        viewBox: "0 0 128 128",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("style", {
                    children: ".prefix__cls-2{stroke-width:0;fill:#1a1a1a}"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "prefix__Layer_1-2",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M60.34 116.5a53.57 53.57 0 01-10.432-1.033C28.174 111.149 11.282 92.87 8.83 71.017c-1.753-15.623 3.597-30.94 14.68-42.025C34.754 17.75 50.383 12.328 66.361 14.12c11.44 1.283 22.302 6.515 30.586 14.734a2.5 2.5 0 11-3.522 3.55c-7.487-7.429-17.296-12.157-27.62-13.315-14.474-1.62-28.597 3.277-38.758 13.439C17.046 42.53 12.217 56.356 13.799 70.46c2.211 19.713 17.46 36.204 37.084 40.103a48.478 48.478 0 0011.643.886 4.65 4.65 0 003.26-1.517 4.332 4.332 0 001.125-3.154c-.146-2.721-.327-6.11-.365-8.363-.102-6.034 2.248-11.037 6.285-13.382 2.387-1.386 5.133-1.716 7.339-1.982 6.908-.83 13.022-2.037 19.243-3.796 3.92-1.108 6.885-4.468 7.378-8.36.527-4.16.478-8.4-.146-12.602-.885-5.955-2.933-11.62-6.09-16.837a2.5 2.5 0 114.278-2.588c3.502 5.787 5.775 12.076 6.758 18.69a51.24 51.24 0 01.16 13.966c-.754 5.946-5.063 10.87-10.977 12.543-6.477 1.832-12.835 3.086-20.007 3.949-1.931.232-3.928.472-5.425 1.342-2.882 1.673-3.851 5.732-3.796 8.973.036 2.161.213 5.5.357 8.18a9.289 9.289 0 01-2.41 6.775c-1.733 1.915-4.124 3.036-6.735 3.157-.804.039-1.61.057-2.418.057z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M61.966 44.798c-5.74 0-10.41-4.636-10.41-10.335 0-5.698 4.67-10.334 10.41-10.334s10.41 4.636 10.41 10.334c0 5.699-4.67 10.335-10.41 10.335zm0-15.67c-2.983 0-5.41 2.394-5.41 5.335 0 2.942 2.427 5.335 5.41 5.335s5.41-2.393 5.41-5.335c0-2.941-2.427-5.334-5.41-5.334zM37.029 58.098c-5.74 0-10.41-4.636-10.41-10.334 0-5.699 4.67-10.335 10.41-10.335s10.41 4.636 10.41 10.335c0 5.698-4.67 10.334-10.41 10.334zm0-15.67c-2.983 0-5.41 2.394-5.41 5.336 0 2.941 2.427 5.334 5.41 5.334 2.982 0 5.41-2.393 5.41-5.334 0-2.942-2.428-5.335-5.41-5.335zM31.274 84.7c-5.74 0-10.41-4.637-10.41-10.336 0-5.698 4.67-10.334 10.41-10.334s10.41 4.636 10.41 10.334c0 5.7-4.67 10.335-10.41 10.335zm0-15.67c-2.982 0-5.41 2.393-5.41 5.334 0 2.942 2.428 5.335 5.41 5.335s5.41-2.393 5.41-5.335c0-2.941-2.427-5.334-5.41-5.334zM48.539 105.6c-5.74 0-10.41-4.636-10.41-10.334s4.67-10.335 10.41-10.335c5.739 0 10.409 4.637 10.409 10.335s-4.67 10.334-10.41 10.334zm0-15.67c-2.984 0-5.41 2.394-5.41 5.336s2.426 5.334 5.41 5.334c2.982 0 5.409-2.393 5.409-5.334s-2.427-5.335-5.41-5.335zM82.726 60.735a2.5 2.5 0 01-1.664-4.366c33.76-30.093 37.371-37.958 37.451-39.893h-.036c-2.846 0-14.447 7.232-40.776 35.444a2.5 2.5 0 11-3.656-3.411c22.796-24.425 37.754-36.876 44.463-37.007 1.848-.049 2.99.716 3.635 1.355s1.403 1.774 1.355 3.565c-.117 4.466-4.856 13.148-39.11 43.68a2.49 2.49 0 01-1.662.633z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M90.434 53.228a2.5 2.5 0 01-2.165-1.246c-2.02-3.484-4.259-5.698-6.657-6.58a2.5 2.5 0 111.727-4.692c3.521 1.295 6.635 4.244 9.256 8.764a2.5 2.5 0 01-2.16 3.754zM66.731 77.206c-2.175 0-4.462-.373-6.839-1.119-2.403-.753-4.338-1.74-5.914-3.016-1.914-1.547-3.186-3.878-4.03-5.42l-.161-.297a2.501 2.501 0 012.132-3.704c.68-.02 3.695-.717 4.346-.905 1.932-.578 3.035-1.074 3.694-2.175.405-.676.72-1.485 1.055-2.34.267-.682.542-1.387.889-2.1.877-1.8 2.155-3.25 3.8-4.305 2.663-1.708 6.089-2.21 9.403-1.367 3.328.844 6.135 2.96 7.7 5.803 1.454 2.641 1.832 6.076.962 8.749-1.063 3.273-3.545 5.969-4.928 7.284-2.39 2.27-5.261 3.828-8.303 4.504a17.473 17.473 0 01-3.806.408zm-10.74-9.246c.353.473.733.902 1.132 1.224 1.079.873 2.473 1.57 4.265 2.133 2.964.929 5.68 1.132 8.064.6 2.156-.479 4.212-1.602 5.943-3.247 1.745-1.66 3.098-3.605 3.618-5.206.442-1.357.195-3.372-.587-4.792-.9-1.635-2.558-2.862-4.55-3.368-1.974-.5-3.97-.235-5.473.73a5.552 5.552 0 00-2.004 2.284c-.259.532-.486 1.115-.727 1.731-.395 1.01-.803 2.054-1.422 3.089-1.639 2.738-4.243 3.706-6.556 4.398-.015.005-.744.199-1.702.424zm11.062-14.03h.01-.01z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        strokeWidth: 0,
                        fill: "none",
                        d: "M0 0h128v128H0z"
                    })
                ]
            })
        ]
    });
}
const $244ce85a94c71565$var$MemoCatArt = /*#__PURE__*/ $bh6RR.memo($244ce85a94c71565$var$CatArt);
var $244ce85a94c71565$export$2e2bcd8739ae039 = $244ce85a94c71565$var$MemoCatArt;




var $bh6RR = parcelRequire("bh6RR");
function $73d47c23a2deb7bc$var$CatClass(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2",
        width: "2em",
        height: "2em",
        viewBox: "0 0 128 128",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("style", {
                    children: ".prefix__cls-2{stroke-width:0;fill:#1a1a1a}"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "prefix__Layer_1-2",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M64 80.962a2.5 2.5 0 01-1.235-.327l-55-31.23a2.5 2.5 0 010-4.348l55-31.23a2.5 2.5 0 012.469 0l55 31.23a2.5 2.5 0 010 4.348l-55 31.23a2.5 2.5 0 01-1.234.327zm-49.937-33.73L64 75.586l49.936-28.356L64 18.875 14.063 47.231z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M64 95.303c-12.478 0-24.957-1.936-37.347-5.807a2.5 2.5 0 01-1.755-2.386V57.777a2.5 2.5 0 115 0v27.48c22.637 6.723 45.567 6.723 68.204 0v-27.48a2.5 2.5 0 115 0V87.11a2.5 2.5 0 01-1.755 2.386C88.957 93.367 76.478 95.303 64 95.303zM113.5 91.048a2.5 2.5 0 01-2.5-2.5V50.354a2.5 2.5 0 115 0v38.194a2.5 2.5 0 01-2.5 2.5z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M113.5 114.5c-3.902 0-7.077-3.175-7.077-7.076v-14.3c0-3.901 3.175-7.076 7.077-7.076s7.076 3.175 7.076 7.076v14.3c0 3.901-3.175 7.076-7.076 7.076zm0-23.452a2.079 2.079 0 00-2.077 2.076v14.3c0 1.144.932 2.076 2.077 2.076s2.076-.932 2.076-2.076v-14.3a2.079 2.079 0 00-2.076-2.076z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        strokeWidth: 0,
                        fill: "none",
                        d: "M0 0h128v128H0z"
                    })
                ]
            })
        ]
    });
}
const $73d47c23a2deb7bc$var$MemoCatClass = /*#__PURE__*/ $bh6RR.memo($73d47c23a2deb7bc$var$CatClass);
var $73d47c23a2deb7bc$export$2e2bcd8739ae039 = $73d47c23a2deb7bc$var$MemoCatClass;




var $bh6RR = parcelRequire("bh6RR");
function $f46979080e57430e$var$CatEntertainment(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2",
        width: "2em",
        height: "2em",
        viewBox: "0 0 128 128",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("style", {
                    children: ".prefix__cls-2{stroke-width:0;fill:#1a1a1a}"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "prefix__Layer_1-2",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M86.743 52.124c-12.548 0-22.756-10.233-22.756-22.812S74.195 6.5 86.743 6.5 109.5 16.734 109.5 29.312 99.29 52.124 86.743 52.124zm0-40.624c-9.791 0-17.756 7.99-17.756 17.812s7.965 17.812 17.756 17.812 17.757-7.99 17.757-17.812S96.534 11.5 86.743 11.5z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M30.806 96.203a2.496 2.496 0 01-1.771-.734L20.75 87.16a2.5 2.5 0 01-.084-3.442l44.977-49.745 3.71 3.353-43.386 47.985 4.924 4.936 47.003-42.732 3.364 3.699-48.77 44.338c-.478.434-1.08.65-1.682.65z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        transform: "rotate(-44.922 62.462 54.356)",
                        d: "M59.962 45.534h5v17.642h-5z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M37.948 121.49c-4.45.001-8.839-1.455-12.358-4.42-4.317-3.635-6.827-8.728-7.07-14.341a19.898 19.898 0 015.769-14.88 2.501 2.501 0 013.541 3.531 14.884 14.884 0 00-4.315 11.132c.181 4.198 2.062 8.01 5.295 10.734 5.793 4.88 14.816 4.203 20.54-1.537l24.7-24.768A12.56 12.56 0 0183 83.224c3.384 0 6.563 1.32 8.954 3.717 4.932 4.945 4.932 12.99.001 17.935l-2.873 2.881a2.501 2.501 0 01-3.541-3.531l2.873-2.881c2.99-2.998 2.99-7.875 0-10.872-1.445-1.45-3.368-2.25-5.412-2.25s-3.966.8-5.411 2.249l-24.7 24.768c-4.125 4.135-9.578 6.25-14.943 6.25zM100.364 46.136c-14.538-3.946-26.306-14.78-31.478-28.98l4.697-1.712C78.2 28.12 88.702 37.79 101.675 41.311l-1.31 4.825z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        strokeWidth: 0,
                        fill: "none",
                        d: "M0 0h128v128H0z"
                    })
                ]
            })
        ]
    });
}
const $f46979080e57430e$var$MemoCatEntertainment = /*#__PURE__*/ $bh6RR.memo($f46979080e57430e$var$CatEntertainment);
var $f46979080e57430e$export$2e2bcd8739ae039 = $f46979080e57430e$var$MemoCatEntertainment;




var $bh6RR = parcelRequire("bh6RR");
function $643070d6519f530c$var$CatFoodBev(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2",
        width: "2em",
        height: "2em",
        viewBox: "0 0 128 128",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("style", {
                    children: ".prefix__cls-2{stroke-width:0;fill:#1a1a1a}"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                id: "prefix__Layer_1-2",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M87.153 32.783H18.026c-4.15 0-7.526-3.377-7.526-7.527v-4.23c0-4.15 3.376-7.526 7.526-7.526h69.127c4.15 0 7.527 3.377 7.527 7.526v4.23c0 4.15-3.376 7.527-7.527 7.527zM18.026 18.5a2.53 2.53 0 00-2.526 2.526v4.23a2.53 2.53 0 002.526 2.527h69.127a2.53 2.53 0 002.527-2.527v-4.23a2.53 2.53 0 00-2.527-2.526H18.026z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M77.12 114.5H27.983c-7.402 0-13.424-6.022-13.424-13.425V30.283a2.5 2.5 0 012.5-2.5h70.986a2.5 2.5 0 012.5 2.5v70.792c0 7.403-6.023 13.425-13.425 13.425zM19.56 32.783v68.292c0 4.646 3.779 8.425 8.424 8.425H77.12c4.646 0 8.425-3.78 8.425-8.425V32.783H19.559z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "prefix__cls-2",
                        d: "M104.581 102.591H87.946a2.5 2.5 0 01-2.5-2.5V86.906a2.5 2.5 0 012.5-2.5h9.673c1.649 0 2.99-1.387 2.99-3.092V58.88c0-1.706-1.341-3.093-2.99-3.093h-9.673a2.5 2.5 0 01-2.5-2.5V40.104a2.5 2.5 0 012.5-2.5h16.635c7.123 0 12.919 5.884 12.919 13.117v38.753c0 7.232-5.796 13.117-12.919 13.117zm-14.135-5h14.135c4.366 0 7.919-3.642 7.919-8.117V50.72c0-4.476-3.553-8.117-7.919-8.117H90.446v8.184h7.173c4.405 0 7.99 3.63 7.99 8.093v22.433c0 4.462-3.585 8.092-7.99 8.092h-7.173v8.185z"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        strokeWidth: 0,
                        fill: "none",
                        d: "M0 0h128v128H0z"
                    })
                ]
            })
        ]
    });
}
const $643070d6519f530c$var$MemoCatFoodBev = /*#__PURE__*/ $bh6RR.memo($643070d6519f530c$var$CatFoodBev);
var $643070d6519f530c$export$2e2bcd8739ae039 = $643070d6519f530c$var$MemoCatFoodBev;




var $bh6RR = parcelRequire("bh6RR");
function $4a25582a626d8770$var$CatMisc(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        "data-name": "Layer 2",
        width: "2em",
        height: "2em",
        viewBox: "0 0 128 128",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
            "data-name": "Layer 1",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M25 119.5a2.5 2.5 0 01-2.168-3.745l28.085-48.886H25a2.5 2.5 0 01-2.059-3.919L59.715 9.582A2.5 2.5 0 0161.773 8.5h35.974a2.5 2.5 0 012.058 3.919L79.874 41.345H103a2.501 2.501 0 011.71 4.324l-78 73.154a2.494 2.494 0 01-1.71.677zm4.759-57.631h25.477a2.5 2.5 0 012.168 3.745l-21.883 38.091 61.158-57.36H75.115a2.5 2.5 0 01-2.059-3.918L92.988 13.5H63.087L29.759 61.87z",
                    fill: "#1a1a1a"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fill: "none",
                    d: "M0 0h128v128H0z"
                })
            ]
        })
    });
}
const $4a25582a626d8770$var$MemoCatMisc = /*#__PURE__*/ $bh6RR.memo($4a25582a626d8770$var$CatMisc);
var $4a25582a626d8770$export$2e2bcd8739ae039 = $4a25582a626d8770$var$MemoCatMisc;


function $6192e7f06885b4a8$var$CatIcon({ category: category }) {
    // All Categories: Arts & Crafts, Class/Workshop, Diversity & Inclusion, Fire/Spectacle, Food & Drink, For Kids, Games, Gathering/Party, Live Music, Mature Audiences, Miscellaneous, Parade, Performance, Repair, Ritual/Ceremony, Self Care, Sustainability/Greening Your Burn, Yoga/Movement/Fitness
    // Palette: Arts & Crafts, For Kids
    // Grad Cap: Class/Workshop, Diversity & Inclusion, Parade, Ritual/Ceremony
    // Mic: Live Music, Performance
    // Mug: Food & Drink, Self Care
    // Bolt: Fire/Spectacle, Sustainability/Greening Your Burn, Yoga/Movement/Fitness
    // TBD: Games, Gathering/Party, Mature Audiences, Misc, Repair
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            category.includes("Arts & Crafts") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $244ce85a94c71565$export$2e2bcd8739ae039), {}) : "",
            category.includes("Class/Workshop") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $73d47c23a2deb7bc$export$2e2bcd8739ae039), {}) : "",
            category.includes("Live Music") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f46979080e57430e$export$2e2bcd8739ae039), {}) : "",
            category.includes("Food & Drink") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $643070d6519f530c$export$2e2bcd8739ae039), {}) : "",
            category.includes("Fire/Spectacle") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4a25582a626d8770$export$2e2bcd8739ae039), {}) : ""
        ]
    });
}
var $6192e7f06885b4a8$export$2e2bcd8739ae039 = $6192e7f06885b4a8$var$CatIcon;


// import Location from "./icons/Location";
function $367fbf3ee07fa43e$var$EventIcons({ event: event }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("section", {
        className: "event-details-icons",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6192e7f06885b4a8$export$2e2bcd8739ae039), {
            category: event.event_type.label
        })
    });
}
var $367fbf3ee07fa43e$export$2e2bcd8739ae039 = $367fbf3ee07fa43e$var$EventIcons;


const $7b7c44ec3449ff98$export$9397a48ce18c8f16 = (event)=>{
    const area = {
        Mezzanine: "#E0E3EE",
        "Lower Bowl": "#E0E3EE",
        "Main Field": "#E1ECE1",
        "Upper Bowl": "#E1ECE1",
        Riverside: "#E1ECE1",
        "North Point Forest": "#E1ECE1",
        "Mobile Art": "#E1ECE1",
        Around: "#E1ECE1",
        "Forest Entry": "#E5DAE7",
        "The Meadow": "#E5DAE7"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "event-tile",
        style: {
            backgroundColor: area[event.neighborhood]
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4a86d076ec401c58$export$2e2bcd8739ae039), {
                event: event
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("section", {
                className: "event-details",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $367fbf3ee07fa43e$export$2e2bcd8739ae039), {
                        event: event
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2a62b23e56945f63$export$2e2bcd8739ae039), {
                        event: event
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $40cb6c9cca0ab5f3$export$2e2bcd8739ae039), {
                event: event
            })
        ]
    });
};



parcelRequire("bh6RR");



parcelRequire("bh6RR");
const $087927facefb832d$var$AppleShare = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: "2.3em",
        height: "2.3em",
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M30.3 13.7 25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M24 7h2v21h-2z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3"
            })
        ]
    });
var $087927facefb832d$export$2e2bcd8739ae039 = $087927facefb832d$var$AppleShare;



parcelRequire("bh6RR");
const $528eda419ff1c41e$var$SvgIcon = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        width: "1.5em",
        height: "1.5em",
        className: "bi bi-three-dots-vertical",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        })
    });
var $528eda419ff1c41e$export$2e2bcd8739ae039 = $528eda419ff1c41e$var$SvgIcon;



parcelRequire("bh6RR");
const $154842fb2e2e9b27$var$AddIOS = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "svg2",
        width: "2em",
        height: "2em",
        viewBox: "0 0 24 24",
        fill: "none",
        version: "1.1",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
            id: "g2",
            stroke: "#000",
            strokeMiterlimit: "10",
            strokeWidth: "1.5",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    id: "path1",
                    d: "M17.6 4H6.4A2.4 2.4 0 0 0 4 6.4v11.2A2.4 2.4 0 0 0 6.4 20h11.2a2.4 2.4 0 0 0 2.4-2.4V6.4A2.4 2.4 0 0 0 17.6 4Z"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    id: "path2",
                    strokeLinecap: "round",
                    d: "M12 16V8m4 4H8",
                    display: "inline"
                })
            ]
        })
    });
var $154842fb2e2e9b27$export$2e2bcd8739ae039 = $154842fb2e2e9b27$var$AddIOS;



parcelRequire("bh6RR");
const $7226c121971c7909$var$AddAndoid = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "2em",
        height: "2em",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M18 1.01 8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99M10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41z"
            })
        ]
    });
var $7226c121971c7909$export$2e2bcd8739ae039 = $7226c121971c7909$var$AddAndoid;


function $dba7186efc6bc3b9$var$Install() {
    const { setInstall: setInstall } = (0, $38311d640b87f30b$export$56bafadbb0c4d7e5)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "install-wrapper",
        children: [
            (0, $e38850c377240f3d$exports.isIOS) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    "Safari on iOS",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "install-list-item",
                                    children: [
                                        "Tap Share ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $087927facefb832d$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "install-list-item",
                                    children: [
                                        "Add to Home Screen ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $154842fb2e2e9b27$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "install-list-item",
                                    children: "Follow the prompts"
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, $e38850c377240f3d$exports.isAndroid) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    "Chrome/Firefox on Android",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "install-list-item",
                                    children: [
                                        "Top right menu",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $528eda419ff1c41e$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "install-list-item",
                                    children: [
                                        "Add to Home Screen",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7226c121971c7909$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "install-list-item",
                                    children: "Follow the prompts"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "install-button-wrapper",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    className: "event-details-footer-button",
                    onClick: ()=>setInstall(false),
                    children: "CLOSE"
                })
            })
        ]
    });
}
var $dba7186efc6bc3b9$export$2e2bcd8739ae039 = $dba7186efc6bc3b9$var$Install;



parcelRequire("bh6RR");

const $5aa85a3563593430$var$imageUrl = new URL($815f827d334037ce$exports);
function $5aa85a3563593430$var$PDFViewer() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "map-container",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            className: "map",
            src: $5aa85a3563593430$var$imageUrl,
            alt: "SOAK Map"
        })
    });
}
var $5aa85a3563593430$export$2e2bcd8739ae039 = $5aa85a3563593430$var$PDFViewer;



const $8e5ff112b9cd554a$export$af4ae38441ca831f = ()=>{
    const events = (0, $38311d640b87f30b$export$91a992459f6e0f07)();
    const { setMenu: setMenu } = (0, $38311d640b87f30b$export$38eaa17faae8f579)();
    const { install: install, setInstall: setInstall } = (0, $38311d640b87f30b$export$56bafadbb0c4d7e5)();
    const { showMap: showMap } = (0, $38311d640b87f30b$export$86f8f9f08863e403)();
    let opaque;
    if (install) opaque = "50%";
    if (!install) opaque = "100%";
    const clearWindows = ()=>{
        setMenu(false);
        setInstall(false);
    };
    const eventList = events.map((event)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("section", {
            style: {
                opacity: opaque
            },
            onClick: ()=>clearWindows(),
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7b7c44ec3449ff98$export$9397a48ce18c8f16), {
                ...event
            })
        }, event.uid));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "event-list",
        children: [
            install && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dba7186efc6bc3b9$export$2e2bcd8739ae039), {}),
            showMap ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5aa85a3563593430$export$2e2bcd8739ae039), {}) : eventList
        ]
    });
};



parcelRequire("bh6RR");

parcelRequire("bh6RR");

const $c5c9db79b46b2a01$export$3e41faf802a29e71 = ({ day: day })=>{
    const { activeTab: activeTab, handleTabClick: handleTabClick } = (0, $38311d640b87f30b$export$d2589202ac9c89c3)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: activeTab === day ? "footer-tab-active" : "footer-tabs",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
            onClick: ()=>handleTabClick(day),
            children: day
        })
    });
};


const $cd092b9f7f40f167$var$TABS = {
    THU: "#02597F",
    FRI: "#1FB2A3",
    SAT: "#FAAF40",
    SUN: "#D9533D"
};
const $cd092b9f7f40f167$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "footer-tab-wrapper",
        children: Object.keys($cd092b9f7f40f167$var$TABS).map((day, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c5c9db79b46b2a01$export$3e41faf802a29e71), {
                day: day
            }, index))
    });
};



function $02c71dbd5d88e811$var$EventMain() {
    const { showMap: showMap } = (0, $38311d640b87f30b$export$86f8f9f08863e403)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("main", {
        className: "app",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06f08e8e9c61cd60$export$d9b273488cd8ce6f), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8e5ff112b9cd554a$export$af4ae38441ca831f), {}),
            !showMap && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cd092b9f7f40f167$export$a06f1c675e846f6f), {})
        ]
    });
}
var $02c71dbd5d88e811$export$2e2bcd8739ae039 = $02c71dbd5d88e811$var$EventMain;



function $7ac7b9e457b0f6ca$var$App() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "app",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02c71dbd5d88e811$export$2e2bcd8739ae039), {})
    });
}
var $7ac7b9e457b0f6ca$export$2e2bcd8739ae039 = $7ac7b9e457b0f6ca$var$App;


const $1f0dc3b9307be026$var$options = {
    init: {
        privacy: {
            cookies_enabled: true
        },
        page_view_timing: {
            enabled: true
        },
        spa: {
            enabled: true
        },
        ajax: {
            enabled: true
        },
        distributed_tracing: {
            enabled: false
        }
    },
    info: {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: "NRJS-e61e46c846a887a7424",
        applicationID: "1134581579",
        sa: 1
    },
    loader_config: {
        accountID: "6708047",
        trustKey: "6708047",
        agentID: "1134581579",
        licenseKey: "NRJS-e61e46c846a887a7424",
        applicationID: "1134581579"
    }
};
new (0, $15f96e47c3fe7d31$export$4b720938abd886b1)($1f0dc3b9307be026$var$options);
console.log("index.js");
var $28a83dd17480586d$exports = {};
$28a83dd17480586d$exports = $parcel$resolve("8PNQt");



async function $1f0dc3b9307be026$var$enableMocking() {
    navigator.serviceWorker.register($28a83dd17480586d$exports);
    return;
    const { worker: worker } = await (parcelRequire("b3Xnn"));
    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    return worker.start({
        serviceWorker: {
            url: './mockServiceWorker.js'
        }
    });
}
const $1f0dc3b9307be026$var$container = document.getElementById("app");
const $1f0dc3b9307be026$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)($1f0dc3b9307be026$var$container);
$1f0dc3b9307be026$var$enableMocking().then(()=>{
    $1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $38311d640b87f30b$export$e5cc2dfc1df151ff), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7ac7b9e457b0f6ca$export$2e2bcd8739ae039), {})
    }));
});


//# sourceMappingURL=app.25d7f982.js.map
